<template>
    <div class="question" :class="[questionClasses, $mq, { 'subitem-action-plan': isActionPlanPage && item.isAuditItem && item.isSubitemActionPlan }]" :data-type="item.type" :id="item.item_id" :noApply="item.apply == 0 ? 1 : 0" v-show="item.apply != 0 || (item.apply == 0 && showNoApply)" @click.stop="onQuestionClick">
        <!-- SECTION BUTTON (para abrir y cerrar la sección)-->
        <div v-if="item.type == FORMAT.TITLE" class="section-button-container">
            <button class="section-button" :class="{ closed: !sectionIsOpen }"></button>
        </div>

        <div
            class="item"
            :class="[
                itemClasses,
                $mq,
                {
                    done: item.apply == 0 && !isActionPlanCompleted,
                    sync: item.requireSync == true,
                    showErrors: showErrors && !item.complete_date && item.mandatory,
                    disabled: isValueLocked
                },
                {
                    'flex-column': item.type == FORMAT.MULTIPLE && itemIsMultiselect && item.value
                }
            ]"
        >
            <div class="answer" :class="answerClasses">
                <div
                    class="line"
                    :class="{
                        'flex-row': !canShowValue && ![FORMAT.TITLE, FORMAT.SUBTITLE].includes(item.type) && ((list.status != 0 && list.status != 'progress' && item.value == null) || list.type == 1),
                        'flex-column': item.type == FORMAT.MULTIPLE && itemIsMultiselect && item.value
                    }"
                >
                    <div class="statement" :class="{ 'has-image': [FORMAT.PHOTO].includes(item.type) && value != null && Object.values(value) != 0 }">
                        <!-- SECTION INDICATOR (completed or not completed section) -->
                        <div v-if="item.type == FORMAT.TITLE" class="section-progress-indicator">
                            <div v-if="sectionItemsAreDone(item.item_id)" class="icon-container">
                                <i class="i-andy-menu-checklist i-andy-m"></i>
                            </div>
                            <div v-else class="icon-container">
                                <i class="i-andy-circle-exclamation i-andy-m"></i>
                            </div>
                        </div>

                        <!-- TITLE -->
                        <div class="multiSelect-title-container">
                            <div
                                class="answer-title keep-format"
                                :class="[
                                    {
                                        optional: !item.mandatory && def.has_mandatory && def.item.itemsTitle.indexOf(item.type) == -1
                                    },
                                    { 'title-no-description': !hasDescriptionOrEquipment }
                                ]"
                                v-html="itemTitle + ((item.mandatory && ![FORMAT.TITLE, FORMAT.SUBTITLE].includes(item.type)) || (![FORMAT.TITLE, FORMAT.SUBTITLE].includes(item.type) && item.mandatory) ? ' *' : '')"
                                :data-after="$t('answer.optional')"
                            ></div>
                            <!-- Require review (multiselect with value: check sits next to title in column layout) -->
                            <div v-if="showReviewCheckInTitle" class="review-check-container">
                                <button v-if="!completed && item.require_review && canBeEdited" class="review-check-disabled" @click="cantValidateAnswer" />
                                <button v-if="completed && !isReview && item.require_review" class="review-check-pending" @click="validateAnswer" />
                                <button v-if="completed && isReview && item.require_review" class="review-check-done" :class="[$mq]" @click="unvalidateAnswer" />
                            </div>
                            <div class="load-last-value" v-if="loadLastValue && $mq === 'desktop' && !isActionPlanItem" @click="loadLastValueForItem" :class="{ margin: item.type == 6 || item.type == 15 }">
                                <i class="i-andy-refresh i-andy-s"></i>
                                <span>{{ $t('answer.load_last_value') }}</span>
                            </div>
                        </div>

                        <!-- EQUIPMENT ID (custom) -->
                        <div v-if="itemEquipmentId" class="description keep-format equipment-id">
                            <p>{{ itemEquipmentId }}</p>
                        </div>

                        <!-- DESCRIPTION -->
                        <div v-if="itemDescription" class="description keep-format" :class="{ 'description-short': showSeeMore }" @click="toggleMeta(true)">
                            <p ref="description" v-html="descriptionParse(itemDescription)"></p>
                            <div v-if="descriptionIsExpandable">
                                <button v-if="showSeeMore" class="see-more">{{ $t('label.more') }}</button>
                                <button v-else class="see-less">{{ $t('label.less') }}</button>
                            </div>
                        </div>
                    </div>

                    <div class="meta" v-if="expanded && item.type == FORMAT.TITLE && canExpandSection(false)">
                        <div class="actions" v-if="showActions()">
                            <!-- BOTÓN "NO APLICA" -->
                            <button v-if="item.apply == 1" class="btn ico action noApply" @click.stop="handleApplicability(ACTION_TYPE.NOT_APPLY)">
                                {{ $t('answer.actions.no_apply') }}
                            </button>
                            <!-- BOTÓN "REALIZAR" (APLICA) -->
                            <button v-else-if="item.apply == 0" class="btn ico action apply" @click.stop="handleApplicability(ACTION_TYPE.APPLY)">
                                {{ $t('answer.actions.make_apply') }}
                            </button>
                        </div>
                    </div>

                    <template v-if="(item.mandatory || (!item.mandatory && item.apply != 0)) && item.type != 8">
                        <!-- RESPONSE / RESPUESTA -->
                        <div
                            class="response"
                            :class="{
                                'no-description': !hasDescriptionOrEquipment,
                                'empty-gallery': (!value || value.length < 1) && item.type == 5
                            }"
                        >
                            <template v-if="canShowValue">
                                <!-- CHECK -->
                                <template v-if="item.type == FORMAT.CHECK">
                                    <!-- Tipo check -->
                                    <span class="response value" :class="[value ? 'checked' : '', { disabled: isActionPlanCompleted }]" @click="checkAccess(!value)"></span>
                                </template>
                                <!-- YES/NO -->
                                <template v-if="item.type == FORMAT.YESNO">
                                    <div class="yes-no">
                                        <span class="value" :class="[value == 0 ? 'selected' : '', { disabled: isActionPlanCompleted }]" data-value="0" @click="checkAccess(0)"></span>
                                        <span class="value" :class="[value == 1 ? 'selected' : '', { disabled: isActionPlanCompleted }]" data-value="1" @click="checkAccess(1)"></span>
                                    </div>
                                </template>
                                <!-- YES/NO/NSNC -->
                                <template v-if="item.type == FORMAT.YESNONC">
                                    <span class="value" :class="[value == 0 ? 'selected' : '', { disabled: isActionPlanCompleted }]" data-value="0" @click="checkAccess(0)">{{ $t('answer.no') }}</span>
                                    <span class="value" :class="[value == 1 ? 'selected' : '', { disabled: isActionPlanCompleted }]" data-value="1" @click="checkAccess(1)">{{ $t('answer.yes') }}</span>
                                    <span class="value" :class="[value == 2 ? 'selected' : '', { disabled: isActionPlanCompleted }]" data-value="2" @click="checkAccess(2)">{{ $t('answer.nsnc') }}</span>
                                </template>
                                <!-- TEXT -->
                                <template v-if="item.type == FORMAT.TEXT" @click="checkAccess()">
                                    <input
                                        type="text"
                                        dir="ltr"
                                        class="value input-text-ltr"
                                        :value="displayedValue"
                                        enterkeyhint="next"
                                        @input="onOpenTextInput"
                                        @keydown.enter.prevent="onTextValueEnter"
                                        @click="onOpenTextActivate"
                                        @focus="onOpenTextFocus"
                                        @blur="onOpenTextBlur"
                                        :readonly="useLandscapeTextPopup"
                                        :class="{ disabled: !hasValidRole() || isActionPlanCompleted || (!this.isCreator && this.cType == 2) }"
                                        :disabled="isValueLocked"
                                        maxlength="140"
                                        autocomplete="off"
                                    />
                                </template>
                                <!-- PHOTO -->
                                <template v-if="item.type == FORMAT.PHOTO && (!aConfig || aConfig.limit <= 1)" @click="checkAccess()">
                                    <div class="actions-image" v-if="value == null || typeof value[0] == 'undefined'" :class="[value !== null && typeof value[0] !== 'undefined' && !isDisabled ? 'editing' : '']">
                                        <!-- ADD FILE BUTTON -->
                                        <div class="add-file" v-if="canShowSinglePhotoUpload" @click="capture($event, 'answer')">
                                            <input type="file" name="upload-image" class="input-file" :class="{ disabled: !hasValidRole() || (!this.isCreator && this.cType == 2) }" accept="image/*" capture="camera" @change="qImageReload" multiple />
                                        </div>
                                    </div>
                                    <div class="preview-image" :class="{ 'has-image': value != null && Object.values(value).length != 0 }" @click="qImagePreview(0)" :style="[isDisabled ? { position: 'relative', zIndex: 5 } : {}]">
                                        <template v-if="value != null && value[0] != undefined">
                                            <img v-if="isOnline || isBase64(value[0])" :src="value[0]" />
                                            <div class="image-offline" v-else></div>
                                        </template>
                                        <template v-else>
                                            <img src="" />
                                        </template>
                                    </div>
                                </template>
                                <!-- PHOTO GALLERY / GALERIA -->
                                <template v-if="item.type == FORMAT.PHOTO && aConfig.limit > 1">
                                    <!-- ADD FILE BUTTON -->
                                    <!-- don't show button if is an audit item in an Action Plan checklist -->
                                    <div class="add-image" v-if="canAddPhotoInThisContext">
                                        <div class="actions-image">
                                            <div v-if="this.cType != 2 || (this.cType == 2 && isCreator)" class="add-file" @click="capture($event, 'answer')">
                                                <input
                                                    type="file"
                                                    name="upload-image"
                                                    class="input-file"
                                                    :class="{
                                                        disabled: !hasValidRole() || isActionPlanCompleted,
                                                        empty: !value || value.length == 0
                                                    }"
                                                    :disabled="isValueLocked"
                                                    accept="image/*"
                                                    capture="camera"
                                                    @change="qImageReload"
                                                    multiple
                                                />
                                            </div>
                                        </div>
                                        <div class="preview-image has-image" :style="[isDisabled ? { position: 'relative', zIndex: 5 } : {}]"></div>
                                    </div>
                                    <div class="galery-list" v-if="value && value.length > 0">
                                        <div class="galery-item" v-for="(item, index) in value">
                                            <template v-if="isOnline || isBase64(value[index])">
                                                <!-- <div class="actions-image editing">
                                                    <a class="btn delete ico" @click="qImageDelete(index)"></a>
                                                </div> -->
                                                <div class="preview-image has-image" @click="qImagePreview(index, true)" :style="{ position: 'relative', zIndex: 5 }">
                                                    <!-- offline -->
                                                    <template v-if="isBase64(value[index])">
                                                        <img :src="value[index]" />
                                                    </template>
                                                    <!-- connection -->
                                                    <template v-else>
                                                        <!-- <cld-image class="galery-img" v-if="value[index]" :publicId="value[index]" type="fetch" loading="lazy">
                                                            <cld-transformation height="100" crop="fill" fetchFormat="webp" />
                                                        </cld-image> -->
                                                        <img :src="value[index]" />
                                                    </template>
                                                </div>
                                            </template>
                                            <div v-else class="preview-image" :class="{ 'has-image': value != null && Object.values(value) != 0 }" @click="qImagePreview(0)" :style="[isDisabled ? { position: 'relative', zIndex: 5 } : {}]">
                                                <!-- <img :srcset="getOfflineImg()"> -->
                                                <div class="image-offline"></div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- NUMBER / NUMÉRICO -->
                                <template v-if="item.type == FORMAT.NUMBER">
                                    <div class="value" @click="checkAccess()" :class="[{ showTap: !value && value != '-' }, { 'no-value': value == '-' }, { bluetooth: item.readingFromSensor && value != null }, { disabled: isActionPlanCompleted }]">
                                        {{ value ? (value != '-' ? value : $t('answer.no_value')) : '' }}
                                        <span v-if="item.readingFromSensor && value != null" class="task-icon-bluetooth"><i class="i-andy-bluetooth i-andy-xs"></i></span>
                                    </div>
                                </template>
                                <!-- DATE / FECHA -->
                                <template v-if="item.type == FORMAT.DATE" @click="checkAccess()">
                                    <div class="checkaccess" @click="checkAccess()">
                                        <!-- Tipo fecha -->
                                        <localized-date-picker
                                            class="value"
                                            :class="{
                                                disabled: !canEditDateValue
                                            }"
                                            :disabled="!canEditDateValue"
                                            :value="value"
                                            @change="onDateOrDatetimeNativeChange"
                                        />
                                    </div>
                                </template>
                                <!-- TEXTAREA -->
                                <template v-if="item.type == FORMAT.TEXTAREA" @click="checkAccess()">
                                    <div class="checkaccess" @click="checkAccess()">
                                        <textarea
                                            class="value"
                                            :value="displayedValue"
                                            @input="onOpenTextInput"
                                            @click="onOpenTextActivate"
                                            @focus="onOpenTextFocus"
                                            @blur="onOpenTextBlur"
                                            :readonly="useLandscapeTextPopup"
                                            :class="[{ disabled: !hasValidRole() || isActionPlanCompleted || (this.cType == 2 && !this.isCreator) }]"
                                            :disabled="isValueLocked"
                                            maxlength="512"
                                        ></textarea>
                                    </div>
                                </template>

                                <!-- MULTIPLE / SELECTOR -->
                                <template v-if="item.type == FORMAT.MULTIPLE">
                                    <!-- SELECTOR MÚLTIPLE (MULTISELECT / MULTISELECTOR)-->
                                    <div v-if="itemIsMultiselect" :class="{ multiSelector: itemIsMultiselect }">
                                        <MultiSelectorInputAndPopup ref="multiSelector" :options="item.config.values" :itemHasActionPlan="itemHasActionPlan" :isActionPlanPage="isActionPlanPage" @openMultiselectPopup="checkAccess" :value="value" @input="qMultiple" @reset="qMultiple" :canClicked="canClicked()" @popup-status="updateSelectorPopupStatus" />
                                    </div>
                                    <div v-else :class="{ simpleSelector: !item.config.multiselect }">
                                        <!-- SELECTOR SIMPLE -->
                                        <Selector ref="simpleSelector" :class="{ simpleSelector: !item.config.multiselect }" :options="item.config.values" @openSelect="checkAccess" :value="value" @input="qMultiple" @reset="qMultiple" :canClicked="canClicked()" :itemHasActionPlan="itemHasActionPlan" :isActionPlanPage="isActionPlanPage" @popup-status="updateSelectorPopupStatus" />
                                    </div>
                                </template>

                                <!-- HOUR / HORA -->
                                <template v-if="item.type == FORMAT.TIME" @click="checkAccess()">
                                    <div class="checkaccess" @click="checkAccess()">
                                        <input type="time" class="value" :class="{ disabled: isActionPlanCompleted }" :disabled="isValueLocked" :key="timeInputKey" :value="value || ''" @change="onDateOrDatetimeNativeChange" />
                                    </div>
                                </template>
                                <!-- FECHA Y HORA -->
                                <template v-if="item.type == FORMAT.DATETIME" @click="checkAccess()">
                                    <div class="checkaccess" @click="checkAccess()">
                                        <!-- Tipo fecha y hora -->
                                        <localized-date-picker
                                            mode="datetime"
                                            class="value"
                                            :class="{
                                                disabled: !canEditDateValue
                                            }"
                                            :disabled="!canEditDateValue"
                                            :value="value"
                                            @change="onDateOrDatetimeNativeChange"
                                        />
                                    </div>
                                </template>
                                <!-- SIGNATURE / FIRMA -->
                                <template v-if="item.type == FORMAT.SIGNATURE">
                                    <div class="sign-block">
                                        <div class="signed" v-show="value" @click="qSignaturePreview()">
                                            <div class="ico" :style="{ backgroundImage: 'url(' + value + ')' }"></div>
                                            <div class="text" v-if="item.config.require_emp">
                                                {{ completeEmployee().name }}
                                            </div>
                                        </div>
                                        <div class="value unsigned" :class="{ disabled: isActionPlanCompleted }" @click="checkAccess()"></div>
                                    </div>
                                </template>
                                <!-- TEMPERATURE / TEMPERATURA -->
                                <template v-if="item.type == FORMAT.TEMPERATURE">
                                    <!-- Tipo temperature -->
                                    <div class="value" @click="checkAccess()" :class="[{ showTap: !value && value != '-' }, { 'no-value': value == '-' }, { bluetooth: item.readingFromSensor && value != null }, { disabled: isActionPlanCompleted }]">
                                        {{ value ? (value != '-' ? value + ' ' + item.config.units : $t('answer.no_value')) : '' }}
                                        <span v-if="item.readingFromSensor && value != null" class="task-icon-bluetooth"><i class="i-andy-bluetooth i-andy-xs"></i></span>
                                    </div>
                                </template>
                                <!-- EMAIL -->
                                <template v-if="item.type == FORMAT.EMAIL">
                                    <button v-if="isEmailSent" class="value sended">
                                        {{ $t('answer.sended_mail') }}
                                    </button>
                                    <button v-else class="value" :class="{ disabled: isActionPlanCompleted }" :disabled="isValueLocked" @click="checkAccess()">
                                        {{ $t('answer.send_mail') }}
                                    </button>
                                </template>
                                <!-- DOCUMENT / DOCUMENTO -->
                                <template v-if="item.type == FORMAT.DOCUMENT">
                                    <div class="value-content keep-format" v-html="item.config.message"></div>
                                    <div class="conditions" v-if="item.config.statement || item.config.check">
                                        <span v-if="item.config.statement" class="text-check" v-html="item.config.statement"></span>
                                        <span v-if="item.config.check" class="value" :class="[value ? 'checked' : '', { disabled: isActionPlanCompleted }]" @click="qDocument(!value)"></span>
                                    </div>
                                </template>
                                <!-- MESSAGE / MENSAJE -->
                                <template v-if="item.type == FORMAT.MESSAGE">
                                    <div class="value-content keep-format" v-html="item.config.message"></div>
                                </template>
                                <!-- LINK -->
                                <template v-if="item.type == FORMAT.LINK">
                                    <span class="value" @click="checkAccess()"></span>
                                </template>
                                <!-- RESOURCE / RECURSO -->
                                <template v-if="item.type == FORMAT.RESOURCE">
                                    <div class="checkaccess" @click="checkAccess()">
                                        <!-- Tipo recurso de libreria -->
                                        <span class="value" @click="qResource()" :class="[{ disabled: !hasValidRole() || isActionPlanCompleted }]"></span>
                                    </div>
                                </template>
                            </template>
                            <!-- REQUIRE REVIEW (all non-title layouts, including simple selector) -->
                            <div v-if="showReviewCheckInResponse" class="review-check-container">
                                <button v-if="!completed && item.require_review && canBeEdited" class="review-check-disabled" @click="cantValidateAnswer" />
                                <button v-if="completed && !isReview && item.require_review" class="review-check-pending" @click="validateAnswer" />
                                <button v-if="completed && isReview && item.require_review" class="review-check-done" :class="[$mq]" @click="unvalidateAnswer" />
                                <div v-if="!canShowValue && !isActionPlanItem && ![FORMAT.TITLE, FORMAT.SUBTITLE, FORMAT.RESOURCE, FORMAT.LINK].includes(item.type) && ((list.status != 0 && list.status != 'progress' && item.value == null) || list.type == 1)" class="unknown">
                                    {{ $t('answer.unknown') }}
                                </div>
                            </div>

                            <!-- POSTPONED / POSPUESTO-->
                            <template v-else-if="item.planned_to_date">
                                <div class="postposed" @click="postpone">{{ $t('answer.postpone.postposed') }}</div>
                            </template>
                            <!-- DOCUMENT / DOCUMENTO -  UNANSWERED / SIN RESPUESTA -->
                            <template v-else-if="![FORMAT.TITLE, FORMAT.SUBTITLE].includes(item.type) && !isActionPlanItem && ((list.status != 0 && list.status != 'progress' && item.value == null) || list.type == 1)">
                                <!-- DOCUMENT -->
                                <template v-if="item.type == FORMAT.DOCUMENT">
                                    <div class="value-content keep-format" v-html="item.config.message"></div>
                                    <div class="conditions" v-if="item.config.statement || item.config.check">
                                        <div class="unknown">{{ $t('answer.unknown') }}</div>
                                    </div>
                                </template>
                                <!-- SIN RESPUESTA -->
                                <template v-else>
                                    <div v-if="![FORMAT.RESOURCE, FORMAT.LINK, FORMAT.EMAIL].includes(item.type) && !itemIsMultiselect" class="unknown">
                                        {{ $t('answer.unknown') }}
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                    <!-- NO APLICA -->
                    <template v-else-if="!item.mandatory && item.apply == 0">
                        <div class="response">
                            <div class="responseNoApply">
                                <div class="text" @click="toggleMeta(false)"></div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <!-- SEE MORE BUTTON -->
            <button v-if="item.type != FORMAT.TITLE || (canExpandSection(false) && showActions())" class="btn ico action toggleMeta" :class="[expanded ? 'open' : '', item.type == FORMAT.TITLE ? 'section-see-more' : '']" @click.stop="toggleMeta(def.item.itemsInfo.includes(item.type))" :style="[canPostpone ? { top: '26px' } : { top: '8px !important' }]"></button>
            <div class="load-last-value" v-if="loadLastValue && $mq === 'portrait'" @click="loadLastValueForItem" :class="{ margin: item.type == 6 || item.type == 15 }">
                <i class="i-andy-refresh i-andy-s"></i>
                <span>{{ $t('answer.load_last_value') }}</span>
            </div>

            <!-- ITEM DETAILS (EMPLEADO Y FECHA) -->
            <div class="meta" v-if="expanded && def.item.itemsTitle.indexOf(item.type) == -1">
                <div v-if="enabledMeta" class="info">
                    <div v-if="item.requireSync" class="offline-message-box">
                        <span class="offline-message"><span class="task-icon-sync"></span>{{ $t('answer.pending_to_sync') }}</span>
                    </div>
                    <div class="sign" v-if="!itemsExcluded && !item.planned_to_date">
                        <!-- <span v-if="completeEmployee() && item.value != null" class="name"
                            ><span class="task-icon-done"></span>{{ $t('answer.performed_by') }}<span class="bold"> {{ completeEmployee().name + ' ' + completeEmployee().surname }}</span></span
                        > -->
                        <span v-if="completeEmployee()" class="name">
                            <span class="task-icon-done"></span>
                            {{ $t('answer.performed_by') }}
                            <span class="bold">
                                {{ completeEmployee().name + ' ' + completeEmployee().surname }}
                            </span>
                        </span>
                        <span v-else-if="!completeEmployee() && item.apply != 0 && item.value == null" class="name">
                            <span class="task-icon-notdone"></span>
                            {{ $t('answer.not_done') }}
                        </span>
                        <!-- <span v-if="!completeEmployee() && item.apply == 0" class="name">{{ $t('answer.meta_na') }}</span> -->
                    </div>
                    <!-- <div class="sign" v-if="!itemsExcluded && !item.planned_to_date && completeEmployee() && completeDate && item.apply != 0">
                        <span class="datetime" v-if="completeEmployee() && completeDate"><span class="task-icon-date"></span>{{ completeDate }}</span>
                    </div> -->
                    <div class="sign" v-if="!itemsExcluded && !item.planned_to_date && completeEmployee() && completeDate">
                        <span class="datetime" v-if="completeEmployee() && completeDate">
                            <span class="task-icon-date"></span>
                            <span class="datetime">{{ completeDate }}</span>
                        </span>
                    </div>
                    <div class="sign" v-if="resetItemInfo && (value === null || (Array.isArray(value) && value.length === 0))">
                        <span class="task-icon-delete"><i class="i-andy-delete i-andy-s"></i></span>
                        <span class="name">
                            {{ $t('answer.reset_by') }}
                            <template v-if="resetItemInfo.employee">{{ resetItemInfo.employee.name + ' ' + resetItemInfo.employee.surname }},</template>
                            {{ resetItemInfo.date }}
                        </span>
                    </div>
                    <div class="sign" v-if="item.readingFromSensor && value != null">
                        <span class="task-icon-bluetooth"><i class="i-andy-bluetooth i-andy-s"></i></span>
                        <span class="name">
                            {{ $t('answer.read_from_sensor') }}
                        </span>
                    </div>
                    <div class="review" v-if="item.require_review && !itemsExcluded && !item.planned_to_date && item.apply != 0">
                        <span v-if="isReview" class="name"><span class="task-icon-reviewed"></span> {{ $t('answer.reviewed_by') }}</span>
                        <span v-else class="name"><span class="task-icon-toreview"></span>{{ $t('answer.not_reviewed') }}</span>
                        <span class="bold" v-if="isReview">{{ isReview.employee.name + ' ' + isReview.employee.surname }}</span>
                    </div>
                    <div class="review" v-if="item.require_review && !itemsExcluded && !item.planned_to_date && isReview">
                        <span class="datetime" v-if="isReview"><span class="task-icon-date"></span>{{ reviewDate }}</span>
                    </div>

                    <div class="timing" v-if="list.def.item.has_periodicity && !itemsExcluded && (item.planned_to_date || item.planned_from_date)">
                        <!-- If it can be posposed or not -->
                        <div class="line">
                            <!-- Yes -->
                            <template v-if="canPostpone">
                                <span class="name"> <span class="task-icon-postpone"></span>{{ $tc('answer.postpone.before_label', item.available > 1 ? 2 : 1) }} </span>
                                <span class="bold">
                                    {{
                                        $tc('answer.postpone.before_date', item.available == 1 ? 1 : 2, {
                                            s: item.available
                                        })
                                    }}
                                </span>
                            </template>

                            <!-- No -->
                            <!-- <template v-else-if="!item.planned_to_date">
                                <span class="name">{{ $t('answer.postpone.cannot') }}</span>
                            </template> -->
                        </div>

                        <!-- If planned -->
                        <div class="line">
                            <!-- Posposed task to another day (this appears like "posposed" and cannot be done) -->
                            <template v-if="item.planned_to_date">
                                <span class="date-info">
                                    <span class="task-icon-postpone_done"></span>
                                    {{ this.completeEmployee() ? $t('answer.postpone.planned_to', getFormattedPostponedDate(item.planned_to_date, true)) : $t('answer.postpone.planned_to_noname', getFormattedPostponedDate(item.planned_to_date, false)) }}
                                </span>
                            </template>

                            <!-- Posposed task from another day (This one has to be done) -->
                            <template v-else-if="item.planned_from_date">
                                <span v-if="item.planned_from_date" class="date-info">
                                    {{ this.completeEmployee() ? $t('answer.postpone.planned_from', getFormattedPostponedDate(item.planned_from_date, true)) : $t('answer.postpone.planned_from_noname', getFormattedPostponedDate(item.planned_from_date, false)) }}
                                </span>
                            </template>
                        </div>
                        <!-- Reasons -->
                        <div class="line" v-if="item.planned_to_date || item.planned_from_date">
                            <span class="bold">
                                <span class="task-icon-reason"></span>
                                {{ $t('answer.postpone.reason') }}:
                            </span>
                            <span class="reason">
                                <template v-if="item.planned_reason_msg">{{ item.planned_reason_msg }}</template>
                                <template v-else-if="item.planned_reason_id">{{ getReasonName }}</template>
                            </span>
                        </div>
                    </div>
                    <div class="role" v-if="item.config.roles && typeof item.config.roles !== 'undefined' && item.config.roles.length > 0 && item.config.roles.some((x) => Object.keys(roles).includes(x))">
                        <div class="line">
                            <span class="name">
                                {{ $t('answer.limited_for') }}
                            </span>
                            <template v-for="(role, index) in item.config.roles">
                                <span class="roles" v-if="role && roles && roles[role]" :key="index">
                                    {{ role && roles[role] ? roles[role].name : '' }}
                                </span>
                            </template>
                        </div>
                    </div>
                    <!-- <div v-if="item.requireSync" class="sync">{{ $t('answer.sync') }}</div> -->
                    <div
                        v-if="showPeriodicityTag && !item.planned_to_date && !item.planned_from_date"
                        class="task-label"
                        :class="{
                            daily: item.periodicity == 1,
                            weekly: item.periodicity == 2,
                            biweekly: item.periodicity == 3,
                            monthly: item.periodicity == 4,
                            quarterly: item.periodicity == 5,
                            biannually: item.periodicity == 6,
                            annually: item.periodicity == 7
                        }"
                    >
                        <span>{{ periodicityTranslation }}</span>
                    </div>
                </div>

                <!-- Acciones + QR en la misma fila (QR visible con identifier aunque no haya Nota/Realizar) -->
                <div v-if="itemQrValue || showActions()" class="actions actions--with-qr">
                    <button v-if="itemQrValue" type="button" class="btn ico action qr-icon-btn" :title="$t('config.templates.items.edit_form.identifier')" aria-label="QR" @click="openQrModal">
                        <span class="qr-icon-btn__icon" aria-hidden="true">
                            <i class="i-andy-qr-code i-andy-m"></i>
                        </span>
                        <span class="qr-icon-btn__label">QR</span>
                    </button>
                    <div v-if="showActions()" class="actions__secondary" :class="{ hidden: isActionPlanPage && item.isAuditItem }">
                        <!-- <button v-if="cType != 3 && !isFuture" class="btn ico action share" @click="shareAnswer" >{{ $t('checklist.share.action') }}</button> -->
                        <button v-if="item.resource && ![FORMAT.RESOURCE].includes(item.type)" class="btn ico action hasFile" @click="qResource(true)">
                            {{ $t('library.resource') }}
                        </button>

                        <!-- NOTE BUTTON / BOTÓN NOTA -->
                        <button class="btn ico action comment" :class="[commenting ? 'editing' : '', item.message || item.image ? 'has' : '']" @click="inputComment">
                            {{ $t('answer.actions.note') }}
                        </button>
                        <button class="btn ico action postpone" v-if="list.def.item.has_periodicity && !itemsExcluded && canPostpone" :class="{ cannot: !canPostpone }" @click="postpone">
                            {{ $t('answer.actions.postpone') }}
                        </button>

                        <!-- BOTÓN "NO APLICA" -->
                        <button class="btn ico action noApply" v-if="!item.mandatory && item.apply != 0 && !item.value" @click.stop="handleApplicability(ACTION_TYPE.NOT_APPLY)">
                            {{ $t('answer.actions.no_apply') }}
                        </button>

                        <!-- BOTÓN "REALIZAR" (APLICA) -->
                        <button class="btn ico action apply" v-if="!item.mandatory && item.apply == 0 && !item.value" @click.stop="handleApplicability(ACTION_TYPE.APPLY)">
                            {{ $t('answer.actions.make_apply') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isActionPlanCompleted && !(!item.message && !item.image && !commenting)" class="has-comment" :class="[{ hide: !item.message && !item.image && !commenting }, { editing: commenting }]">
            <!-- NOTE -->
            <div class="has-note">
                <span v-if="!commenting" class="editIcon"></span>
                <textarea
                    :value="displayedComment"
                    class="note input-text-ltr"
                    :maxlength="460"
                    dir="ltr"
                    @input="onCommentInput"
                    :disabled="!commenting"
                    :readonly="useLandscapeTextPopupForComment"
                    ref="refInputComment"
                    @click="onCommentActivate"
                    @focus="onCommentFocus"
                    @blur="onCommentBlur"
                />
            </div>

            <!-- IMAGE OF NOTE -->
            <div class="has-image" :class="[{ editing: image }]">
                <div class="preview" v-if="commenting || image" @click="imagePreview">
                    <img class="image" :src="isOnline || isBase64(image) ? image : getOfflineImg()" />
                </div>

                <div class="add-file" ref="changeimage" @click="capture($event, 'comment')">
                    <input type="file" name="change-image" class="input-file" :class="{ disabled: !hasValidRole() || isActionPlanCompleted }" accept="image/*" capture="camera" :disabled="!commenting || isActionPlanCompleted" @change="imageReload" />
                </div>
            </div>
        </div>

        <!-- ALERTS and INCIDENT REFERENCE -->
        <template v-if="!isActionPlanPage">
            <div v-if="list.type == TYPE.AUDIT && item.reference && item.reference.type == TYPE.ACTION_PLAN" class="action-plan-link-container" @click.stop>
                <div class="action-plan-generated-message" :class="{ 'is-closed': isActionPlanClosed }">
                    <i class="i-andy-circle-exclamation i-andy-m"></i>
                    <span class="message-text">{{ actionPlanMessage }}</span>
                    <button type="button" class="ver-link" @click="goToActionPlan(item, $event)">
                        {{ getString('answer.view') }}
                    </button>
                </div>
            </div>
            <!-- NO mostrar link en items con Plan de Acción -->
            <div class="reference-link" v-if="item.reference && item.alerts && !isANonConformity && hasIssuesTool" :class="[{ 'has-issue': hasLinkedTemplateIds }, item.alerts.class]">
                <div class="message keep-format" @click="goToReference">
                    <div class="i-andy-task-warning i-andy-s"></div>
                    <div class="preview" v-html="getStringVariable('answer.reference.issue', getStringIssueState(item.reference.status))"></div>
                    <div class="read-more">
                        {{ getString('answer.reference.issue_action') }}
                        <div class="i-andy-right-arrow i-andy-s"></div>
                    </div>
                </div>
            </div>

            <!-- ALERT MESSAGE-->
            <div class="item-alert" v-if="item.alerts && item.alerts_triggers && item.alerts_triggers[0] && item.alerts_triggers[0].type !== 'email'" :class="[$mq, { 'has-issue': hasLinkedTemplateIds }, item.alerts.class]">
                <div class="message keep-format">
                    <AlertMessage :type="item.alerts.class" :preview="item.alerts.message ? item.alerts.preview : ''" :is-incidence="hasLinkedTemplateIds && !isANonConformity && hasIssuesTool" :incidence-label="$t('answer.reference.incident')">
                        <template #read-more>
                            <div class="read-more" @click="showAlertOrIncidentPopup">{{ getString('answer.actions.read_more') }}</div>
                        </template>
                    </AlertMessage>
                </div>
            </div>

            <div class="item-alert" v-if="item.alerts && item.alerts_triggers && item.alerts_triggers[0] && item.alerts_triggers[0].type === 'email'" :class="[$mq, { 'has-issue': hasLinkedTemplateIds }, item.alerts.class]">
                <div class="message keep-format email">
                    <AlertMessage :type="item.alerts.class" :preview="getAlertEmail(item.alerts_triggers[0])" :is-incidence="hasLinkedTemplateIds && !isANonConformity && hasIssuesTool" :incidence-label="$t('answer.reference.incident')" />
                </div>
            </div>
        </template>

        <!-- mensaje que sugiere al usuario dejar una nota -->
        <Message v-if="showApplyMessage || showUnderItemMessage" :message="$t('answer.apply.message')" :type="'alert'" customClass="custom-alert-task" :hasActions="false" />
    </div>
</template>

<script>
import { FORMAT, TYPE, ACTION_TYPE, TOOLS } from '@/constants'
import Message from '@/components/domain/ui/Message'
import Selector from '../../inputs/SelectorPopup.vue'
import MultiSelectorInputAndPopup from '../../inputs/MultiSelectorPopup.vue'
import i18n from '@/i18n'
import AlertMessage from '@/components/domain/ui/AlertMessage.vue'
import QRCode from 'qrcode'
import { getFirstCustomRecord } from '@/utils/templateCustom'
import { displayPreventDeletePopup } from '@/utils/popups'
import { shouldUseLandscapeTextPopup as shouldUseLandscapeTextPopupUtil, subscribeScreenLayoutChange, isScreenRotationInProgress } from '@/utils/screen'
import { formatDisplayDateFromStore, formatDisplayTimeFromStore, formatDisplayDateTimeFromStore } from '@/utils/dateFormatters'
import { getLocationMoment } from '@/utils/locationTime'
import { ALERT_ACTION_TYPE, resolveItemAlertAction, readCreatedIncidentId } from '@/utils/showAlertOrIncidentPopup'

export default {
    name: 'answer',
    components: {
        Message,
        Selector,
        MultiSelectorInputAndPopup,
        AlertMessage
    },
    props: {
        // cType = checklist type (tool)
        cType: { type: Number, default: 1 },
        cId: { type: String },
        aId: { type: String },
        item: { type: Object },
        list: { type: Object },
        isIssueClosed: { type: Boolean, default: false },
        isRegisterClosed: { type: Boolean, default: false },
        hasDependency_tpl: { type: [Boolean, Object], default: false },
        showErrors: {
            type: Boolean
        },
        isActionPlanPage: { type: Boolean, default: false },
        doneSectionsIds: { type: Array, default: () => [] },
        showUnderItemMessage: { type: Boolean, default: false },
        timeRefreshKey: { type: Number, default: 0 },
        isActionPlanCompleted: { type: Boolean, default: false },
        isDeadlineEnded: { type: Boolean, default: false }, // for Action Plan items
        // null = el padre no decide los permisos y se aplica la lógica de roles del propio item
        permissions: {
            type: Boolean,
            default: null,
            validator: function (value) {
                return value === null || value === true || value === false
            }
        }
    },
    data() {
        return {
            showingClock: false,
            expanded: false,
            hasAccess: true,
            userAccess: false,
            selected: null,
            error: false,
            warning: false,
            linkedIssue: false,
            commenting: false,
            loading: false,
            FORMAT: FORMAT,
            TYPE: TYPE,
            ACTION_TYPE: ACTION_TYPE,
            valueExpanded: true,
            showApplyMessage: false,
            requireSync: false,
            isOnline: true,
            showSeeMore: true,
            descriptionIsExpandable: false,
            imageAPP: css_image_url,
            isSelectorPopupOpen: false,
            oldNumericValue: 0,
            sectionIsOpen: true,
            bReadingFromSensor: false,
            typingTimer: null,
            dispatchQueue: null,
            landscapeTextPopupOpen: false,
            landscapeTextPopupIsComment: false,
            landscapeTextPopupInputVal: '',
            landscapeSuppressReopen: false,
            landscapeDismissWithoutRefocus: false,
            landscapeSourceEl: null,
            screenLayoutVersion: 0,
            unsubscribeScreenLayout: null,
            valueDraft: null,
            commentDraft: null,
            valueDraftCommitted: null,
            commentDraftCommitted: null,
            valueSavePending: false,
            commentSavePending: false,
            navigatingViaEnter: false,
            inlineTextSourceEl: null,
            inlineTextBackButtonHandler: null,
            inlineTextViewportHandler: null,
            inlineTextWindowResizeHandler: null,
            inlineTextFullHeight: 0,
            inlineTextKeyboardWasOpen: false,
            isResettingTextAnswer: false
        }
    },
    computed: {
        auditIsLoading() {
            return this.$store.getters['audit/getIsLoading']
        },
        useLandscapeTextPopup() {
            void this.screenLayoutVersion

            return this.shouldUseLandscapeTextPopup()
        },
        useLandscapeTextPopupForComment() {
            void this.screenLayoutVersion

            return this.shouldUseLandscapeTextPopup(true)
        },
        isCreator() {
            return true
            if (this.cType === 2) {
                const creator = this.$store.getters['audit/getById'](this.cId)

                return creator.employee_ref.id === this.loggedUser
            } else {
                return true
            }
        },
        isAuditItemInActionPlanChecklist() {
            return this.isActionPlanPage && (Number(this.cType) === TYPE.AUDIT || Boolean(this.item && this.item.isAuditItem))
        },
        canAddPhotoInThisContext() {
            return !this.isAuditItemInActionPlanChecklist
        },
        isNotAnAuditItemInActionPlanChecklist() {
            return !this.isAuditItemInActionPlanChecklist
        },
        // el valor no admite cambios: plan de acción finalizado o item de auditoría mostrado como contexto
        isValueLocked() {
            return this.isActionPlanCompleted || this.isAuditItemInActionPlanChecklist || this.isDeadlineEnded
        },
        canEditDateValue() {
            if (this.isValueLocked || this.isDisabled || this.hasDependency_tpl) {
                return false
            }

            if (!this.hasValidPermissions() || !this.hasValidRole()) {
                return false
            }

            if (this.cType == 2 && !this.isCreator) {
                return false
            }

            if (this.isANonConformity && this.isActionPlanPage) {
                return false
            }

            return true
        },
        isAuditOriginatedItemInActionPlan() {
            if (!this.isActionPlanPage) {
                return false
            }

            return Boolean(this.item && this.item.isAuditItem) || this.cType === 2
        },
        isNcSubsubitemInActionPlan() {
            return this.isAuditOriginatedItemInActionPlan && Boolean(this.item && this.item.is_subsubitem)
        },
        canShowSinglePhotoUpload() {
            const hasNoPhoto = this.value == null || this.value.length == 0
            if (!hasNoPhoto) {
                return false
            }

            if (!this.canAddPhotoInThisContext) {
                return false
            }

            if (this.cType == 2 && !this.isCreator) {
                return false
            }

            if (this.isNcSubsubitemInActionPlan) {
                return false
            }

            return true
        },
        isUserRoleLevelHigherThanOne() {
            if (!this.user || !this.user.rol || !this.roles) {
                return false
            }

            const userRole = this.roles[this.user.rol]

            if (!userRole || typeof userRole.level == 'undefined') {
                return false
            }

            return parseInt(userRole.level) >= 2
        },
        showPeriodicityTag() {
            return this.list.type == TYPE.TASK
        },
        showNoApply() {
            return this.$store.getters['checklist/getShowNoApply']
        },
        periodicityTranslation() {
            return this.$t(this.getPeriodicityTranslationKey())
        },
        typename() {
            // los items de un plan de acción se gestionan en el módulo 'actionplan' del store,
            // y su lista no tiene un list.type propio con el que resolverlo
            if (this.isActionPlanItem) {
                return 'actionplan'
            }

            switch (parseInt(this.list.type)) {
                case 1:
                    return 'tasks'
                case 2:
                    return 'audit'
                case 3:
                    return 'register'
                case 4:
                    return 'issues'
                default:
                    return 'checklist'
            }
        },
        def() {
            return this.list.def
        },
        hasError: {
            get() {
                return this.error
            },
            set(value) {
                this.error = value
            }
        },
        hasAlert: {
            get() {
                return this.warning
            },
            set(value) {
                this.warning = value
            }
        },
        // alerts.issues can include Incident or Action Plan template ids.
        hasLinkedTemplateIds() {
            return this.item.alerts ? !!(this.item.alerts.issues && this.item.alerts.issues.length) : false
        },
        hasIssuesTool() {
            const tools = (this.$store.getters['login/getConfig'] && this.$store.getters['login/getConfig'].tools) || []
            return tools.map(Number).includes(TOOLS.ISSUES)
        },
        autosave() {
            return this.def.is_autosave
        },
        completeDate() {
            return this.item.complete_date ? formatDisplayDateFromStore(this.item.complete_date, { includeTime: true, emptyValue: '' }) : false
        },
        reviewDate() {
            return this.item.review && this.item.review.complete_date ? formatDisplayDateFromStore(this.item.review.complete_date, { includeTime: true, emptyValue: '' }) : false
        },
        // employee id
        loggedUser() {
            return this.userAccess ? this.userAccess : this.$store.getters['loginUser/getLocalEmployee']
        },
        // Si tiene tiempo limitado, tendrá distintas "fases"
        isIntime() {
            if (this.def.has_timing) {
                if (!this.itemsExcluded) {
                    return this.timingState == 'intime'
                }
            } else {
                return true
            }
        },
        isPast() {
            if (this.def.has_timing) {
                if (!this.itemsExcluded) {
                    return this.timingState == 'past'
                }
            } else {
                return false
            }
        },
        isFuture() {
            if (this.def.has_timing) {
                if (!this.itemsExcluded) {
                    return this.timingState == 'future'
                }
            } else {
                return false
            }
        },
        // Styles and template facilities
        customRecord() {
            return getFirstCustomRecord(this.item ? this.item.custom : null)
        },
        itemTitle() {
            if (this.customRecord && this.customRecord.title != null && String(this.customRecord.title).trim() !== '') {
                return this.customRecord.title
            }
            return this.item.title
        },
        itemDescription() {
            if (this.customRecord && this.customRecord.description != null && String(this.customRecord.description).trim() !== '') {
                return this.customRecord.description
            }
            return this.item.description
        },
        itemEquipmentId() {
            if (this.customRecord && this.customRecord.equipment_id != null && String(this.customRecord.equipment_id).trim() !== '') {
                return String(this.customRecord.equipment_id).trim()
            }
            return null
        },
        itemQrValue() {
            if (this.itemEquipmentId) return this.itemEquipmentId
            const fromItem = this.item && this.item.equipment_id != null ? String(this.item.equipment_id).trim() : ''
            if (fromItem) return fromItem
            const fromQr = this.item && this.item.qr_code != null ? String(this.item.qr_code).trim() : ''
            return fromQr || ''
        },
        hasDescriptionOrEquipment() {
            return !!(this.itemDescription || this.itemEquipmentId)
        },
        uncompleted() {
            if (this.def.has_timing) {
                // return !this.canBeEdited || !this.canShowValue
                return !this.canBeEdited && !this.canShowValue
                // return !this.canShowValue
                // return !( this.def.item.itemsImage.includes(this.item.type) ? (this.value ? this.value.lenght : false) : this.value ) || (!this.canBeEdited && this.isPast);
            } else {
                return !this.value && !this.canBeEdited
            }
        },
        completed() {
            if (this.completeEmployee() && this.completeDate != false) {
                return true
            } else {
                if ([FORMAT.PHOTO, FORMAT.SIGNATURE].includes(this.item.type)) {
                    return !!(!(typeof this.value === 'undefined' || this.value == '' || this.value == null) && typeof this.value === 'object' && this.value.length)
                } else {
                    return !!this.value
                }
            }
        },
        enabledMeta() {
            // return this.cType != 3
            return true
        },
        getReasonName() {
            var reason = this.$store.getters['getSingleReasonPostpone'](this.item.planned_reason_id)
            if (!reason) {
                return false
            }
            return this.$te(reason.name) ? this.$t(reason.name) : reason.name
        },
        questionClasses() {
            return {
                past: this.isPast,
                future: this.isFuture,
                child: this.item.parent_id,
                subsubitem: this.item.is_subsubitem,
                hidden: !this.item.is_visible,
                uncompleted: this.uncompleted,
                loading: this.loading,
                'value-collapsed': !this.valueExpanded,
                'postposed-from': this.item.planned_from_date,
                'postposed-to': this.item.planned_to_date && this.item.type != 8,
                'action-plan': this.cType === TOOLS.ACTION_PLANS
            }
        },
        answerClasses() {
            return {
                toReview: this.item.require_review && (this.canBeEdited || this.completed) && !this.item.planned_to_date && this.def.item.can_review,
                galery: this.item.type == FORMAT.PHOTO && this.aConfig.limit > 1
            }
        },
        itemClasses() {
            return {
                done: this.completed && !this.isActionPlanCompleted,
                error: this.hasError,
                issue: this.item.alerts ? !!(this.item.alerts.issues && this.item.alerts.issues.length) : false,
                alert: this.hasAlert,
                excluded: this.def.item.itemsExcluded.includes(this.item.type),
                error: !this.hasValidRole() && !this.completed
                // sync: (typeof this.item.requireSync !== 'undefined' && this.item.requireSync) || this.requireSync
            }
        },
        timeInputKey() {
            return `${this.aId}-time-${this.value == null || this.value === '' ? 'empty' : 'filled'}`
        },
        itemsExcluded() {
            return this.def.item.itemsExcluded.includes(this.item.type)
        },
        user() {
            if (this.loggedUser) {
                return this.$store.getters['employee/getEmployee'](this.loggedUser)
            }
            return false
        },
        roles() {
            return this.$store.getters['employee/getAllRoles']
        },
        userAppAccess() {
            return this.$store.getters['loginUser/getHasAccessApp']
        },
        timingNow() {
            if (this.list && this.list.type == 1) {
                const instant = this.timeRefreshKey ? new Date(this.timeRefreshKey) : new Date()
                return getLocationMoment(this.$store.getters, instant)
            }

            return this.timeRefreshKey ? moment(this.timeRefreshKey) : moment()
        },
        timingState() {
            if (!this.def.has_timing || this.itemsExcluded) {
                return false
            }

            const now = this.timingNow.clone().set({ s: 0, ms: 0 })
            const start = moment(this.list.limit.start)
            const end = moment(this.list.limit.end)

            if (now.isBefore(start)) {
                return 'future'
            }

            if (!now.isBetween(start, end) && now.isAfter(end)) {
                return 'past'
            }

            return 'intime'
        },
        isDisabled() {
            let now = this.timingNow.clone()

            // try {
            //     const options = {
            //         timeZone: timezone,
            //         year: 'numeric',
            //         month: 'numeric',
            //         day: 'numeric',
            //         hour: 'numeric',
            //         minute: 'numeric'
            //     }
            //     const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
            //     const objectDate = {}
            //     for (const item of dateTimeFormat) {
            //         objectDate[item.type] = item.value
            //     }
            //     const dateString = `${objectDate['year']}-${objectDate['month'].padStart(2, '0')}-${objectDate['day'].padStart(2, '0')} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`
            //     now = moment(dateString)
            // } catch (error) {
            //     now = moment()
            //     logError(error)
            // }

            // If action plan is completed, disable all interactions
            if (this.isActionPlanCompleted) {
                return true
            }

            if (this.loggedUser) {
                if (this.list.type == 1) {
                    if (now.isBefore(this.list.limit.start)) {
                        return 'future'
                    }
                }
                if (this.user) {
                    if (!this.userAppAccess) {
                        return 'no_access_app'
                    }
                    if (!this.userAppAccess && (this.cType == 2 || this.cType == 1)) {
                        return true
                    }
                }
                if (this.isIssueClosed || this.isRegisterClosed) {
                    return true
                }

                // if (this.hasDependency_tpl) {
                //     return 'dependency_tpl'
                // }
                if (this.def.has_timing) {
                    if (this.timingState == 'past') {
                        return 'past'
                    } else {
                        return false
                    }
                    // } else if( this.list.type == 2 && ( this.list.complete_date || moment(this.list.start_date).valueOf() > moment().valueOf() ) ){
                } else if (this.list.type == 3 && this.list.complete_date) {
                    // validate edits dates
                    let currentTemplate = this.$store.getters['register/getTemplateById'](this.$route.params.id)
                    if (currentTemplate.config && typeof currentTemplate.config.edit_days !== 'undefined') {
                        let edit_days = parseInt(currentTemplate.config.edit_days)

                        // by default
                        if (edit_days == -1) {
                            return true
                        } else {
                            let completed_date = moment(this.list.complete_date).startOf('day')
                            let compare_date = this.timingNow.clone().startOf('day').subtract(edit_days, 'days')
                            let days_difference = completed_date.diff(compare_date, 'days')

                            if (days_difference < 0) {
                                return true
                            }
                        }
                    } else {
                        // default
                        return true
                    }

                    // Registers
                    return false
                    // IS DISABLED AUDITS / AUDITORÍAS (no deshabilitar item si es plan de acción: this.cType !== 5)
                } else if (this.list.type == 2 && this.cType !== 5 && (this.list.complete_date || (this.isPast && this.def.can_edit.inPast) || (this.isFuture && this.def.can_edit.inFuture))) {
                    // Audits
                    return 'past'
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        aConfig() {
            return this.item.config && Object.keys(this.item.config).length > 0 ? this.item.config : false
        },
        // Un plan de acción llega con cType 5 (checklist del plan) o 19 (items del plan en su propia vista)
        isActionPlanItem() {
            return this.cType === TOOLS.ACTION_PLANS
        },
        canShowValue() {
            // en un plan de acción completado los valores se muestran siempre, aunque estén vacíos, para que se vean deshabilitados
            if (this.isActionPlanCompleted && (this.isActionPlanPage || this.cType === TOOLS.ACTION_PLANS)) {
                return true
            }

            let result = false

            // Action Plan checklist
            if (this.cType === 5) {
                result = true
            }

            if (!this.item.planned_to_date) {
                if (this.def.item.itemsVisibles.includes(this.item.type)) {
                    result = true
                } else if (this.def.item.itemsExcluded.includes(this.item.type)) {
                    result = true
                } else if (this.def.item.itemsImage.includes(this.item.type) && (this.canBeEdited || (this.value ? this.value.length > 0 : false))) {
                    result = true
                } else if (!this.def.item.itemsImage.includes(this.item.type) && (this.canBeEdited || this.value)) {
                    result = true
                }
            }
            return result
        },
        canPostpone() {
            if (this.def.item.can_pospone) {
                let maxDate = moment(this.list.business_date).add(parseInt(this.item.available), 'days')
                let currentDate = moment(this.list.business_date)

                if (this.item.margin > 0 && this.item.available > 0 && currentDate.isBefore(maxDate) && this.def.item.has_periodicity && (!this.value || (this.def.item.itemsImage.includes(this.item.type) && this.value.length == 0))) {
                    return true
                } else {
                    return false
                }
            }
        },
        canBeEdited() {
            if (this.isActionPlanCompleted) {
                return false
            }

            if (this.isDisabled == 'no_access_app') {
                if (this.list.type == 1) {
                    if (this.timingState == 'past') {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            } else if (this.isDisabled == 'future') {
                return true
            } else {
                return !this.isDisabled
            }
        },
        // for Action Plan Items
        checkRef() {
            return this.item.data && this.item.data.checklist ? this.item.data.checklist : null
        },
        itemRef() {
            return this.item.data && this.item.data.ref_item ? this.item.data.ref_item : null
        },
        displayedValue() {
            if (this.valueDraft !== null) {
                return this.valueDraft
            }

            return this.item.value != null ? this.item.value : ''
        },
        displayedComment() {
            if (this.commentDraft !== null) {
                return this.commentDraft
            }

            return this.item.message ? this.item.message : ''
        },
        // Comp values para las notas propias de ESTA tarea
        comment: {
            get() {
                return this.item.message ? this.item.message : ''
            },
            set(value) {
                const self = this

                // el plan de acción cerrado o fuera de plazo no admite notas,
                // y los items de la auditoría solo se muestran como contexto de la no conformidad
                if (this.isActionPlanCompleted || this.isDeadlineEnded || this.isAuditItemInActionPlanChecklist) {
                    return
                }

                const commentParams = {
                    cType: this.cType,
                    check: this.cId,
                    answer: this.aId,
                    message: value,
                    checkRef: this.cType === 5 ? this.checkRef : null,
                    itemRef: this.cType === 5 ? this.itemRef : null
                }

                if (this.image) {
                    commentParams.file = this.image
                }

                this.$store
                    .dispatch(self.typename + '/comment', commentParams)
                    .then((response) => {
                        const persisted = self.finalizeCommentSaveAttempt()
                        // al guardar correctamente la mayoría de módulos del store no devuelven respuesta,
                        // así que solo hay error cuando llega un objeto con status false
                        if (response && !response.status) {
                            if (!persisted) {
                                self.$snackbar.error({
                                    closeable: true,
                                    duration: 5000,
                                    message: self.$t('tasks.answer_offline')
                                })
                            }
                        } else {
                            self.item.message = value
                        }
                    })
                    .catch((error) => {
                        self.finalizeCommentSaveAttempt()
                        console.error('error saving the note: ', error)
                    })
            }
        },
        image: {
            get() {
                return this.item.image ? this.item.image : false
            },
            set(value) {
                let self = this

                // el plan de acción cerrado o fuera de plazo no admite notas,
                // y los items de la auditoría solo se muestran como contexto de la no conformidad
                if (this.isActionPlanCompleted || this.isDeadlineEnded || this.isAuditItemInActionPlanChecklist) {
                    return
                }

                this.$store
                    .dispatch(self.typename + '/comment', {
                        cType: this.cType,
                        check: this.cId,
                        answer: this.aId,
                        message: this.comment,
                        file: value,
                        checkRef: this.cType === 5 ? this.checkRef : null,
                        itemRef: this.cType === 5 ? this.itemRef : null
                    })
                    .then(function (response) {
                        if (response && !response.status) {
                            self.$snackbar.error({
                                closeable: true,
                                duration: 5000,
                                message: self.$t('tasks.answer_offline')
                            })
                        } else {
                            self.commenting = false
                        }
                    })
                    .catch(function (error) {
                        console.error('error saving the note image: ', error)
                    })
            }
        },
        // Valor propio de la tarea
        value: {
            get() {
                if (this.autosave) {
                    if (this.def.item.itemsImage.includes(this.item.type)) {
                        let aux = this.item.value
                        if (!aux) {
                            return []
                        } else {
                            return aux
                        }
                    } else {
                        return this.item.value
                    }
                } else {
                    // TODO tiene sentido dividir el get por autosave?
                    return this.item.value
                }
            },
            async set(value) {
                const self = this

                // el plan de acción cerrado o fuera de plazo no admite respuestas,
                // y los items de la auditoría solo se muestran como contexto de la no conformidad
                if (this.isActionPlanCompleted || this.isDeadlineEnded || this.isAuditItemInActionPlanChecklist) {
                    return
                }

                const itemType = Number(this.item.type)
                const hasStoredValue = this.item.value != null

                const isTypeTextOrTextarea = itemType === FORMAT.TEXT || itemType === FORMAT.TEXTAREA

                // Vaciar TEXT/TEXTAREA con respuesta persistida: solo reset, nunca answer('').
                if (this.shouldConfirmEmptyTextReset(value)) {
                    await this.confirmAndResetEmptyText()
                    return
                }

                const isDateLikeType = [FORMAT.DATE, FORMAT.TIME, FORMAT.DATETIME].includes(itemType)

                if (value === '' && isDateLikeType) {
                    if (hasStoredValue) {
                        const skipPreventDeletePopup = itemType === FORMAT.DATE || itemType === FORMAT.DATETIME
                        const confirmed = await this.resetAnswer({ skipPreventDeletePopup })
                        if (!confirmed) {
                            self.$forceUpdate()
                        }
                    }
                    return
                }

                self.hasError = false
                self.$overlay.hide()

                const timezone = this.$store.getters['getTimeZoneName']
                let date = false

                try {
                    const options = {
                        timeZone: timezone,
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric',
                        hour12: false
                    }
                    const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                    const objectDate = {}
                    for (const item of dateTimeFormat) {
                        objectDate[item.type] = item.value
                    }
                    const dateString = `${objectDate['year']}-${objectDate['month'].padStart(2, '0')}-${objectDate['day'].padStart(2, '0')} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}:${objectDate['second'].padStart(2, '0')}`
                    date = moment(dateString).unix()
                } catch (error) {
                    date = moment().unix()
                    logError(error)
                }

                if (this.item.type === FORMAT.CHECK) {
                    value = value ? 1 : 0
                }

                if (!this.isDisabled) {
                    const employee = this.loggedUser
                    const alertTriggers = this.item.alerts_triggers

                    let bExistsEmailAlert = false

                    if (alertTriggers) {
                        if (!self.itemIsMultiselect) {
                            // for all types of items
                            bExistsEmailAlert = alertTriggers.some((alert) => alert.type === 'email' && this.checkCondition(alert, value))
                        } else {
                            // for multiselect items (type 11 with config.multiselect = 1)
                            const itemValues = value.split('|') // the multiple values are saved as a string with the values separated by a pipe (|)
                            bExistsEmailAlert = alertTriggers.some((alert) => alert.type === 'email' && itemValues.some((value) => this.checkCondition(alert, value)))
                        }
                    }

                    if (bExistsEmailAlert) {
                        this.handleDisplayEmailAlert(value, employee, date, this.completeDate)
                    } else {
                        if (this.autosave) {
                            this.loading = true

                            this.dispatchQueue = this.dispatchQueue || Promise.resolve()
                            this.dispatchQueue = this.dispatchQueue.then(() => this.dispatchAnswer(value, employee, date, self.completeDate))
                        } else {
                            if (self.mandatedValidation(value)) {
                                self.hasError = true
                            }

                            this.loading = true
                            this.dispatchQueue = this.dispatchQueue || Promise.resolve()
                            this.dispatchQueue = this.dispatchQueue.then(() => this.dispatchAnswer(value, employee, date, self.completeDate))
                        }
                    }
                }
            }
        },
        isReview() {
            let result = this.item.review
            if (result) {
                result.complete_date = moment(result.complete_date)
            }
            return result
        },
        bSensorLimitation() {
            return this.$store.getters['getSensorLimitation'] == 1
        },
        itemHasActionPlan() {
            return this.item.reference && this.item.reference.type && this.item.reference.type === TYPE.ACTION_PLAN
        },
        actionPlanTemplates() {
            const actionPlanTemplates = this.$store.getters['audit/getActionPlanTemplates']
            if (actionPlanTemplates) {
                return Object.values(actionPlanTemplates)
            } else {
                return []
            }
        },
        isActionPlanClosed() {
            return this.item.reference && this.item.reference.isClosed === true
        },
        actionPlanMessage() {
            if (this.isActionPlanClosed) {
                return this.getString('answer.action_plan_by_item')
            }
            return this.getString('answer.action_plan_pending')
        },
        isANonConformity() {
            // "non conformity" is an Audit item that has an Action Plan associated with it
            const self = this

            if (self.cType === 2 && self.item.alerts_triggers && self.item.alerts_triggers[0]) {
                const alertTriggerTemplateID = self.item.alerts_triggers[0].tpl ? self.item.alerts_triggers[0].tpl : null

                if (!alertTriggerTemplateID) {
                    return false
                }

                const templateIdIsActionPlan = this.actionPlanTemplates.some((template) => template.id === alertTriggerTemplateID)

                return templateIdIsActionPlan
            } else {
                return false
            }
        },
        itemIsMultiselect() {
            const item = this.item

            if (!item) return false

            return item.config && item.config.hasOwnProperty('multiselect') && item.config.multiselect === 1
        },
        canShowReviewCheck() {
            return !this.item.planned_to_date && this.def.item.can_review
        },
        // Multiselect with a value uses column layout: keep the check next to the title only
        showReviewCheckInTitle() {
            return this.canShowReviewCheck && this.item.require_review && this.item.type == FORMAT.MULTIPLE && this.itemIsMultiselect && !!this.item.value
        },
        // Everywhere else (including simple selector) — mutually exclusive with title placement
        showReviewCheckInResponse() {
            if (!this.canShowReviewCheck) {
                return false
            }

            if (this.item.type !== FORMAT.MULTIPLE) {
                return true
            }

            return !this.showReviewCheckInTitle
        },
        isEmailSent() {
            const hasValue = this.value == 1 || this.value === true
            return hasValue && !this.item.requireSync
        },
        loadLastValue() {
            return this.$store.getters['login/getConfig'].loadLastValue && this.item.config.load_last_value
        },
        resetItemInfo() {
            if (this.item.reset) {
                let employee = this.item.reset.e
                let date = this.item.reset.d
                // Format: Vie 26/09/2025 08:40h
                let dateString = formatDisplayDateTimeFromStore(date, { emptyValue: '' })
                let oEmployee = this.$store.getters['employee/getEmployee'](employee)
                return {
                    employee: oEmployee ? oEmployee : false,
                    date: dateString
                }
            }
            return false
        }
    },
    methods: {
        onQuestionClick() {
            if (this.isDeadlineEnded) {
                this.showDeadlineEndedAlert()
                return
            }

            this.toggleShowHideSectionItems(this.item)
        },
        showDeadlineEndedAlert() {
            const userName = this.user && this.user.name ? this.user.name : ''

            this.$popup.alert({
                message: this.$t('action_plans.cannot_change_item_deadline_ended', { name: userName }),
                textSave: this.$t('popup.alert.text_save')
            })
        },
        checkIfNewAnswerTriggersSameActionPlan(newVal) {
            const self = this

            const isAuditTemplate = self.cType === TYPE.AUDIT ? true : false

            if (!isAuditTemplate || newVal === undefined || newVal === null || newVal === '') {
                return false
            }

            const actionPlanTriggers = self.item.alerts_triggers
            const currentActionPlans = self.item.actionplans ? Object.values(self.item.actionplans) : []
            const currentActionPlanTemplateId = currentActionPlans.length > 0 && currentActionPlans[0].actionplan_templateid ? currentActionPlans[0].actionplan_templateid : null

            if (!actionPlanTriggers || !currentActionPlanTemplateId) {
                return false
            }

            const valuesToCheck = self.itemIsMultiselect ? String(newVal).split('|').filter(Boolean) : [newVal]

            return actionPlanTriggers.some((trigger) => {
                const matchesTemplate = trigger.tpl && trigger.tpl === currentActionPlanTemplateId

                if (!matchesTemplate) {
                    return false
                }

                return valuesToCheck.some((itemValue) => compare(trigger.value, itemValue, trigger.operator))
            })
        },
        sectionItemsAreDone(sectionId) {
            return this.doneSectionsIds.includes(sectionId)
        },
        toggleShowHideSectionItems(item) {
            if (item.type !== FORMAT.TITLE) {
                return
            }

            const sectionId = item.item_id

            if (this.sectionIsOpen) {
                this.$emit('section-toggled', sectionId, true)
            } else {
                this.$emit('section-toggled', sectionId, false)
            }

            this.sectionIsOpen = !this.sectionIsOpen
        },

        getEmailAnswerErrorMessage(msg) {
            if (msg && msg !== 'Error: Api Error') {
                return this.$t(msg)
            }
            return this.$t('answer.email_send_failed')
        },
        async dispatchAnswer(value, employee, date, completeDate) {
            const self = this
            try {
                const response = await this.$store.dispatch(self.typename + '/answer', {
                    cType: this.cType,
                    check: this.cId,
                    answer: this.aId,
                    answer_type: this.item.type,
                    emp: employee,
                    date: date,
                    value: value,
                    customTitle: this.item.config && this.item.config.custom_title ? true : false,
                    checkRef: this.cType === 5 ? this.checkRef : null,
                    itemRef: this.cType === 5 ? this.itemRef : null,
                    audit: this.cType === 5 ? this.list.id : null,
                    bReadingFromSensor: self.bReadingFromSensor
                })

                let complete_date = self.completeDate
                if (self.item.mandatory && complete_date) {
                    self.$emit('checkAllMandatory')
                }
                self.loading = false
                self.$overlay.hide()

                const persisted = self.finalizeValueSaveAttempt()
                const isEmailItem = Number(self.item.type) === FORMAT.EMAIL

                if (!response || !response.status) {
                    if (isEmailItem) {
                        self.$forceUpdate()
                    }

                    const isEmailQueuedForSync = isEmailItem && self.item.requireSync
                    const showEmailServerError = isEmailItem && !isEmailQueuedForSync

                    if (!persisted && !self.$store.getters.getOffline) {
                        let msg = self.$t('tasks.answer_offline')
                        if (isEmailItem) {
                            msg = self.getEmailAnswerErrorMessage(response.msg)
                        } else if (response.msg && response.msg == 'Error: Api Error') {
                            msg = self.$t('tasks.answer_api_error')
                        }
                        self.$snackbar.error({
                            closeable: true,
                            duration: 5000,
                            message: msg
                        })
                    } else if (showEmailServerError) {
                        self.$snackbar.error({
                            closeable: true,
                            duration: 5000,
                            message: self.getEmailAnswerErrorMessage(response.msg)
                        })
                    } else if (self.$store.getters.getOffline) {
                        self.hasAccess = !self.item.require_pin
                        self.userAccess = false

                        if (self.cType === TYPE.AUDIT && self.valueCreatesActionPlan(value)) {
                            self.displayCreateActionPlanConfirmPopup()
                        } else {
                            self.showAlertOrIncidentPopup()
                        }

                        self.requireSync = true
                    }
                } else {
                    if (isEmailItem && fnCheckConnection()) {
                        self.$snackbar.success({
                            message: self.$t('answer.sended_mail'),
                            duration: 5000,
                            closeable: true
                        })
                    }

                    self.hasAccess = !self.item.require_pin
                    self.userAccess = false

                    if (self.cType === TYPE.AUDIT && self.valueCreatesActionPlan(value)) {
                        if ((self.item.type === 5 && Array.isArray(self.item.value) && self.item.value.length > 1) || Object.values(self.item.actionplans).length > 0) {
                            return
                        } else {
                            self.displayCreateActionPlanConfirmPopup()
                        }
                    } else {
                        self.showAlertOrIncidentPopup()
                    }
                }
            } catch (error) {
                if (Number(self.item.type) === FORMAT.EMAIL) {
                    self.$forceUpdate()
                    if (!self.item.requireSync) {
                        self.$snackbar.error({
                            closeable: true,
                            duration: 5000,
                            message: self.getEmailAnswerErrorMessage(error.msg)
                        })
                    }
                }
                console.error('Error in dispatchAnswer:', error)
                self.finalizeValueSaveAttempt()
                self.loading = false
                self.$overlay.hide()
            }
        },
        finalizeValueSaveAttempt() {
            const committed = this.valueDraftCommitted
            if (committed === null) {
                this.valueSavePending = false
                return true
            }

            const storedValue = this.item.value != null ? String(this.item.value) : ''
            if (storedValue === String(committed)) {
                this.valueSavePending = false
                this.valueDraft = null
                this.valueDraftCommitted = null
                return true
            }

            if (this.valueDraft === null) {
                this.valueDraft = committed
            }
            return false
        },
        finalizeCommentSaveAttempt() {
            const committed = this.commentDraftCommitted
            if (committed === null) {
                this.commentSavePending = false
                return true
            }

            const storedMessage = this.item.message ? this.item.message : ''
            if (storedMessage === String(committed)) {
                this.commentSavePending = false
                this.commentDraft = null
                this.commentDraftCommitted = null
                return true
            }

            if (this.commentDraft === null) {
                this.commentDraft = committed
            }
            return false
        },
        showDatePicker(event) {
            if (this.cType == 2 || this.isCreator) {
                event.target.showPicker()
            }
        },
        async onDateOrDatetimeNativeChange(event) {
            const newVal = event.target.value
            const previous = this.value

            if (newVal === '') {
                if (!previous) {
                    this.resetNativeTemporalInput(event.target)
                    return
                }

                if (!this.valueCreatesActionPlan(this.item.value)) {
                    const confirmed = await displayPreventDeletePopup(this)
                    if (!confirmed) {
                        event.target.value = previous
                        return
                    }
                }

                await this.resetAnswer({ skipPreventDeletePopup: true })
                this.resetNativeTemporalInput(event.target)
                return
            }

            this.value = newVal
        },
        resetNativeTemporalInput(input) {
            if (!input) {
                return
            }

            input.value = ''

            // Chrome keeps incomplete time values (e.g. 18:--) when .value is already empty
            if (input.type === 'time') {
                input.type = 'text'
                input.type = 'time'
            }
        },
        isActionPlanAlertTrigger(alert) {
            if (!alert || !alert.tpl) {
                return false
            }

            const actionPlanTemplates = this.actionPlanTemplates
            if (!actionPlanTemplates || actionPlanTemplates.length === 0) {
                return false
            }

            return actionPlanTemplates.some((template) => template.id === alert.tpl)
        },
        answerMatchesActionPlanTrigger(alert, answerValue) {
            if (answerValue == null || answerValue === '') {
                return false
            }

            if (this.itemIsMultiselect) {
                const itemValues = String(answerValue).split('|')
                return itemValues.some((itemValue) => this.checkCondition(alert, itemValue))
            }

            return this.checkCondition(alert, answerValue)
        },
        valueCreatesActionPlan(answerValue) {
            const alertsTriggers = this.item.alerts_triggers
            if (!alertsTriggers) {
                return false
            }

            const actionPlanTriggers = Object.values(alertsTriggers).filter((alert) => this.isActionPlanAlertTrigger(alert))
            if (actionPlanTriggers.length === 0) {
                return false
            }

            return actionPlanTriggers.find((alert) => this.answerMatchesActionPlanTrigger(alert, answerValue)) || false
        },
        // CREATE ACTION PLAN / CREAR PLAN DE ACCIÓN - calls store to create it
        createActionPlan() {
            if (this.isActionPlanItem) {
                return
            }

            const self = this
            self.$overlay.loading()

            const actionPlanIds = self.item.alerts.issues

            if (actionPlanIds.length === 1) {
                this.$store
                    .dispatch(self.typename + '/addActionPlan', {
                        actionPlanId: actionPlanIds[0], // Action Plan ID
                        cType: 5,
                        checklist_ref: self.list.id,
                        item_ref: self.item.item_id
                    })
                    .then(function (response) {
                        if (response) {
                            return true
                        }
                        // API ok but no data
                        self.$overlay.hide()
                    })
                    .catch((error) => {
                        console.error('Error in createActionPlan:', error)
                        self.$overlay.hide()
                    })
            } else {
                // handle create multiple action plans
                const promises = actionPlanIds.map((actionPlanId) => {
                    return this.$store.dispatch(self.typename + '/addActionPlan', {
                        actionPlanId: actionPlanId,
                        cType: 5,
                        checklist_ref: self.list.id,
                        item_ref: self.item.item_id
                    })
                })

                Promise.all(promises)
                    .then((responses) => {
                        if (responses.every((response) => response)) {
                            return true
                        }
                        self.$overlay.hide()
                    })
                    .catch((error) => {
                        console.error('Error in createActionPlan:', error)
                        self.$overlay.hide()
                    })
            }
            // importante: si no hay errores, el loading se cierra en el watch de auditIsLoading
        },
        getActionPlanName() {
            const self = this

            const value = self.value
            const actionPlans = self.item.alerts_triggers

            let actionPlanName

            actionPlans.forEach((actionplan) => {
                const valueCreatesActionPlan = self.answerMatchesActionPlanTrigger(actionplan, value)

                if (valueCreatesActionPlan) {
                    const actionPlan = self.actionPlanTemplates.filter((template) => template.id === actionplan.tpl)[0]

                    actionPlanName = actionPlan.name
                }
            })

            return actionPlanName
        },
        // DISPLAY CREATE ACTION PLAN / PLAN DE ACCIÓN POPUP CONFIRM
        displayCreateActionPlanConfirmPopup() {
            const self = this

            const itemAlerts = this.item.alerts
            const alertMessage = itemAlerts.message ? itemAlerts.message : itemAlerts.triggers[0].msg ? itemAlerts.triggers[0].msg : this.$t('popup.action_plan_create.message2')

            const actionPlanName = itemAlerts.issues.length === 1 ? self.getActionPlanName() : ''

            self.$popup.confirm({
                title: `${alertMessage}`,
                tplName: actionPlanName ? `${actionPlanName}` : '',
                textSave: this.$t('menu_aux.action.create'),
                textCancel: this.$t('menu_aux.action.cancel'),
                type: 'action-plan-create',
                callCancel: async () => {
                    await this.resetAnswer({ skipPreventDeletePopup: true })
                    self.$popup.close()
                },
                callSave: () => {
                    // if popup response is 'Create', create action plan:
                    this.createActionPlan() // calls de store to create the action plan

                    self.$popup.close()
                }
            })
        },
        displayDeletedActionPlanConfirmSnackbar() {
            const snackbarData = {
                duration: 4000,
                closeable: true,
                message: this.$t('issues.deleted_msg')
            }

            this.$snackbar.success(snackbarData)
        },
        // DELETE ACTION PLAN / BORRAR PLAN DE ACCIÓN (calls the store)
        async deleteActionPlan() {
            const self = this

            // data for store
            const data = {
                checklist: self.list.id,
                employeeId: this.loggedUser, // employee id
                item_id: this.item.item_id,
                action_plan_id: this.item.reference.checklist // action plan id
            }

            try {
                const response = await self.$store.dispatch('audit/deleteActionPlan', data)
                if (response) {
                    return true
                }
            } catch (error) {
                console.error(error)
            }
        },
        // DELETE ACTION PLAN POPUP CONFIRM
        async displayDeleteActionPlanConfirmPopup() {
            const self = this

            return new Promise((resolve) => {
                self.$popup.confirm({
                    title: self.$t('popup.action_plan_loss.title'),
                    message: self.$t('popup.action_plan_loss.message'),
                    textSave: self.$t('popup.delete.text_save'),
                    textCancel: self.$t('popup.delete.text_cancel'),
                    type: 'action-plan-loss',
                    callCancel: () => {
                        self.$popup.close()
                        resolve(false)
                    },
                    callSave: async () => {
                        self.$popup.close()
                        const actionPlanWasDeleted = await this.deleteActionPlan()

                        if (actionPlanWasDeleted) {
                            self.$popup.close()
                            this.displayDeletedActionPlanConfirmSnackbar()
                            resolve(true)
                        }
                    }
                })
            })
        },
        calculedLength(e) {
            const value = e.target.value
            const maxLength = 460
            const jsonValue = jsonEscapeUTF(JSON.stringify(value))
            const difference = jsonValue.length - value.length

            if (jsonValue.length > maxLength) {
                e.target.value = value.substring(0, maxLength - difference)
            }
        },
        completeEmployee() {
            var employee = this.item.employee

            if (typeof employee === 'object') {
                return employee
            } else if (employee) {
                return this.$store.getters['employee/getEmployee'](employee)
            } else {
                return false
            }
        },
        getPeriodicityTranslationKey() {
            switch (this.item.periodicity) {
                case 1:
                    return this.$t('answer.daily')
                case 2:
                    return this.$t('answer.weekly')
                case 3:
                    return this.$t('answer.biweekly')
                case 4:
                    return this.$t('answer.monthly')
                case 5:
                    return this.$t('answer.quarterly')
                case 6:
                    return this.$t('answer.biannually')
                case 7:
                    return this.$t('answer.annually')
                default:
                    return ''
            }
        },
        checkCondition(conditions, value) {
            const val = conditions.value
            const operator = conditions.operator

            switch (this.item.type) {
                case FORMAT.EMAIL:
                case FORMAT.DOCUMENT:
                case FORMAT.CHECK:
                case FORMAT.YESNO:
                    return compare(parseInt(val) == 1 || (val == '' && operator == '!empty'), value == true || value == 'true' || (value != null && val == '' && operator == '!empty'), operator)
                    break
                case FORMAT.YESNONC:
                    return compare(parseInt(val) || (val == '' && operator == '!empty'), value || (val == '' && operator == '!empty'), operator)
                    break
                case FORMAT.MULTIPLE:
                    return compare(val || (val == '' && operator == '!empty'), value, operator)
                    break
                case FORMAT.TEXT:
                case FORMAT.TEXTAREA:
                case FORMAT.PHOTO:
                case FORMAT.DATE:
                case FORMAT.TIME:
                case FORMAT.DATETIME:
                case FORMAT.SIGNATURE:
                    return compare(val, value, operator)
                    break
                case FORMAT.NUMBER:
                    var aux = value.toString().replace(',', '.')
                    return compare(parseFloat(aux), val, operator) || (val == '' && operator == '!empty')
                    break
                case FORMAT.TEMPERATURE:
                    var aux = value.toString().replace(',', '.')
                    return compare(parseFloat(aux), val, operator) || (val == '' && operator == '!empty')
                    break
                default:
                    break
            }

            return true
        },
        handleEmailAlertSave(value, employee, date, completeDate) {
            const isDateLikeType = [FORMAT.DATE, FORMAT.TIME, FORMAT.DATETIME].includes(Number(this.item.type))

            if (value === '' && isDateLikeType) {
                this.resetAnswer({ skipPreventDeletePopup: true })
                return
            }

            const isEmptyTextType = (value === '' || value == null) && [FORMAT.TEXT, FORMAT.TEXTAREA].includes(Number(this.item.type))
            if (isEmptyTextType) {
                this.valueDraft = null
                this.valueDraftCommitted = null
                this.valueSavePending = false
                this.resetAnswer({ skipPreventDeletePopup: true })
                return
            }

            // Base object with common properties for answer dispatch
            const baseAnswerData = {
                cType: this.cType,
                check: this.cId,
                answer: this.aId,
                emp: employee,
                date: date,
                value: value,
                checkRef: this.cType === 5 ? this.checkRef : null,
                itemRef: this.cType === 5 ? this.itemRef : null,
                audit: this.cType === 5 ? this.list.id : null,
                bReadingFromSensor: this.bReadingFromSensor
            }

            if (this.autosave) {
                // si son de "tipo texto", cuando no tengan valor se autoresetearan (para hacer bien el recount)
                if ([FORMAT.TEXT, FORMAT.DATE, FORMAT.TEXTAREA, FORMAT.TIME, FORMAT.DATETIME].includes(this.item.type)) {
                    // TODO
                    this.loading = true

                    this.$store.dispatch(this.typename + '/answer', baseAnswerData).then((response) => {
                        this.loading = false

                        if (this.item.mandatory && !completeDate) {
                            this.$emit('checkAllMandatory')
                        }

                        if (!response || !response.status) {
                            if (!this.$store.getters.getOffline) {
                                this.$snackbar.error({
                                    closeable: true,
                                    duration: 5000,
                                    message: this.$t('tasks.answer_offline')
                                })
                            } else {
                                this.requireSync = true
                            }
                        } else {
                            if (this.value == '') {
                                this.resetAnswer()
                            } else {
                                this.hasAccess = !this.item.require_pin
                                this.userAccess = false
                            }

                            this.showAlertOrIncidentPopup()
                        }
                    })
                } else {
                    // TODO
                    this.loading = true

                    this.$store
                        .dispatch(this.typename + '/answer', {
                            ...baseAnswerData,
                            answer_type: this.item.type
                        })
                        .then((response) => {
                            if (this.item.mandatory && completeDate) {
                                this.$emit('checkAllMandatory')
                            }

                            this.loading = false
                            this.$overlay.hide()

                            if (!response || !response.status) {
                                if (!this.$store.getters.getOffline) {
                                    this.$snackbar.error({
                                        closeable: true,
                                        duration: 5000,
                                        message: this.$t('tasks.answer_offline')
                                    })
                                } else {
                                    this.requireSync = true
                                }
                            } else {
                                this.hasAccess = !this.item.require_pin
                                this.userAccess = false

                                this.showAlertOrIncidentPopup()
                            }
                        })
                }
            } else {
                if (this.mandatedValidation(value)) {
                    this.hasError = true
                }

                this.loading = true

                this.$store
                    .dispatch(this.typename + '/answer', {
                        ...baseAnswerData,
                        answer_type: this.item.type
                    })
                    .then((response) => {
                        if (this.item.mandatory && completeDate) {
                            this.$emit('checkAllMandatory')
                        }

                        this.loading = false
                        this.$overlay.hide()

                        if (!response || !response.status) {
                            if (!this.$store.getters.getOffline) {
                                this.$snackbar.error({
                                    closeable: true,
                                    duration: 5000,
                                    message: this.$t('tasks.answer_offline')
                                })
                            } else {
                                this.requireSync = true
                            }
                        } else {
                            this.showAlertOrIncidentPopup()
                            this.hasAccess = !this.item.require_pin
                            this.userAccess = false
                        }
                    })
            }
        },
        handleDisplayEmailAlert(value, employee, date, completeDate) {
            const alertTriggers = this.item.alerts_triggers

            let valueToDisplay = value

            if (this.itemIsMultiselect) {
                valueToDisplay = value.split('|').join(', ')
            }

            setTimeout(() => {
                let emailToDisplay = ''

                if (!this.itemIsMultiselect) {
                    emailToDisplay = alertTriggers.reduce((acc, alert) => {
                        if (alert.type === 'email' && this.checkCondition(alert, value)) {
                            acc = alert.to
                        }
                        return acc
                    }, '')
                } else {
                    // for multiselect items (type 11 with config.multiselect = 1)
                    const itemValues = value.split('|') // the multiple values are saved as a string with the values separated by a pipe (|)

                    const emailsList = []

                    alertTriggers.forEach((alert) => {
                        if (alert.type === 'email' && itemValues.some((itemValue) => this.checkCondition(alert, itemValue))) {
                            const email = alert.to

                            if (!emailsList.includes(email)) {
                                emailsList.push(email)
                            }
                        }
                    })

                    emailToDisplay = emailsList.join(', ')
                }

                if (this.item.type === FORMAT.CHECK) {
                    valueToDisplay = this.$t('popup.email-alert.check')
                }

                if (this.item.type === FORMAT.EMAIL) {
                    valueToDisplay = this.item.config.to.join(', ')
                }

                if (this.item.type === FORMAT.YESNONC || this.item.type === FORMAT.YESNO) {
                    if (value === 0) {
                        valueToDisplay = this.$t('popup.email-alert.s_n_ns_0')
                    } else if (value === 1) {
                        valueToDisplay = this.$t('popup.email-alert.s_n_ns_1')
                    } else if (value === 2) {
                        valueToDisplay = this.$t('popup.email-alert.s_n_ns_2')
                    }
                }

                let message = this.$t('popup.email-alert.message', { email: emailToDisplay, value: valueToDisplay })

                if (this.item.type === FORMAT.SIGNATURE || this.item.type === FORMAT.PHOTO || this.item.type === FORMAT.GALLERY) {
                    valueToDisplay = `<img src='${value}' class='image-preview'/>`
                    message = this.$t('popup.email-alert.message-img', { email: emailToDisplay, value: valueToDisplay })
                }

                this.$popup.emailAlert({
                    message: message,
                    callSave: () => this.handleEmailAlertSave(value, employee, date, completeDate)
                })
            }, 100)
        },
        canExpandSection(update) {
            const bUpdate = typeof update !== 'undefined' ? update : true
            const sectionItems = this.$store.getters[this.typename + '/getItemsBySection'](this.list.id, this.item.item_id)

            if (Object.values(sectionItems).length > 0) {
                // if all items of section are mandatory, then section can't be expanded
                if (Object.values(sectionItems).every((item) => item.mandatory) && bUpdate) {
                    this.toggleMeta(false)
                }
                return !Object.values(sectionItems).every((item) => item.mandatory)
            }
            return false
        },
        showActions() {
            if (this.isActionPlanCompleted) {
                return false
            }

            return !this.isDisabled
        },
        hasValidRole() {
            if (!this.hasValidPermissions()) return false

            const itemRoles = this.aConfig ? this.aConfig.roles : false

            if (itemRoles && itemRoles.length > 0) {
                // IF ALL ROLES HAS BEEN DELETED
                if (itemRoles.length == 1 && !itemRoles.every((v) => Object.keys(this.roles).includes(v))) {
                    return true
                } else return itemRoles.includes(this.user.rol)
            } else return true
        },
        textParse(text) {
            if (!text) {
                return
            }

            let result = text

            result = result.replace(/\n/gi, ' <br> ')
            result = result.replace(/&lt;br&gt;/g, '<br>')

            result = result.replace(/([^\S]|^)(((https?\:\/\/)|(http?\:\/\/)|(www\.))(\S+))/gi, function (match, space, url) {
                var hyperlink = url.startsWith('www') ? 'https://' + url : url
                return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>'
            })

            return result
        },
        descriptionParse(msg) {
            return this.textParse(msg)
        },
        getAlertEmail(oAlert) {
            return this.$tc('supervise.checklists.alert_email', 0, { to: oAlert.to })
        },
        getString(str) {
            return this.$t(str)
        },
        getStringObject(str, obj) {
            return i18n.t(str, obj)
        },
        getStringVariable(str, name) {
            return this.$t(str, { s: name })
        },
        getStringIssueState(id) {
            let issueState = this.$store.getters['getSingleIssueStates'](id)
            return issueState ? issueState.name.toLowerCase() : ''
        },
        getStringLimitRoles(roles) {
            const nameRoles = []

            for (const role in roles) {
                if (this.roles && roles && roles[role] && this.roles[roles[role]]) {
                    nameRoles.push(this.roles[roles[role]].name)
                }
            }
            return nameRoles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        getFormattedPostponedDate(date, withName) {
            const parsedDate = moment.utc(date) // Forzar UTC

            if (withName) {
                return {
                    name: this.completeEmployee().name + ' ' + this.completeEmployee().surname,
                    s1: parsedDate.format('dddd'),
                    s2: parsedDate.format('DD'),
                    s3: parsedDate.format('MMMM')
                }
            }
            return { s1: parsedDate.format('dddd'), s2: parsedDate.format('DD'), s3: parsedDate.format('MMMM') }
        },
        handleFocus(event, id, atElement) {
            if (!this.checkAccess(undefined, atElement)) {
                return
            }

            if (this.landscapeSuppressReopen) {
                this.landscapeSuppressReopen = false
                return
            }

            if (this.shouldUseLandscapeTextPopup(!!atElement)) {
                this.openLandscapeTextPopup(event, id, atElement)
                return
            }

            atElement = typeof atElement === 'undefined' ? false : atElement

            var scroll = {
                container: this.$parent.$refs.container,
                target: document.getElementById(id),
                offset: -105
            }
            if (atElement) {
                var elHeight = event.target.offsetHeight
                scroll.offset = elHeight
            }
            this.$root.handleFocusKeyboard(this, scroll)
        },
        shouldUseLandscapeTextPopup(isComment = false) {
            if (isComment && !this.commenting) {
                return false
            }

            return shouldUseLandscapeTextPopupUtil()
        },
        onScreenLayoutChange() {
            if (!this.landscapeTextPopupOpen) {
                return
            }

            const isComment = this.landscapeTextPopupIsComment

            if (this.shouldUseLandscapeTextPopup(isComment)) {
                return
            }

            this.landscapeDismissWithoutRefocus = true
            this.closeLandscapeTextPopupAfterRotation()
        },
        closeLandscapeTextPopupAfterRotation() {
            if (!this.landscapeTextPopupOpen) {
                return
            }

            const isComment = this.landscapeTextPopupIsComment

            if (isComment) {
                this.saveLandscapeComment(this.landscapeTextPopupInputVal)
            } else {
                this.saveLandscapeValue(this.landscapeTextPopupInputVal)
            }

            this.handleInputEnd()

            if (this.landscapeSourceEl) {
                try {
                    this.landscapeSourceEl.blur()
                } catch (e) {
                    // blur may fail if element was removed from DOM
                }
            }

            this.landscapeTextPopupOpen = false
            this.landscapeTextPopupIsComment = false
            this.landscapeTextPopupInputVal = ''
            this.landscapeSuppressReopen = false
            this.landscapeSourceEl = null
            this.landscapeDismissWithoutRefocus = false
            this.$popup.close()

            try {
                this.$root.handleBlurKeyboard(this)
            } catch (e) {
                // restoring bars is non-critical; ignore if elements are missing
            }
        },
        getLandscapeTextPopupTitle(isComment = false) {
            let title = this.itemTitle || ''

            if (typeof title === 'string') {
                title = title.replace(/<[^>]*>/g, '').trim()
            }

            if (isComment && title) {
                title = `${this.$t('answer.attach_note')}: ${title}`
            } else if (isComment) {
                title = this.$t('answer.attach_note')
            }

            if (!isComment && this.item.mandatory) {
                title += ' *'
            }

            return title
        },
        getNextLandscapeTextItem() {
            if (!this.list || !this.list.items) {
                return null
            }

            let itemsArray = []
            if (typeof this.list.items === 'object' && !Array.isArray(this.list.items)) {
                itemsArray = Object.keys(this.list.items).map((key) => this.list.items[key])
            } else if (Array.isArray(this.list.items)) {
                itemsArray = this.list.items
            }

            const currentIndex = itemsArray.findIndex((item) => item && item.item_id === this.item.item_id)
            if (currentIndex === -1) {
                return null
            }

            for (let i = currentIndex + 1; i < itemsArray.length; i++) {
                const candidate = itemsArray[i]
                if (!candidate) {
                    continue
                }

                const type = Number(candidate.type)
                if (type === FORMAT.TEXT || type === FORMAT.TEXTAREA) {
                    return candidate
                }
            }

            return null
        },
        activateTextLikeField(el) {
            if (!el) {
                return false
            }

            try {
                el.focus({ preventScroll: true })
            } catch (e) {
                try {
                    el.focus()
                } catch (focusError) {
                    // focus may fail if element was removed from DOM
                }
            }

            try {
                el.click()
            } catch (clickError) {
                // click may fail if element is not interactive
            }

            try {
                el.dispatchEvent(
                    new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    })
                )
            } catch (dispatchError) {
                // older WebViews may not support MouseEvent constructor
            }

            return true
        },
        focusNextLandscapeTextItem() {
            const nextItem = this.getNextLandscapeTextItem()

            if (!nextItem) {
                return false
            }

            const nextElement = document.getElementById(nextItem.item_id)
            if (!nextElement) {
                return false
            }

            const valueDiv = nextElement.querySelector('.value')
            if (!valueDiv) {
                return false
            }

            this.landscapeSuppressReopen = false
            this.landscapeDismissWithoutRefocus = true

            const activate = () => {
                this.activateTextLikeField(valueDiv)
            }

            this.$nextTick(() => {
                activate()
                setTimeout(activate, 120)
                setTimeout(activate, 320)
            })

            return true
        },
        openLandscapeTextPopup(event, id, atElement) {
            if (this.landscapeTextPopupOpen) {
                return
            }

            const self = this
            const isComment = !!atElement
            const itemType = Number(this.item.type)
            let multiline = true
            let maxlength = 512
            let inputVal = this.valueDraft !== null ? this.valueDraft : this.value != null ? String(this.value) : ''

            if (isComment) {
                maxlength = 460
                inputVal = this.commentDraft !== null ? this.commentDraft : this.comment != null ? String(this.comment) : ''
            } else if (itemType === FORMAT.TEXT) {
                multiline = false
                maxlength = 140
            } else if (itemType === FORMAT.TEXTAREA) {
                maxlength = 512
            }

            this.landscapeTextPopupOpen = true
            this.landscapeTextPopupIsComment = isComment
            this.landscapeTextPopupInputVal = inputVal || ''
            this.landscapeSourceEl = event && event.target ? event.target : null

            if (event && event.target) {
                event.target.blur()
            }

            this.$popup.textInputLandscape({
                title: self.getLandscapeTextPopupTitle(isComment),
                inputVal: inputVal || '',
                maxlength,
                multiline,
                imeAdvance: !isComment,
                callInput: function (popupSelf) {
                    if (popupSelf && typeof popupSelf.inputVal !== 'undefined') {
                        self.landscapeTextPopupInputVal = popupSelf.inputVal

                        if (isComment) {
                            self.commentDraft = popupSelf.inputVal != null ? String(popupSelf.inputVal) : ''
                        } else {
                            self.valueDraft = popupSelf.inputVal != null ? String(popupSelf.inputVal) : ''
                        }
                    }

                    self.handleInputStart()
                },
                callSave: function (popupSelf) {
                    const val = popupSelf.inputVal != null ? popupSelf.inputVal : self.landscapeTextPopupInputVal

                    if (isComment) {
                        self.saveLandscapeComment(val)
                    } else {
                        self.saveLandscapeValue(val)
                    }

                    self.handleInputEnd()
                },
                callCancel: function (popupSelf) {
                    const advance = !!(popupSelf && popupSelf.landscapeAdvanceOnClose)

                    self.landscapeTextPopupOpen = false
                    self.landscapeTextPopupIsComment = false
                    self.landscapeTextPopupInputVal = ''
                    self.$popup.close()

                    try {
                        self.$root.handleBlurKeyboard(self)
                    } catch (e) {
                        // restoring bars is non-critical; ignore if elements are missing
                    }

                    self.$nextTick(() => {
                        if (advance && !isComment && self.focusNextLandscapeTextItem()) {
                            self.landscapeDismissWithoutRefocus = false
                            return
                        }

                        if (self.landscapeSourceEl) {
                            if (self.shouldUseLandscapeTextPopup(isComment) && !self.landscapeDismissWithoutRefocus) {
                                self.landscapeSuppressReopen = true
                                try {
                                    self.landscapeSourceEl.focus({ preventScroll: true })
                                } catch (e) {
                                    // focus may fail if element was removed from DOM
                                }
                            } else {
                                self.landscapeSuppressReopen = false
                                try {
                                    self.landscapeSourceEl.blur()
                                } catch (e) {
                                    // blur may fail if element was removed from DOM
                                }
                            }
                        }

                        self.landscapeDismissWithoutRefocus = false
                    })
                }
            })

            this.$root.handleFocusKeyboard(this)
        },
        handleBlur(e) {
            this.$root.handleBlurKeyboard(this)
        },
        shouldConfirmEmptyTextReset(value) {
            const itemType = Number(this.item.type)
            const isTypeTextOrTextarea = itemType === FORMAT.TEXT || itemType === FORMAT.TEXTAREA
            const hasStoredValue = this.item.value !== null && this.item.value !== '' && this.item.value !== undefined
            return value === '' && isTypeTextOrTextarea && hasStoredValue
        },
        blurActiveTextInput() {
            const active = document.activeElement
            if (active && this.$el && this.$el.contains(active) && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA')) {
                active.blur()
            }
        },
        async confirmAndResetEmptyText() {
            if (this.isResettingTextAnswer) {
                return false
            }

            this.isResettingTextAnswer = true
            this.blurActiveTextInput()

            try {
                const confirmed = await displayPreventDeletePopup(this)
                if (!confirmed) {
                    this.valueDraftCommitted = null
                    this.valueSavePending = false
                    this.valueDraft = this.item.value != null ? String(this.item.value) : ''
                    this.$forceUpdate()
                    return false
                }

                await this.resetAnswer({ skipPreventDeletePopup: true })
                this.valueDraftCommitted = null
                this.valueSavePending = false
                const typedReplacement = this.valueDraft !== null && String(this.valueDraft).trim() !== ''
                if (!typedReplacement) {
                    this.valueDraft = null
                }
                this.$emit('acTitle')
                return true
            } finally {
                this.isResettingTextAnswer = false
            }
        },
        onOpenTextFocus(event) {
            const usePopup = this.shouldUseLandscapeTextPopup()
            if (!usePopup && this.valueDraft === null) {
                if (this.valueSavePending && this.valueDraftCommitted !== null) {
                    this.valueDraft = this.valueDraftCommitted
                } else {
                    this.valueDraft = this.item.value != null ? String(this.item.value) : ''
                    this.valueDraftCommitted = null
                }
            }
            this.handleFocus(event, this.item.item_id)
            if (!this.landscapeTextPopupOpen && !usePopup) {
                this.initInlineTextGuards(event.target)
            }
        },
        onOpenTextActivate(event) {
            if (!this.shouldUseLandscapeTextPopup()) {
                return
            }

            if (this.landscapeTextPopupOpen || this.landscapeSuppressReopen) {
                return
            }

            if (event) {
                event.preventDefault()
            }

            this.openLandscapeTextPopup(event, this.item.item_id)
        },
        onCommentActivate(event) {
            if (!this.shouldUseLandscapeTextPopup(true)) {
                return
            }

            if (this.landscapeTextPopupOpen || this.landscapeSuppressReopen) {
                return
            }

            if (event) {
                event.preventDefault()
            }

            this.openLandscapeTextPopup(event, this.item.item_id, true)
        },
        onOpenTextInput(event) {
            this.valueDraft = event.target.value
            this.handleInputStart()
        },
        onOpenTextBlur(event) {
            this.cleanupInlineTextGuards()
            if (this.navigatingViaEnter) {
                this.handleBlur(event)
                return
            }
            this.commitValueDraft()
            this.handleInputEnd(event)
        },
        initInlineTextGuards(el) {
            if (process.env.VUE_APP_IS_APP !== 'TRUE' || !el) {
                return
            }

            this.cleanupInlineTextGuards()
            this.inlineTextSourceEl = el

            const vv = window.visualViewport
            this.inlineTextFullHeight = vv ? vv.height : window.innerHeight || 0
            this.inlineTextKeyboardWasOpen = false

            if (vv) {
                this.inlineTextViewportHandler = () => {
                    this.checkInlineKeyboardHidden()
                }
                vv.addEventListener('resize', this.inlineTextViewportHandler)
            } else {
                this.inlineTextWindowResizeHandler = () => {
                    this.checkInlineKeyboardHidden()
                }
                window.addEventListener('resize', this.inlineTextWindowResizeHandler)
            }

            this.inlineTextBackButtonHandler = (e) => {
                e.preventDefault()
                e.stopImmediatePropagation()
                this.commitInlineTextFromDom()
                if (this.inlineTextSourceEl) {
                    try {
                        this.inlineTextSourceEl.blur()
                    } catch (err) {
                        // blur may fail if element was removed from DOM
                    }
                }
                this.cleanupInlineTextGuards()
            }
            document.addEventListener('backbutton', this.inlineTextBackButtonHandler, true)
        },
        cleanupInlineTextGuards() {
            if (window.visualViewport && this.inlineTextViewportHandler) {
                window.visualViewport.removeEventListener('resize', this.inlineTextViewportHandler)
                this.inlineTextViewportHandler = null
            }

            if (this.inlineTextWindowResizeHandler) {
                window.removeEventListener('resize', this.inlineTextWindowResizeHandler)
                this.inlineTextWindowResizeHandler = null
            }

            if (this.inlineTextBackButtonHandler) {
                document.removeEventListener('backbutton', this.inlineTextBackButtonHandler, true)
                this.inlineTextBackButtonHandler = null
            }

            this.inlineTextSourceEl = null
            this.inlineTextKeyboardWasOpen = false
            this.inlineTextFullHeight = 0
        },
        commitInlineTextFromDom() {
            const el = this.inlineTextSourceEl
            if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) {
                return
            }

            this.valueDraft = el.value
            this.commitValueDraft()
        },
        checkInlineKeyboardHidden() {
            const vv = window.visualViewport
            const current = vv ? vv.height : window.innerHeight || 0
            this.inlineTextFullHeight = Math.max(this.inlineTextFullHeight, current)

            const keyboardOpen = current < this.inlineTextFullHeight - 100

            if (keyboardOpen) {
                this.inlineTextKeyboardWasOpen = true
            } else if (this.inlineTextKeyboardWasOpen && !isScreenRotationInProgress()) {
                this.commitInlineTextFromDom()
                this.cleanupInlineTextGuards()
            }
        },
        onTextValueEnter() {
            // En modo popup landscape, el avance al siguiente item lo gestiona el propio popup.
            if (this.shouldUseLandscapeTextPopup()) {
                return
            }

            this.commitValueDraft()
            this.clearTypingTimer()
            this.navigatingViaEnter = true
            const navigated = this.logicItems(() => {
                this.navigatingViaEnter = false
                this.endTypingState()
            })
            if (!navigated) {
                this.navigatingViaEnter = false
                this.endTypingState()
            }
        },
        onCommentFocus(event) {
            if (this.commentDraft === null) {
                if (this.commentSavePending && this.commentDraftCommitted !== null) {
                    this.commentDraft = this.commentDraftCommitted
                } else {
                    this.commentDraft = this.item.message ? this.item.message : ''
                    this.commentDraftCommitted = null
                }
            }
            this.handleFocus(event, this.item.item_id, true)
        },
        onCommentInput(event) {
            this.calculedLength(event)
            this.commentDraft = event.target.value
            this.handleInputStart()
        },
        commitValueDraft() {
            const storedValue = this.item.value != null ? String(this.item.value) : ''
            let draft = this.valueDraft

            if (draft === null) {
                if (!this.valueSavePending || this.valueDraftCommitted === null) {
                    return
                }
                draft = this.valueDraftCommitted
            }

            if (this.shouldConfirmEmptyTextReset(draft)) {
                if (this.isResettingTextAnswer) {
                    return
                }
                this.confirmAndResetEmptyText()
                return
            }

            if (!this.valueSavePending && String(draft) === storedValue) {
                this.valueDraft = null
                this.valueDraftCommitted = null
                return
            }

            if (this.valueSavePending && this.valueDraftCommitted !== null && String(this.valueDraftCommitted) === String(draft)) {
                this.value = draft
                return
            }

            this.valueDraftCommitted = draft
            this.valueSavePending = true
            this.value = draft
        },
        commitCommentDraft() {
            const storedMessage = this.item.message ? this.item.message : ''
            let draft = this.commentDraft

            if (draft === null) {
                if (!this.commentSavePending || this.commentDraftCommitted === null) {
                    return
                }
                draft = this.commentDraftCommitted
            }

            if (!this.commentSavePending && String(draft) === String(storedMessage)) {
                this.commentDraft = null
                this.commentDraftCommitted = null
                return
            }

            if (this.commentSavePending && this.commentDraftCommitted !== null && String(this.commentDraftCommitted) === String(draft)) {
                this.comment = draft
                return
            }

            this.commentDraftCommitted = draft
            this.commentSavePending = true
            this.comment = draft
        },
        saveLandscapeComment(val) {
            const normalized = val != null ? String(val) : ''
            this.commentDraft = normalized
            this.commentDraftCommitted = normalized
            this.commentSavePending = true
            this.comment = normalized
        },
        saveLandscapeValue(val) {
            const normalized = val != null ? String(val) : ''
            this.valueDraft = normalized
            this.valueDraftCommitted = normalized
            this.valueSavePending = true
            this.value = normalized
        },
        onCommentBlur(event) {
            this.commitCommentDraft()
            this.handleInputEnd(event)
        },
        clearTypingTimer() {
            if (this.typingTimer) {
                clearTimeout(this.typingTimer)
                this.typingTimer = null
            }
        },
        endTypingState() {
            this.clearTypingTimer()
            this.$store.commit('tasks/setIsUserTyping', false)
        },
        handleInputStart() {
            // Limpiar el timer anterior si existe
            if (this.typingTimer) {
                clearTimeout(this.typingTimer)
            }

            // Setear el estado a true (usuario está escribiendo)
            this.$store.commit('tasks/setIsUserTyping', true)

            // Crear un nuevo timer que se ejecutará cuando el usuario deje de escribir
            this.typingTimer = setTimeout(() => {
                this.handleInputEnd()
            }, 800) // 800ms después de la última tecla presionada
        },
        handleInputEnd(e) {
            this.endTypingState()

            // Si viene del evento blur, ejecutar la lógica original
            if (e) {
                this.handleBlur(e)
            }
        },
        logicItems(onNavigationComplete) {
            const completeNavigation = () => {
                if (typeof onNavigationComplete === 'function') {
                    onNavigationComplete()
                }
            }

            if (this.list && this.list.items) {
                let itemsArray = []
                let currentIndex = -1

                if (typeof this.list.items === 'object' && !Array.isArray(this.list.items)) {
                    itemsArray = Object.keys(this.list.items).map((key) => this.list.items[key])
                } else if (Array.isArray(this.list.items)) {
                    itemsArray = this.list.items
                }

                currentIndex = itemsArray.findIndex((item) => item && item.item_id === this.item.item_id)
                const nextItem = itemsArray[currentIndex + 1]
                const textValue = this.valueDraft !== null ? this.valueDraft : this.item.value
                if (currentIndex !== -1 && currentIndex < itemsArray.length - 1) {
                    if (this.item.type === FORMAT.TEXT && textValue && String(textValue).trim() !== '') {
                        if (nextItem && nextItem.type === FORMAT.NUMBER) {
                            this.$nextTick(() => {
                                const nextElement = document.getElementById(nextItem.item_id)
                                if (nextElement) {
                                    const valueDiv = nextElement.querySelector('.value')
                                    if (valueDiv) {
                                        setTimeout(() => {
                                            valueDiv.click()
                                            completeNavigation()
                                        }, 1000)
                                        return
                                    }
                                }
                                completeNavigation()
                            })
                            return true
                        } else if (nextItem && (nextItem.type === FORMAT.TEXT || nextItem.type === FORMAT.TEXTAREA)) {
                            this.$nextTick(() => {
                                const nextElement = document.getElementById(nextItem.item_id)
                                if (nextElement) {
                                    const valueDiv = nextElement.querySelector('.value')
                                    if (valueDiv) {
                                        this.activateTextLikeField(valueDiv)
                                    }
                                }
                                completeNavigation()
                            })
                            return true
                        } else if (nextItem && nextItem.type === FORMAT.TEMPERATURE) {
                            this.$nextTick(() => {
                                const nextElement = document.getElementById(nextItem.item_id)
                                if (nextElement) {
                                    const valueDiv = nextElement.querySelector('.value')
                                    if (valueDiv) {
                                        setTimeout(() => {
                                            valueDiv.click()
                                            completeNavigation()
                                        }, 1000)
                                        return
                                    }
                                }
                                completeNavigation()
                            })
                            return true
                        }
                    } else if (this.item.type === FORMAT.NUMBER) {
                        if (nextItem && (nextItem.type === FORMAT.TEXT || nextItem.type === FORMAT.TEXTAREA)) {
                            this.$nextTick(() => {
                                const nextElement = document.getElementById(nextItem.item_id)
                                if (nextElement) {
                                    const valueDiv = nextElement.querySelector('.value')
                                    if (valueDiv) {
                                        this.activateTextLikeField(valueDiv)
                                    }
                                }
                                completeNavigation()
                            })
                            return true
                        }
                    }
                }
            }

            return false
        },
        checkAvailability() {
            if (!this.list.limit.start || !this.list.limit.end) {
                return ''
            }

            const formatTimingTime = (value) => formatDisplayTimeFromStore(value, { emptyValue: '' })
            const formatTimingDateTime = (value, { hourSuffix = false } = {}) => formatDisplayDateTimeFromStore(value, { emptyValue: '', hourSuffix })
            const isSameCalendarDay = (left, right) => moment(left).isSame(moment(right), 'day')

            let finalPhrase = (isSameCalendarDay(this.list.limit.start, this.list.business_date) ? formatTimingTime(this.list.limit.start) : formatTimingDateTime(this.list.limit.start)) + ' ' + this.$tc('assets.timing.to') + ' '

            if (!isSameCalendarDay(this.list.limit.end, this.list.business_date)) {
                finalPhrase += formatTimingDateTime(this.list.limit.end)
            } else {
                finalPhrase += formatTimingTime(this.list.limit.end)
            }

            return finalPhrase
        },
        // CHECKACCESS Valida si se puede o no realizar una accion
        async checkAccess(val, isNote) {
            const self = this
            const type = self.item.type
            const toolType = self.cType

            if (this.isActionPlanCompleted || this.isAuditItemInActionPlanChecklist) {
                return
            }

            if (this.isDeadlineEnded) {
                this.showDeadlineEndedAlert()
                return
            }

            // almacena el numero anterior al input
            if (this.item.type === FORMAT.NUMBER) {
                self.oldNumericValue = self.item.value
            }

            // ONLY FOR AUDIT ITEM that:
            // has a value (not null or Undefined)
            // has an ACTION PLAN RELATED
            if (toolType === TYPE.AUDIT && self.item.value !== null && self.item.value !== undefined && self.itemHasActionPlan) {
                // to prevent the Action Plan Delete Confirmation popup from appearing when trying to add a note
                if (isNote) {
                    return
                }

                // only for items type selector
                if (self.item.type == FORMAT.MULTIPLE) {
                    const newValue = val
                    const currentItemValue = self.item.value

                    const isResetValue = newValue === null || newValue === ''

                    if ((newValue && newValue !== currentItemValue) || isResetValue) {
                        // isResetValue por si el usuario hace click en "No value selected" en el popup del selector
                        // (para que en este caso también se muestre el popup de confirmación de borrado del Plan de Acción)

                        // IMPORTANTE: no debe entrar por aquí si newValue es undefined
                        // ya que si es así se mostrarían superpuestos los dos popups (el de borrado del Plan de Acción y el del selector)
                        const newAnswerTriggersSameActionPlan = this.checkIfNewAnswerTriggersSameActionPlan(newValue)

                        if (!newAnswerTriggersSameActionPlan) {
                            const actionPlanWasDeleted = await this.displayDeleteActionPlanConfirmPopup()

                            if (actionPlanWasDeleted) {
                                const subitemsThatNotMeetCondition = this.subitemsThatNotMeetCondition(newValue)

                                // only for subitems that no longer meet the condition to be displayed
                                if (subitemsThatNotMeetCondition && subitemsThatNotMeetCondition.length > 0) {
                                    // reset subitems that not meet the condition
                                    this.resetItems(subitemsThatNotMeetCondition)
                                }
                            } else {
                                return false
                            }
                        }
                    }
                } else {
                    // BUILD-6167 #37879: mantenemos la lógica que ya teníamos para el resto de items que no son selector:
                    // for all item types except photo or gallery (because is necessary to always show the image popup)
                    if (self.item.type != FORMAT.PHOTO) {
                        const actionPlanWasDeleted = await this.displayDeleteActionPlanConfirmPopup()

                        if (actionPlanWasDeleted === false) {
                            return
                        } else {
                            this.resetAnswer()
                            return
                        }
                    }
                }
            }

            // For the audit, if the user is not the one who created the template can't modify the item
            if (toolType === 2 && !this.isCreator) {
                return
            }

            if (this.isDisabled) {
                if (this.isDisabled == 'future') {
                    let text = this.checkAvailability()
                    this.$popup.alert({
                        message: this.$t('detail.checklist.future', { name: self.user.name, date: text })
                    })
                }

                if (this.isDisabled == 'past' && this.list.type == 2 && this.cType !== 5) {
                    this.$popup.alert({ message: this.$t('detail.audit.past', { name: self.user.name }) })
                } else if (this.isDisabled == 'past' || (this.isPast && !this.def.can_edit.inPast)) {
                    this.$popup.alert({ message: this.$t('answer.timing.cannot_past') })
                } else if (this.isFuture && !this.def.can_edit.inFuture) {
                    this.$popup.alert({ message: this.$t('answer.timing.cannot_future') })
                } else if (this.isIssueClosed) {
                    this.$popup.alert({ message: this.$t('answer.issue_closed', { name: self.user.name }) })
                } else if (this.isRegisterClosed) {
                    this.$popup.alert({ message: this.$t('answer.no_access_register', { name: self.user.name }) })
                } else {
                    this.$popup.alert({ message: this.$t('answer.no_access_app', { name: self.user.name }) })
                }
            } else if (!this.hasValidPermissions()) {
                if (self.rolesWithWritePermissions()) {
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: self.user.name,
                            roles: self.rolesWithWritePermissions()
                        })
                    })
                } else {
                    this.$popup.alert({
                        message: this.$t('home.permissions_messages.no_edit', {
                            name: this.user.name
                        })
                    })
                }
            } else if (!this.hasValidRole()) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role', {
                        name: self.user.name,
                        roles: self.getStringLimitRoles(self.item.config.roles)
                    })
                })
                // return false
            } else if (this.hasDependency_tpl) {
                this.$popup.confirm({
                    message: self.$t('answer.dependency.label', { name: self.user.name, tpl: self.hasDependency_tpl.title }),
                    textSave: self.$t('answer.dependency.view'),
                    textCancel: self.$t('popup.default.text_close'),
                    callSave: function () {
                        self.$emit('cleanDependency')
                        self.$router.push({ name: 'ChecklistDetail', params: { id: self.hasDependency_tpl.id } })
                    }
                })
            } else if (this.item.require_pin && this.loggedUser && !this.isReview && this.canBeEdited) {
                if (!this.hasAccess) {
                    this.$popup.access({
                        list: this.$store.getters['employee/getAccessUsers'](0),
                        callAfterAccess: function (response) {
                            if (response) {
                                if (response.status) {
                                    self.hasAccess = true
                                    self.userAccess = response.emp_id
                                    self.$popup.close()

                                    if (type == 1) self.qCheck(val)
                                    if (type == 2 || type == 3) self.qOption(val)
                                    if (type == 6) self.qNumeric()
                                    if (type == 14) self.qSignature()
                                    if (type == 15) self.qTemperature()
                                    if (type == 16) self.qSendMail()
                                    if (type == 1) self.qDocument(val)
                                    if (type == 19) self.qLink()
                                }
                            }
                        }
                    })
                } else {
                    if (type == 1) self.qCheck(val)
                    if (type == 2 || type == 3) self.qOption(val)
                    if (type == 6) self.qNumeric()
                    if (type == 14) self.qSignature()
                    if (type == 15) self.qTemperature()
                    if (type == 16) self.qSendMail()
                    if (type == 1) self.qDocument(val)
                    if (type == 19) self.qLink()
                }
            } else if (!this.item.require_pin && this.loggedUser && this.canBeEdited) {
                this.hasAccess = true

                if (!isNote) {
                    if (type == 1) {
                        this.qCheck(val)
                    } else if (type == 2 || type == 3) {
                        this.qOption(val)
                    } else if (type == 6) {
                        this.qNumeric()
                    } else if (type == 14) {
                        this.qSignature()
                    } else if (type == 15) {
                        this.qTemperature()
                    } else if (type == 16) {
                        this.qSendMail()
                    } else if (type == 1) {
                        this.qDocument(val)
                    } else if (type == 19) {
                        this.qLink()
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            } else if (!this.loggedUser && !this.isReview && this.canBeEdited) {
                this.$popup.login({
                    list: this.$store.getters['employee/getLoginUsers'](1),
                    callAfterAccess: function (response) {
                        if (response) {
                            if (!self.hasAccess) {
                                self.checkAccess()
                            } else {
                                self.$popup.close()
                            }
                        }
                    }
                })
            } else {
                return true
            }
        },
        hasValidPermissions() {
            // En el plan de acción los permisos se resuelven en la vista padre y llegan por prop
            if (this.permissions !== null && this.permissions !== undefined) {
                return this.permissions
            }

            const checklist = this.list

            if (!checklist) {
                return false
            }

            // Validar que el usuario existe
            if (!this.user || !this.user.rol) {
                return false
            }

            const employeeRole = this.$store.getters['employee/getRol'](this.user.rol)

            // Validar que el rol existe
            if (!employeeRole) {
                return false
            }

            // Si el objeto config no existe o no tiene nRoles/roles, permitir edición (comportamiento por defecto)
            if (!checklist.config || (!checklist.config.nRoles && !checklist.config.roles)) {
                return true
            }

            // Si existe config.nRoles, verificar permisos según roles
            if (checklist.config.nRoles && checklist.config.nRoles.length > 0) {
                // Si el nivel del empleado es mayor o igual a 8, se considera válido
                if (employeeRole.level >= 8) {
                    return true
                }

                return checklist.config.nRoles.some((role) => {
                    return this.user.rol == role.roleId && role.permissions && role.permissions.includes('w')
                })
            }

            // Si existe config.roles (formato antiguo), mantener compatibilidad
            if (checklist.config.roles && checklist.config.roles.length > 0) {
                // Si el nivel del empleado es mayor o igual a 8, se considera válido
                if (employeeRole.level >= 8) {
                    return true
                }
                return checklist.config.roles.includes(this.user.rol)
            }

            return true
        },
        rolesWithWritePermissions() {
            const permissions = this.list
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('w')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        canClicked(val, isNote) {
            const self = this
            const type = this.item.type

            if (this.isActionPlanCompleted || this.isDeadlineEnded) {
                return false
            }

            if (!this.hasValidPermissions()) {
                return false
            }

            // don't allow to answer Audit Items in Action Plan checklist
            if (self.isAuditItemInActionPlanChecklist) {
                return false
            }

            if (this.isDisabled) {
                if (this.isDisabled == 'future') {
                    return false
                }

                if (this.isDisabled == 'past' && this.list.type == 2) {
                    return false
                } else if (this.isDisabled == 'past' || (this.isPast && !this.def.can_edit.inPast)) {
                    return false
                } else if (this.isFuture && !this.def.can_edit.inFuture) {
                    return false
                } else if (this.isIssueClosed || this.isRegisterClosed) {
                    return false
                } else {
                    return false
                }
            } else if (!this.hasValidRole()) {
                return false
                // return false
            } else if (this.hasDependency_tpl) {
                return false
            } else if (!this.isCreator) {
                return false
            } else if (this.item.require_pin && this.loggedUser && !this.isReview && this.canBeEdited) {
                if (!this.hasAccess) {
                    this.$popup.access({
                        list: this.$store.getters['employee/getAccessUsers'](0),
                        callAfterAccess: function (response) {
                            if (response) {
                                if (response.status) {
                                    self.hasAccess = true
                                    self.userAccess = response.emp_id
                                    self.$popup.close()

                                    if (type == 1) self.qCheck(val)
                                    if (type == 2 || type == 3) self.qOption(val)
                                    if (type == 6) self.qNumeric()
                                    if (type == 14) self.qSignature()
                                    if (type == 15) self.qTemperature()
                                    if (type == 16) self.qSendMail()
                                    if (type == 1) self.qDocument(val)
                                    if (type == 19) self.qLink()
                                }
                            }
                        }
                    })
                } else {
                    if (type == 1) self.qCheck(val)
                    if (type == 2 || type == 3) self.qOption(val)
                    if (type == 6) self.qNumeric()
                    if (type == 14) self.qSignature()
                    if (type == 15) self.qTemperature()
                    if (type == 16) self.qSendMail()
                    if (type == 1) self.qDocument(val)
                    if (type == 19) self.qLink()
                }
            } else if (!this.item.require_pin && this.loggedUser && this.canBeEdited) {
                this.hasAccess = true
                if (!isNote) {
                    if (type == 1) {
                        this.qCheck(val)
                    } else if (type == 2 || type == 3) {
                        this.qOption(val)
                    } else if (type == 6) {
                        this.qNumeric()
                    } else if (type == 14) {
                        this.qSignature()
                    } else if (type == 15) {
                        this.qTemperature()
                    } else if (type == 16) {
                        this.qSendMail()
                    } else if (type == 1) {
                        this.qDocument(val)
                    } else if (type == 19) {
                        this.qLink()
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            } else if (!this.loggedUser && !this.isReview && this.canBeEdited) {
                return false
            } else {
                return true
            }
        },
        qCheck(newVal) {
            if (!this.isDisabled || this.isDisabled == 'no_access_app') {
                if (newVal && newVal != '') {
                    this.value = newVal
                } else {
                    this.resetAnswer()
                }
            }
        },
        qOption(newVal) {
            if (!this.isDisabled) {
                if (newVal != this.value) {
                    this.value = newVal
                } else {
                    this.resetAnswer()
                }
            }
        },
        qMultiple(newVal) {
            const value = this.item.value
            this.$nextTick(async () => {
                let access = await this.checkAccess(newVal)

                if (!access) {
                    this.item.value = null
                    this.$nextTick(() => {
                        this.item.value = value
                        if (this.itemHasActionPlan) {
                            this.reopenSelectorPopup()
                        }
                    })
                    return
                }

                if (this.item.value == newVal) {
                    return
                }

                if (!this.isDisabled) {
                    if (!newVal) {
                        this.resetAnswer()
                    } else {
                        this.value = newVal
                    }
                }
            })
        },
        qImagePreview(pos, force = false) {
            // let self = this

            const hasImage = this.value && typeof this.value[pos] !== 'undefined' && this.value[pos] != false && this.value[pos] != null

            if (this.isNcSubsubitemInActionPlan && !hasImage) {
                return
            }

            // don't show the delete button if this photo belongs to the non-conformity block on the Action Plan page
            if (this.isAuditItemInActionPlanChecklist) {
                if (!this.value || typeof this.value[pos] === 'undefined' || !this.value[pos]) {
                    return
                }

                this.$popup.media({
                    image: this.value[pos],
                    showDeleteButton: false
                })
                // const auditStatus = this.list.status

                // Auditorías finalizadas
                // if (auditStatus === 'completed') {
                // this.$popup.alert({ message: this.$t('detail.audit.past', { name: this.user.name }) })
                // return
                // Auditorías en progreso
                // } else {
                // this.$popup.alert({ message: this.$t('popup.action_plan_audit_item_not_allowed.message') })
                //     this.$popup.media({
                //         image: this.value[pos],
                //         showDeleteButton: false
                //     })
                //     return
                // }
                return
            }

            if (this.isOnline && ((typeof this.value[pos] !== 'undefined' && this.value[pos] != false) || force)) {
                this.$popup.media({
                    image: this.value[pos],
                    showDeleteButton: !this.isDisabled,
                    callDelete: () => {
                        this.$popup.close()

                        if (this.isDisabled) {
                            return
                        }

                        if (this.checkAccess()) {
                            const galleryCopy = Array.from(this.value)

                            galleryCopy.splice(pos, 1)

                            let value = Array.from(galleryCopy)

                            if (value && value.length <= 0) {
                                this.resetAnswer()
                            } else {
                                this.value = Array.from(value)
                            }
                        }
                    }
                })
            }
        },
        qImageDelete(pos) {
            if (!this.isDisabled) {
                let self = this

                this.$popup.confirm({
                    message: self.$t('popup.delete.title'),
                    textSave: self.$t('popup.delete.text_save'),
                    textCancel: self.$t('popup.delete.text_cancel'),
                    callSave: function () {
                        if (self.value && self.value.length <= 1) {
                            self.resetAnswer()
                        } else {
                            let aux = self.value
                            aux.splice(pos, 1)
                            self.value = JSON.parse(JSON.stringify(aux))
                        }
                    }
                })
            }
        },
        qImageReload(e) {
            if (this.isAuditItemInActionPlanChecklist) {
                e.target.value = ''
                return
            }

            const isOfflineActive = this.$store.getters.getOffline
            let self = this
            let valueItem = JSON.parse(JSON.stringify(this.value))

            let selectedFiles = Array.from(e.target.files)
            const photoLimit = parseInt(self.aConfig && self.aConfig.limit, 10)
            const maxSelectable = Number.isFinite(photoLimit) && photoLimit >= 1 ? photoLimit : 5

            if (selectedFiles.length > maxSelectable) {
                self.$popup.alert({ message: self.$t('answer.galery.message') })
                e.target.value = ''
                return
            }

            if (!self.isDisabled) {
                if (!valueItem || valueItem.length <= 0) {
                    valueItem = []
                }
                if (fnCheckConnection() || isOfflineActive) {
                    const files = e.target.files || e.dataTransfer.files
                    const totalFiles = valueItem.length + files.length
                    if (typeof self.aConfig.limit === 'undefined' || totalFiles <= self.aConfig.limit || self.aConfig.limit == 1) {
                        if (!files.length) return
                        ;(async function processFiles() {
                            for (const file of files) {
                                await new Promise((resolve) => {
                                    const image = new Image()
                                    const reader = new FileReader()

                                    reader.onload = (e) => {
                                        image.onload = () => {
                                            if (self.aConfig.limit == 1) {
                                                valueItem = []
                                            }

                                            valueItem.push(self.resizeImage(image))
                                            self.value = JSON.parse(JSON.stringify(valueItem))
                                            resolve()
                                        }
                                        image.src = e.target.result
                                    }
                                    reader.readAsDataURL(file)
                                })
                            }
                        })()
                    } else {
                        self.$popup.alert({ message: self.$t('answer.galery.message') })
                    }
                }
            }
        },
        resizeImage(image) {
            const maxWidth = andyImageLimit.width
            const maxHeight = andyImageLimit.height

            let newWidth, newHeight

            if (image.width > image.height) {
                newWidth = maxWidth
                newHeight = (image.height / image.width) * maxWidth
            } else {
                newHeight = maxHeight
                newWidth = (image.width / image.height) * maxHeight
            }

            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')

            canvas.width = newWidth
            canvas.height = newHeight

            ctx.drawImage(image, 0, 0, newWidth, newHeight)

            const newImage = canvas.toDataURL('image/webp', 0.6)

            return newImage
        },

        capture(e, type) {
            const isComment = type === 'comment'

            if (this.isAuditItemInActionPlanChecklist && !isComment) {
                return
            }

            const isOfflineActive = this.$store.getters.getOffline

            if ((fnCheckConnection() || isOfflineActive) && this.checkAccess(true, isComment)) {
                if (process.env.VUE_APP_IS_APP == 'TRUE') {
                    var self = this

                    e.preventDefault()
                    e.stopPropagation()
                    var self = this

                    var cameraOptions = {
                        destinationType: 1,
                        quality: 50,
                        encodingType: 0, // JEPG
                        targetWidth: andyImageLimit.width,
                        targetHeight: andyImageLimit.height,
                        correctOrientation: true
                    }

                    const check = isComment ? this.$store.getters.getNoteImg : this.item.config.capture
                    let valueItem = JSON.parse(JSON.stringify(this.value))
                    if (!isComment && typeof self.aConfig.limit !== 'undefined' && valueItem && valueItem.length >= self.aConfig.limit && self.aConfig.limit != 1) {
                        this.$popup.alert({ message: this.$t('answer.galery.message') })
                    } else {
                        if (!check || check === 'all') {
                            this.$popup.confirmUpload({
                                message: this.$t('cordova.plugins.camera.title'),
                                textSaveStart: this.$t('cordova.plugins.camera.text_camera'),
                                textSave: this.$t('cordova.plugins.camera.text_library'),
                                callSaveStart: function () {
                                    if (fnCheckConnection() || isOfflineActive) {
                                        if (false && self.$store.getters.getIsAndroid) {
                                            self.captureNative(type)
                                        } else {
                                            navigator.camera.getPicture(
                                                function (imageData) {
                                                    if (true || fnCheckConnection()) {
                                                        getFileContentAsBase64(
                                                            imageData,
                                                            function (base64Image) {
                                                                // Then you'll be able to handle the myimage.png file as base64
                                                                imageData = base64Image

                                                                var bgImg = new Image()
                                                                bgImg.onload = function () {
                                                                    switch (type) {
                                                                        case 'answer':
                                                                            let aux = self.value
                                                                            if (!aux) {
                                                                                aux = []
                                                                            }
                                                                            aux.push(bgImg.src)
                                                                            self.value = JSON.parse(JSON.stringify(aux))
                                                                            // self.value.push(bgImg.src);
                                                                            break
                                                                        case 'comment':
                                                                            self.image = bgImg.src
                                                                            break
                                                                    }
                                                                }
                                                                bgImg.src = imageData
                                                            },
                                                            function (err) {
                                                                self.$snackbar.error({
                                                                    closeable: true,
                                                                    message: self.$t('popup.media.image_empty')
                                                                })
                                                            }
                                                        )
                                                    } else {
                                                        self.$snackbar.error({
                                                            duration: 5000,
                                                            closeable: true,
                                                            message: self.$t('empty_pages.connection_description')
                                                        })
                                                    }
                                                },
                                                function (message) {
                                                    if (message.toLowerCase() == 'no image selected') {
                                                        return true
                                                    }
                                                    self.$snackbar.error({
                                                        closeable: true,
                                                        message: self.$t('popup.media.image_empty')
                                                    })
                                                },
                                                cameraOptions
                                            )
                                        }
                                    } else {
                                        this.$snackbar.error({
                                            duration: 5000,
                                            closeable: true,
                                            message: this.$t('empty_pages.connection_description')
                                        })
                                    }
                                },
                                callSave: function () {
                                    cameraOptions.sourceType = 0
                                    if (fnCheckConnection() || isOfflineActive) {
                                        if (false && self.$store.getters.getIsAndroid) {
                                            self.captureNativeGallery(type)
                                        } else {
                                            navigator.camera.getPicture(
                                                function (imageData) {
                                                    if (true || fnCheckConnection()) {
                                                        getFileContentAsBase64(
                                                            imageData,
                                                            function (base64Image) {
                                                                // Then you'll be able to handle the myimage.png file as base64
                                                                imageData = base64Image

                                                                var bgImg = new Image()
                                                                bgImg.onload = function () {
                                                                    switch (type) {
                                                                        case 'answer':
                                                                            let aux = self.value
                                                                            if (!aux) {
                                                                                aux = []
                                                                            }
                                                                            aux.push(bgImg.src)
                                                                            self.value = JSON.parse(JSON.stringify(aux))
                                                                            // self.value.push(bgImg.src);
                                                                            break
                                                                        case 'comment':
                                                                            self.image = bgImg.src
                                                                            break
                                                                    }
                                                                }
                                                                bgImg.src = imageData
                                                            },
                                                            function (err) {
                                                                self.$snackbar.error({
                                                                    closeable: true,
                                                                    message: self.$t('popup.media.image_empty')
                                                                })
                                                            }
                                                        )
                                                    } else {
                                                        self.$snackbar.error({
                                                            duration: 5000,
                                                            closeable: true,
                                                            message: self.$t('empty_pages.connection_description')
                                                        })
                                                    }
                                                },
                                                function (message) {
                                                    if (message.toLowerCase() == 'no image selected') {
                                                        return true
                                                    }
                                                    self.$snackbar.error({
                                                        closeable: true,
                                                        message: self.$t('popup.media.image_empty')
                                                    })
                                                },
                                                cameraOptions
                                            )
                                        }
                                    } else {
                                        this.$snackbar.error({
                                            duration: 5000,
                                            closeable: true,
                                            message: this.$t('empty_pages.connection_description')
                                        })
                                    }
                                }
                            })
                        } else if (this.item.config.capture == 'camera') {
                            this.$popup.confirm({
                                message: this.$t('cordova.plugins.camera.title'),
                                textSave: this.$t('cordova.plugins.camera.text_camera'),
                                callSave: function () {
                                    if (fnCheckConnection() || isOfflineActive) {
                                        if (false && self.$store.getters.getIsAndroid) {
                                            self.captureNative(type)
                                        } else {
                                            navigator.camera.getPicture(
                                                function (imageData) {
                                                    if (true || fnCheckConnection()) {
                                                        getFileContentAsBase64(
                                                            imageData,
                                                            function (base64Image) {
                                                                // Then you'll be able to handle the myimage.png file as base64
                                                                imageData = base64Image

                                                                var bgImg = new Image()
                                                                bgImg.onload = function () {
                                                                    switch (type) {
                                                                        case 'answer':
                                                                            let aux = self.value
                                                                            if (!aux) {
                                                                                aux = []
                                                                            }
                                                                            aux.push(bgImg.src)
                                                                            self.value = JSON.parse(JSON.stringify(aux))
                                                                            // self.value.push(bgImg.src);
                                                                            break
                                                                        case 'comment':
                                                                            self.image = bgImg.src
                                                                            break
                                                                    }
                                                                }
                                                                bgImg.src = imageData
                                                            },
                                                            function (err) {
                                                                self.$snackbar.error({
                                                                    closeable: true,
                                                                    message: self.$t('popup.media.image_empty')
                                                                })
                                                            }
                                                        )
                                                    } else {
                                                        self.$snackbar.error({
                                                            duration: 5000,
                                                            closeable: true,
                                                            message: self.$t('empty_pages.connection_description')
                                                        })
                                                    }
                                                },
                                                function (message) {
                                                    if (message.toLowerCase() == 'no image selected') {
                                                        return true
                                                    }
                                                    self.$snackbar.error({
                                                        closeable: true,
                                                        message: self.$t('popup.media.image_empty')
                                                    })
                                                },
                                                cameraOptions
                                            )
                                        }
                                    } else {
                                        this.$snackbar.error({
                                            duration: 5000,
                                            closeable: true,
                                            message: this.$t('empty_pages.connection_description')
                                        })
                                    }
                                }
                            })
                        } else if (this.item.config.capture == 'gallery') {
                            this.$popup.confirm({
                                message: this.$t('cordova.plugins.camera.title'),
                                textSave: this.$t('cordova.plugins.camera.text_library'),
                                callSave: function () {
                                    cameraOptions.sourceType = 0
                                    if (fnCheckConnection() || isOfflineActive) {
                                        if (self.$store.getters.getIsAndroid) {
                                            self.captureNativeGallery(type)
                                        } else {
                                            navigator.camera.getPicture(
                                                function (imageData) {
                                                    if (true || fnCheckConnection()) {
                                                        imageData = 'data:image/webp;base64,' + imageData
                                                        var bgImg = new Image()
                                                        bgImg.onload = function () {
                                                            switch (type) {
                                                                // TODO revisar
                                                                case 'answer':
                                                                    let aux = self.value
                                                                    if (!aux) {
                                                                        aux = []
                                                                    }
                                                                    aux.push(bgImg.src)
                                                                    self.value = JSON.parse(JSON.stringify(aux))
                                                                    // self.value.push(bgImg.src);
                                                                    break
                                                                case 'comment':
                                                                    self.image = bgImg.src
                                                                    break
                                                            }
                                                        }
                                                        bgImg.src = imageData
                                                    } else {
                                                        self.$snackbar.error({
                                                            duration: 5000,
                                                            closeable: true,
                                                            message: self.$t('empty_pages.connection_description')
                                                        })
                                                    }
                                                },
                                                function (message) {
                                                    if (message.toLowerCase() == 'no image selected') {
                                                        return true
                                                    }
                                                    self.$snackbar.error({
                                                        closeable: true,
                                                        message: self.$t('popup.media.image_empty')
                                                    })
                                                },
                                                cameraOptions
                                            )
                                        }
                                    } else {
                                        this.$snackbar.error({
                                            duration: 5000,
                                            closeable: true,
                                            message: this.$t('empty_pages.connection_description')
                                        })
                                    }
                                }
                            })
                        }
                    }
                }
            } else if (!isOfflineActive) {
                e.preventDefault()
                e.stopPropagation()
                this.$snackbar.error({ duration: 5000, closeable: true, message: this.$t('empty_pages.connection_description') })
            }
        },
        captureNativeGallery(type) {
            var self = this
            var input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'
            input.capture = 'camera'

            input.onchange = function (ev) {
                const file = ev.target.files[0] // get the file
                const blobURL = URL.createObjectURL(file)
                const img = new Image()
                img.src = blobURL
                img.onerror = function () {
                    URL.revokeObjectURL(this.src)
                    // Handle the failure properly
                    self.$snackbar.error({ closeable: true, message: self.$t('popup.media.image_empty') })
                }
                img.onload = function () {
                    URL.revokeObjectURL(this.src)
                    const [newWidth, newHeight] = calculateImgSize(img, andyImageLimit.width, andyImageLimit.height)
                    const canvas = document.createElement('canvas')
                    canvas.width = newWidth
                    canvas.height = newHeight
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(img, 0, 0, newWidth, newHeight)
                    canvas.toBlob(
                        (blob) => {
                            // Handle the compressed image. es. upload or save in local state
                            displayFileInfo('Original file', file)
                            displayFileInfo('Compressed file', blob)
                            var reader = new FileReader()
                            reader.readAsDataURL(blob)
                            reader.onloadend = function () {
                                var base64data = reader.result
                                switch (type) {
                                    case 'answer':
                                        let aux = self.value
                                        if (!aux) {
                                            aux = []
                                        }
                                        aux.push(base64data)
                                        self.value = JSON.parse(JSON.stringify(aux))
                                        break
                                    case 'comment':
                                        self.image = base64data
                                        break
                                }
                            }
                        },
                        andyImageLimit.mime,
                        andyImageLimit.quality
                    )
                }
            }

            input.click()
        },
        captureNative(type) {
            var self = this
            this.$overlay.loading()
            this.$store.commit('setCameraActive', true)
            var imageCapture
            var track
            var currentCamera = 'back'
            var flash = false
            var currentZoom = 1
            var minZoom = 1
            var maxZoom = 10

            setTimeout(function () {
                navigator.mediaDevices
                    .getUserMedia({ video: { facingMode: { exact: 'environment' } } })
                    .then((mediaStream) => {
                        track = mediaStream.getVideoTracks()[0]
                        let capabilities = track.getCapabilities()
                        if (capabilities.zoom) {
                            // Configura el control de zoom con los rangos soportados
                            const zoomControl = document.getElementById('zoom-camera')
                            minZoom = capabilities.zoom.min
                            maxZoom = capabilities.zoom.max
                            currentZoom = track.getSettings().zoom || capabilities.zoom.min

                            // Cambia el zoom al mover el slider
                            zoomControl.removeEventListener('click', async () => {
                                if (currentZoom == minZoom) {
                                    if (currentZoom * 2 < maxZoom) {
                                        currentZoom = currentZoom * 2
                                        self.$store.commit('setCameraCurrentZoom', 'x2')
                                    } else {
                                        currentZoom = maxZoom
                                        self.$store.commit('setCameraCurrentZoom', 'x5')
                                    }
                                } else if (currentZoom == maxZoom) {
                                    currentZoom = minZoom
                                    self.$store.commit('setCameraCurrentZoom', 'x1')
                                } else {
                                    currentZoom = maxZoom
                                    self.$store.commit('setCameraCurrentZoom', 'x5')
                                }
                                track.applyConstraints({ advanced: [{ zoom: currentZoom }] })
                            })
                            zoomControl.addEventListener('click', async () => {
                                if (currentZoom == minZoom) {
                                    if (currentZoom * 2 < maxZoom) {
                                        currentZoom = currentZoom * 2
                                        self.$store.commit('setCameraCurrentZoom', 'x2')
                                    } else {
                                        currentZoom = maxZoom
                                        self.$store.commit('setCameraCurrentZoom', 'x5')
                                    }
                                } else if (currentZoom == maxZoom) {
                                    currentZoom = minZoom
                                    self.$store.commit('setCameraCurrentZoom', 'x1')
                                } else {
                                    currentZoom = maxZoom
                                    self.$store.commit('setCameraCurrentZoom', 'x5')
                                }
                                track.applyConstraints({ advanced: [{ zoom: currentZoom }] })
                            })
                        } else {
                            console.warn('El zoom no está soportado en este dispositivo/navegador.')
                            // document.getElementById('zoom-camera').style.display = 'none';
                        }
                        imageCapture = new ImageCapture(track)
                        document.querySelector('video').srcObject = mediaStream
                    })
                    .catch((error) => console.error(error))

                document.getElementById('swap-camera').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    track.stop()

                    if (currentCamera == 'front') {
                        navigator.mediaDevices
                            .getUserMedia({ video: { facingMode: { exact: 'environment' } } })
                            .then((mediaStream) => {
                                track = mediaStream.getVideoTracks()[0]
                                let capabilities = track.getCapabilities()
                                if (capabilities.zoom) {
                                    // Configura el control de zoom con los rangos soportados
                                    const zoomControl = document.getElementById('zoom-camera')
                                    minZoom = capabilities.zoom.min
                                    maxZoom = capabilities.zoom.max
                                    currentZoom = track.getSettings().zoom || capabilities.zoom.min

                                    // Cambia el zoom al mover el slider
                                    zoomControl.removeEventListener('click', async () => {
                                        if (currentZoom == minZoom) {
                                            if (currentZoom * 2 < maxZoom) {
                                                currentZoom = currentZoom * 2
                                                self.$store.commit('setCameraCurrentZoom', 'x2')
                                            } else {
                                                currentZoom = maxZoom
                                                self.$store.commit('setCameraCurrentZoom', 'x5')
                                            }
                                        } else if (currentZoom == maxZoom) {
                                            currentZoom = minZoom
                                            self.$store.commit('setCameraCurrentZoom', 'x1')
                                        } else {
                                            currentZoom = maxZoom
                                            self.$store.commit('setCameraCurrentZoom', 'x5')
                                        }
                                        track.applyConstraints({ advanced: [{ zoom: currentZoom }] })
                                    })
                                    zoomControl.addEventListener('click', async () => {
                                        if (currentZoom == minZoom) {
                                            if (currentZoom * 2 < maxZoom) {
                                                currentZoom = currentZoom * 2
                                                self.$store.commit('setCameraCurrentZoom', 'x2')
                                            } else {
                                                currentZoom = maxZoom
                                                self.$store.commit('setCameraCurrentZoom', 'x5')
                                            }
                                        } else if (currentZoom == maxZoom) {
                                            currentZoom = minZoom
                                            self.$store.commit('setCameraCurrentZoom', 'x1')
                                        } else {
                                            currentZoom = maxZoom
                                            self.$store.commit('setCameraCurrentZoom', 'x5')
                                        }
                                        track.applyConstraints({ advanced: [{ zoom: currentZoom }] })
                                    })
                                } else {
                                    console.warn('El zoom no está soportado en este dispositivo/navegador.')
                                    // document.getElementById('zoom-camera').style.display = 'none';
                                }
                                imageCapture = new ImageCapture(track)
                                document.querySelector('video').srcObject = mediaStream
                            })
                            .catch((error) => console.error(error))
                    } else {
                        if (flash) {
                            track.applyConstraints({
                                advanced: [{ torch: !flash }]
                            })
                            flash = !flash
                            document.getElementById('flash-camera').classList.remove('bounce')
                        }

                        navigator.mediaDevices
                            .getUserMedia({ video: true })
                            .then((mediaStream) => {
                                track = mediaStream.getVideoTracks()[0]
                                imageCapture = new ImageCapture(track)
                                document.querySelector('video').srcObject = mediaStream
                            })
                            .catch((error) => console.error(error))
                    }

                    currentCamera = currentCamera == 'back' ? 'front' : 'back'
                })

                document.getElementById('flash-camera').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    if (currentCamera == 'back') {
                        track.applyConstraints({
                            advanced: [{ torch: !flash }]
                        })
                        flash = !flash
                        if (flash) {
                            document.getElementById('flash-camera').classList.remove('bounce')
                        } else {
                            document.getElementById('flash-camera').classList.add('bounce')
                        }
                    }
                })

                document.getElementById('cancel-camera').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    track.stop()
                    self.$store.commit('setCameraActive', false)
                })

                document.getElementById('take-camera').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    imageCapture
                        .takePhoto()
                        .then((blob) => createImageBitmap(blob))
                        .then((imageBitmap) => {
                            const [newWidth, newHeight] = calculateImgSize(imageBitmap, andyImageLimit.width, andyImageLimit.height)
                            const canvas = document.createElement('canvas')
                            canvas.width = newWidth
                            canvas.height = newHeight
                            const ctx = canvas.getContext('2d')
                            ctx.drawImage(imageBitmap, 0, 0, newWidth, newHeight)
                            canvas.toBlob(
                                (blob) => {
                                    // Handle the compressed image. es. upload or save in local state
                                    // displayFileInfo('Original file', file)
                                    displayFileInfo('Compressed file', blob)
                                    var reader = new FileReader()
                                    reader.readAsDataURL(blob)
                                    reader.onloadend = function () {
                                        var base64data = reader.result
                                        switch (type) {
                                            case 'answer':
                                                let aux = self.value
                                                if (!aux) {
                                                    aux = []
                                                }
                                                aux.push(base64data)
                                                self.value = JSON.parse(JSON.stringify(aux))
                                                // self.value.push(base64data);
                                                break
                                            case 'comment':
                                                self.image = base64data
                                                break
                                        }

                                        self.$store.commit('setCameraActive', false)
                                        track.stop()
                                    }
                                },
                                andyImageLimit.mime,
                                andyImageLimit.quality
                            )

                            // drawCanvas(canvas, imageBitmap)
                        })
                        .catch((error) => console.error(error))
                })

                self.$overlay.hide()
            }, 200)
        },
        qNumeric() {
            if (!this.isDisabled) {
                var thisAns = this
                var decimal = thisAns.aConfig ? (thisAns.aConfig.decimal ? thisAns.aConfig.decimal : false) : false
                var hasNegative = thisAns.aConfig ? (thisAns.aConfig.negative || (!isNaN(thisAns.aConfig.negative) && thisAns.aConfig.negative == 1) ? true : false) : false
                const type = this.$store.getters.getIsApp && this.bSensorLimitation && typeof thisAns.aConfig.input !== 'undefined' && thisAns.aConfig.input ? thisAns.aConfig.input : 'manual'
                const displayDeleteActionPlanConfirmPopup = this.displayDeleteActionPlanConfirmPopup

                thisAns.$popup.numeric({
                    decimal: decimal,
                    hasNegative: hasNegative,
                    inputVal: thisAns.value && thisAns.value !== '-' ? thisAns.value : '',
                    tempOptions: {
                        sensorType: type
                    },
                    callSave: async function (self, store) {
                        await thisAns.$nextTick()
                        thisAns.logicItems()
                        const toolType = thisAns.cType
                        if ((thisAns.isANonConformity && thisAns.item.value ? thisAns.valueCreatesActionPlan(self.inputVal).tpl !== thisAns.valueCreatesActionPlan(thisAns.item.value).tpl : true) && toolType === 2 && thisAns.isDisabled !== 'past' && (thisAns.itemHasActionPlan || thisAns.item.isSubitemActionPlan) && self.inputVal !== thisAns.item.value && ((thisAns.item.reference && thisAns.item.reference.type === 5) || thisAns.item.isSubitemActionPlan)) {
                            const popupResult = await displayDeleteActionPlanConfirmPopup()
                            if (popupResult === false) {
                                return
                            }
                        }

                        if (self.inputVal === '-') {
                            thisAns.value = '-'
                        } else if (self.inputVal !== '' && typeof self.inputVal !== 'undefined') {
                            thisAns.bReadingFromSensor = self.bReadingFromSensor
                            thisAns.value = self.inputVal
                        } else {
                            // Defer reset until after Numeric's default callSave runs $popup.close(),
                            // otherwise the confirm from displayPreventDeletePopup is removed immediately.
                            thisAns.$nextTick(async () => {
                                const confirmed = await thisAns.resetAnswer()
                                if (!confirmed) {
                                    // Si el usuario cancela el popup de confirmación, vuelve a mostrar el popup numérico
                                    thisAns.qNumeric()
                                }
                            })
                        }
                    }
                })
            }
        },
        qTemperature() {
            if (!this.isDisabled) {
                let thisAns = this
                const type = this.$store.getters.getIsApp && this.bSensorLimitation && typeof thisAns.aConfig.input !== 'undefined' && thisAns.aConfig.input ? thisAns.aConfig.input : 'manual'

                thisAns.$popup.temperature({
                    tempOptions: {
                        mesure: thisAns.aConfig.units ? thisAns.aConfig.units : 'ºC',
                        sensorType: type
                    },
                    inputVal: thisAns.value && thisAns.value != '-' ? thisAns.value.toString() : '',
                    callSave: function (self, store) {
                        if (self.inputVal == '-') {
                            thisAns.value = '-'
                        } else if (self.inputVal != '' && typeof self.inputVal !== 'undefined') {
                            thisAns.bReadingFromSensor = self.bReadingFromSensor
                            thisAns.value = self.inputVal
                        } else {
                            // Defer reset until after Temperature's default callSave runs $popup.close(),
                            // otherwise the confirm from displayPreventDeletePopup is removed immediately.
                            thisAns.$nextTick(async () => {
                                const confirmed = await thisAns.resetAnswer()
                                if (!confirmed) {
                                    // Si el usuario cancela el popup de confirmación, vuelve a mostrar el popup de temperatura
                                    thisAns.qTemperature()
                                }
                            })
                        }
                    }
                })
            }
        },
        qSignature() {
            if (!this.isDisabled) {
                var thisAns = this
                if (this.item.config.require_emp) {
                    this.$popup.sign({
                        list: this.$store.getters['employee/getAllEmployees'],
                        selectedEl: this.loggedUser,
                        callSave: function (self2, store) {
                            if (self2.inputVal != '') {
                                thisAns.userAccess = self2.selectedEl
                                thisAns.value = self2.inputVal
                            } else {
                                thisAns.resetAnswer()
                            }
                        }
                    })
                } else {
                    this.$popup.freeSign({
                        callSave: function (self2, store) {
                            if (self2.inputVal != '') {
                                thisAns.value = self2.inputVal
                            } else {
                                thisAns.resetAnswer()
                            }
                        }
                    })
                }
            }
        },
        qSignaturePreview() {
            if (this.value) {
                this.$popup.previewSignature({
                    image: this.value
                })
            }
        },
        qDocument(newVal) {
            if (fnCheckConnection()) {
                if (!this.isDisabled) {
                    if (newVal) {
                        this.value = newVal
                    } else {
                        this.resetAnswer()
                    }
                }
            } else {
                this.$snackbar.error({ duration: 10000, closeable: true, message: this.$t('empty_pages.connection_description') })
            }
        },
        qSendMail() {
            if (!this.isDisabled) {
                const isOfflineActive = this.$store.getters.getOffline
                if (isOfflineActive || fnCheckConnection()) {
                    this.value = 1
                    if (!fnCheckConnection() && isOfflineActive) {
                        this.$snackbar.warning({
                            duration: 10000,
                            closeable: true,
                            message: this.$t('answer.sended_mail_pending_sync')
                        })
                    }
                }
            }
        },
        qLink() {
            const self = this
            if (fnCheckConnection()) {
                if (self.$store.getters.getIsApp) {
                    cordova.InAppBrowser.open(self.item.config.url, '_blank')
                } else {
                    window.open(self.item.config.url)
                }
            } else {
                this.$snackbar.error({ duration: 10000, closeable: true, message: this.$t('empty_pages.connection_description') })
            }
        },
        qResource(val) {
            if (fnCheckConnection()) {
                const isNote = val ? val : false

                this.checkAccess(undefined, isNote)

                this.$popup.resource({
                    resource: this.item.resource
                })
            } else {
                this.$snackbar.error({ duration: 10000, closeable: true, message: this.$t('empty_pages.connection_description') })
            }
        },
        // RESET ANSWER
        // options.skipPreventDeletePopup: true para omitir el popup de confirmación de borrado
        async resetAnswer({ skipPreventDeletePopup = false } = {}) {
            const self = this

            if (this.isReview != false && this.item.require_pin_review) {
                this.unvalidateAnswer()
                return true
            }

            const isSelectorItemType = Number(self.item.type) === FORMAT.MULTIPLE
            // Mostrar popup de confirmación de borrado solo cuando:
            // - no se ha solicitado omitir el popup
            // - el item tiene valor
            // - no es un audit item con plan de acción (porque estos ya muestran un popup similar)
            // - no es tipo selector (ya que los componentes de popup de selector se encargan de mostrar este popup)
            if (!skipPreventDeletePopup && this.item.value !== null && !self.valueCreatesActionPlan(this.item.value) && !isSelectorItemType) {
                const confirmed = await displayPreventDeletePopup(this)

                if (!confirmed) {
                    return false
                }
            }

            this.dispatchQueue = this.dispatchQueue || Promise.resolve()
            this.dispatchQueue = this.dispatchQueue.then(() => this.dispatchReset())

            if (!this.autosave && self.item.mandatory && self.def.has_mandatory) {
                this.hasError = true
            }

            this.unvalidateAnswer()

            return true
        },
        subitemsThatNotMeetCondition(newValue) {
            if (!newValue) {
                return []
            }

            if (!this.list || !this.list.sections) {
                return []
            }

            const itemId = this.item.item_id
            const auditSections = Object.values(this.list.sections)
            const subitemsNotMeetingCondition = []

            for (const section of auditSections) {
                const items = section.items && typeof section.items === 'object' ? Object.values(section.items) : []

                for (const item of items) {
                    // if the item has parent_id and is equal to itemId, then it is a subitem of the current item
                    if (item.parent_id && item.parent_id === itemId) {
                        const subitem = item

                        const subitemConditions = subitem.conditions && subitem.conditions.values ? Object.values(subitem.conditions.values) : []

                        for (const condition of subitemConditions) {
                            const conditionValue = condition.value ? condition.value : null
                            const conditionOperator = condition.operator ? condition.operator : null

                            const subitemMeetsCondition = compare(conditionValue, newValue, conditionOperator)

                            if (!subitemMeetsCondition) {
                                subitemsNotMeetingCondition.push(item)
                                break // Only add once per subitem
                            }
                        }
                    }
                }
            }

            return subitemsNotMeetingCondition
        },
        // method only for Audit items
        // (used for subitems that no longer meet the condition to be displayed,
        // after the item response changes and an action plan is deleted)
        resetItems(items) {
            const self = this

            const toolType = self.cType
            if (toolType !== TYPE.AUDIT) {
                return
            }

            const employee = self.$store.getters['loginUser/getUserInformation']

            items.forEach((item) => {
                const resetData = {
                    cType: self.cType,
                    check: self.cId,
                    answer: item.item_id,
                    checkRef: null,
                    itemRef: null,
                    audit: self.list.id,
                    emp: employee.id
                }

                this.$store.dispatch(self.typename + '/reset', resetData).catch((error) => {
                    console.error('error in resetItems: ', error)
                })
            })
        },
        // RESET (DISPATCH RESET)
        async dispatchReset() {
            const self = this

            this.loading = true

            // only for items type image that previously created an Action Plan (delete the action plan)
            if (self.item.type === 5 && Array.isArray(self.item.value) && self.item.value.length === 1 && self.item.actionplans && Object.values(self.item.actionplans).length > 0) {
                this.deleteActionPlan()
            }

            const employee = this.$store.getters['loginUser/getUserInformation']
            const timezone = this.$store.getters['getTimeZoneName']
            let currentTime = false

            try {
                const options = {
                    timeZone: timezone,
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false
                }
                const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                const objectDate = {}
                for (const item of dateTimeFormat) {
                    objectDate[item.type] = item.value
                }
                const dateString = `${objectDate['year']}-${objectDate['month'].padStart(2, '0')}-${objectDate['day'].padStart(2, '0')} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}:${objectDate['second'].padStart(2, '0')}`
                currentTime = moment(dateString).unix()
            } catch (error) {
                currentTime = moment().unix()
                console.error('Error calculating timezone-aware timestamp:', error)
            }

            try {
                const response = await this.$store.dispatch(self.typename + '/reset', {
                    cType: this.cType,
                    check: this.cId,
                    answer: this.aId,
                    checkRef: this.cType === 5 ? this.checkRef : null,
                    itemRef: this.cType === 5 ? this.itemRef : null,
                    audit: this.cType === 5 ? this.list.id : null,
                    emp: employee.id,
                    date: currentTime
                })

                if (!response || !response.status) {
                    self.$snackbar.error({
                        closeable: true,
                        duration: 5000,
                        message: self.$t('tasks.answer_offline')
                    })
                    return
                }

                self.hasAccess = !self.item.require_pin
                self.userAccess = false
                self.hasError = false

                if (self.item.mandatory) {
                    self.$emit('checkAllMandatory', true)
                }
            } catch (error) {
                console.error('Error in dispatchReset:', error)
            } finally {
                self.loading = false
            }
        },
        cantValidateAnswer() {
            var self = this

            const reviewRoles = this.item.config && typeof this.item.config.review_roles !== 'undefined' && this.item.config.review_roles ? this.item.config.review_roles : false
            const employee = this.$store.getters['loginUser/getUserInformation']

            if (reviewRoles && !reviewRoles.includes(employee.rol)) {
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.access.review_roles', { employee: employee.name }),
                    textSave: self.$t('popup.access.understood_andy'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
            } else if (this.def.item.can_review) {
                this.$popup.alert({ message: this.$t('popup.review.cant_until') })
            }
        },
        validateAnswer() {
            if (this.def.item.can_review) {
                let self = this
                const reviewRoles = this.item.config && typeof this.item.config.review_roles !== 'undefined' && this.item.config.review_roles ? this.item.config.review_roles : false
                const employee = this.$store.getters['loginUser/getUserInformation']

                if (reviewRoles && !reviewRoles.includes(employee.rol)) {
                    self.$popup.alert({
                        closable: false,
                        blocking: false,
                        message: self.$t('popup.access.review_roles', { employee: employee.name }),
                        textSave: self.$t('popup.access.understood_andy'),
                        callSave: function (response) {
                            self.$popup.close()
                        }
                    })
                } else {
                    if (self.canBeEdited && !self.isReview) {
                        if (self.item.require_pin_review) {
                            self.$popup.access({
                                list: self.$store.getters['employee/getAccessUsers'](1),
                                callAfterAccess: function (response) {
                                    if (response) {
                                        if (response.status) {
                                            self.$store
                                                .dispatch(self.typename + '/validate', {
                                                    cType: self.cType,
                                                    check: self.cId,
                                                    answer: self.aId,
                                                    emp: response.emp_id,
                                                    date: moment().unix()
                                                })
                                                .then(function () {})
                                            self.$popup.close()
                                        }
                                    }
                                }
                            })
                        } else {
                            self.$store
                                .dispatch(self.typename + '/validate', {
                                    cType: self.cType,
                                    check: self.cId,
                                    answer: self.aId,
                                    emp: self.loggedUser,
                                    date: moment().unix()
                                })
                                .then(function () {})
                        }
                    }
                }
            }
        },
        unvalidateAnswer(thenReset = false) {
            if (this.def.item.can_review) {
                var self = this
                const reviewRoles = this.item.config && typeof this.item.config.review_roles !== 'undefined' && this.item.config.review_roles ? this.item.config.review_roles : false
                const employee = this.$store.getters['loginUser/getUserInformation']
                if (reviewRoles && !reviewRoles.includes(employee.rol)) {
                    self.$popup.alert({
                        closable: false,
                        blocking: false,
                        message: self.$t('popup.access.review_roles', { employee: employee.name }),
                        textSave: self.$t('popup.access.understood_andy'),
                        callSave: function (response) {
                            self.$popup.close()
                        }
                    })
                } else {
                    if (this.canBeEdited && this.isReview) {
                        if (this.item.require_pin_review) {
                            this.$popup.access({
                                list: this.$store.getters['employee/getAccessUsers'](1),
                                callAfterAccess: function (response) {
                                    if (response) {
                                        if (response.status) {
                                            self.$store
                                                .dispatch(self.typename + '/unvalidate', {
                                                    cType: self.cType,
                                                    check: self.cId,
                                                    answer: self.aId
                                                })
                                                .then(function () {
                                                    if (thenReset) {
                                                        // self.dispatchReset();
                                                    } else {
                                                    }
                                                })
                                            self.$popup.close()
                                        }
                                    }
                                }
                            })
                        } else {
                            this.$store.dispatch(self.typename + '/unvalidate', { cType: this.cType, check: this.cId, answer: this.aId }).then(function () {
                                if (thenReset) {
                                    // self.dispatchReset();
                                } else {
                                }
                            })
                        }
                    }
                }
            }
        },
        mandatedValidation(value) {
            if (this.item.mandatory && this.def.has_mandatory && (typeof value === 'undefined' || value === '' || value == null) && !this.autosave && !this.def.item.itemsExcluded.includes(this.item.type) && this.item.is_visible) {
                return true
            } else {
                return false
            }
        },
        imagePreview() {
            const self = this

            if (this.isAuditItemInActionPlanChecklist) {
                if (this.image) {
                    this.$popup.media({
                        image: this.image,
                        showDeleteButton: false
                    })
                }
                return
            }

            if (!this.commenting && this.image) {
                if (this.isAuditOriginatedItemInActionPlan) {
                    this.$popup.media({
                        image: this.image,
                        showDeleteButton: false,
                        textCancel: self.$t('menu_aux.action.cancel'),
                        callCancel: function () {
                            self.$popup.close()
                            self.$overlay.hide()
                        }
                    })
                    return
                }

                this.$popup.media({
                    image: this.image,
                    textCancel: self.$t('menu_aux.action.cancel'),
                    textEdit: self.$t('menu_aux.action.edit'),
                    textDelete: self.$t('menu_aux.action.delete'),
                    callCancel: function (ref, store, item) {
                        self.$popup.close()
                        self.$overlay.hide()
                    },
                    callEdit: function (ref, store, item) {
                        //self.capture(null, 'comment')
                        //self.$popup.close()

                        self.$popup.close()
                        var input = document.createElement('input')
                        input.type = 'file'
                        input.accept = 'image/*'
                        input.capture = 'camera'

                        input.onchange = function (e) {
                            self.imageReload(e)
                        }
                        input.click()
                        self.$refs.changeimage.click()
                    },
                    callDelete: function (ref, store, item) {
                        self.image = ''
                        self.$popup.close()
                    }
                })
            } else {
                this.capture()
            }
        },

        imageReload(e) {
            if (this.commenting) {
                const files = e.target.files || e.dataTransfer.files
                if (!files.length) return

                const reader = new FileReader()
                reader.onerror = (error) => {
                    console.error('Error reading file:', error)
                }

                reader.onload = (e) => {
                    // this.image = e.target.result

                    const image = new Image()

                    image.onload = () => {
                        this.image = this.resizeImage(image)
                    }

                    image.src = e.target.result
                }

                reader.readAsDataURL(files[0])
            }
        },
        inputComment() {
            if (this.isAuditItemInActionPlanChecklist) {
                return false
            }

            var self = this
            if (!this.hasValidPermissions()) {
                this.$popup.alert({
                    message: this.$t('answer.timing.not_has_role_permission', {
                        name: self.user.name,
                        roles: self.rolesWithWritePermissions()
                    })
                })
                return false
            }
            if (!this.hasValidRole()) {
                self.$popup.alert({
                    message: self.$t('answer.timing.not_has_role', {
                        name: self.user.name,
                        roles: self.getStringLimitRoles(self.item.config.roles)
                    })
                })
                return false
            }
            const wasCommenting = this.commenting
            this.commenting = !this.commenting

            if (this.commenting) {
                if (this.commentDraft === null) {
                    if (this.commentSavePending && this.commentDraftCommitted !== null) {
                        this.commentDraft = this.commentDraftCommitted
                    } else {
                        this.commentDraft = this.item.message ? this.item.message : ''
                        this.commentDraftCommitted = null
                    }
                }
            } else if (wasCommenting) {
                this.commitCommentDraft()
                this.handleInputEnd()
            }

            this.$nextTick(() => {
                if (this.$refs && this.$refs.refInputComment) {
                    this.$refs.refInputComment.focus()
                    this.$refs.refInputComment.scrollIntoView({ block: 'center', behavior: 'smooth' })
                }
            })
        },
        toggleMeta(expandValue) {
            if (this.descriptionIsExpandable) {
                this.showSeeMore = !this.showSeeMore
            }

            if (this.item.type !== FORMAT.TITLE || this.showActions()) {
                if (expandValue) {
                    this.valueExpanded = !this.valueExpanded
                } else {
                    // for META section
                    this.expanded = !this.expanded
                }
            }
        },
        openQrModal() {
            const value = this.itemQrValue ? String(this.itemQrValue).trim() : ''
            if (!value) return
            const self = this
            QRCode.toDataURL(value, { margin: 1, width: 200 })
                .then((dataUrl) => {
                    self.$popup.media({
                        image: dataUrl,
                        caption: '#' + value,
                        textCancel: self.$t('popup.media.text_cancel'),
                        customClass: 'popup-qr-identifier'
                    })
                })
                .catch(() => {})
        },
        postpone() {
            if (this.isActionPlanItem) {
                return
            }

            // validate role
            var self = this
            if (fnCheckConnection()) {
                if (!this.hasValidRole()) {
                    self.$popup.alert({
                        message: self.$t('answer.timing.not_has_role', {
                            name: self.user.name,
                            roles: self.getStringLimitRoles(self.item.config.roles)
                        })
                    })
                    return false
                }
                if (this.canPostpone) {
                    let thisAns = this
                    let start = ''
                    let end = ''
                    let today = moment().format('YYYY-MM-DD')
                    let data = {
                        selectedDate: '',
                        showReason: false,
                        showErrorReason: false,
                        errorReason: thisAns.$t('answer.postpone.error')
                    }
                    let list = thisAns.$store.getters['getReasonPostpone']

                    if (thisAns.item.planned_from_date) {
                        start = moment(thisAns.item.planned_from_date)
                    } else {
                        start = moment(thisAns.list.business_date, 'YYYY-MM-DD')
                    }
                    end = moment(start).add(thisAns.item.margin, 'days').format('YYYY-MM-DD')
                    let start_calendar = moment(thisAns.list.business_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')

                    data.selectedDate = {
                        selectedDate: moment(thisAns.list.business_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
                    }

                    data.available = this.item.available ? this.item.available : ''
                    thisAns.$popup.postpone({
                        title: thisAns.$t('popup.postpone.title'),
                        dateStart: start_calendar,
                        dateEnd: end,
                        textSave: this.$t('popup.default.text_save'),
                        textCancel: this.$t('popup.default.text_cancel'),
                        data: data,
                        list: list,
                        callSave: async function (self2, store) {
                            if (fnCheckConnection()) {
                                if (!self2.selected || (list[self2.selected].id == 0 && self2.message.trim() == '')) {
                                    self2.data.showErrorReason = true
                                } else {
                                    thisAns.$overlay.loading()
                                    self2.data.showErrorReason = false

                                    store
                                        .dispatch(thisAns.typename + '/postpone', {
                                            cType: thisAns.cType,
                                            check: thisAns.cId,
                                            answer: thisAns.aId,
                                            date: self2.data.selectedDate.selectedDate,
                                            reason: self2.selected,
                                            description: self2.message
                                        })
                                        .then(function (response) {
                                            thisAns.$popup.close()
                                            thisAns.$overlay.hide()
                                            thisAns.$snackbar.info({ message: thisAns.$t('tooltip.done'), closeable: true })
                                            // thisAns.$router.go();
                                        })
                                }
                            } else {
                                await self.$popup.close()

                                self.$popup.alert({
                                    closable: false,
                                    blocking: false,
                                    message: self.$t('empty_pages.connection_description'),
                                    textSave: self.$t('audit.error.alert_save'),
                                    callSave: function (response) {
                                        self.$popup.close()
                                    }
                                })
                            }
                        }
                    })
                } else {
                    this.$popup.alert({
                        title: this.$t('popup.postpone.title'),
                        message: this.item.planned_to_date ? (this.completeEmployee() ? this.$t('answer.postpone.planned_to', this.getFormattedPostponedDate(this.item.planned_to_date, true)) : this.$t('answer.postpone.planned_to_noname', this.getFormattedPostponedDate(this.item.planned_to_date, false))) : this.$t('answer.postpone.cannot'),
                        showingError: !this.canPostpone
                    })
                }
            } else {
                this.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('empty_pages.connection_description'),
                    textSave: self.$t('audit.error.alert_save'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
            }
        },
        openFile() {
            this.$popup.library({ file: this.item.resource })
        },
        showAlertOrIncidentPopup() {
            const incidentsTemplates = this.hasIssuesTool ? this.$store.getters['issues/getTemplates']() || {} : {}
            // Returns a plain object: alert popup, incident popup, or no popup. It does not open one.
            const action = resolveItemAlertAction({
                alerts: this.item.alerts,
                alertsTriggers: this.item.alerts_triggers,
                isAudit: this.list.type === TYPE.AUDIT,
                canUseIncidentTool: this.hasIssuesTool,
                incidentsTemplates,
                hasExistingIncident: Boolean(this.hasLinkedTemplateIds && this.item.reference && this.hasIssuesTool),
                isNonConformity: this.isANonConformity,
                isActionPlanItem: this.isActionPlanItem
            })

            if (action.type === ALERT_ACTION_TYPE.ALERT_POPUP) {
                this.displayAlertPopup(action)
                return
            }

            if (action.type === ALERT_ACTION_TYPE.INCIDENT_POPUP) {
                this.displayIncidentAlert(action, incidentsTemplates)
            }
        },
        displayAlertPopup(action) {
            this.$popup.alert({
                mood: action.mood,
                message: action.message
            })
        },
        displayIncidentAlert(action, incidentsTemplates) {
            this._createdIncidentId = null
            const hasExistingIncident = action.hasExistingIncident

            this.$popup.issueAlert({
                mood: action.mood,
                message: action.message,
                list: { ...incidentsTemplates },
                selectedEl: action.templateIds[0],
                selectedIssueEl: action.templateIds,
                showingError: true,
                selected: hasExistingIncident,
                textSave: hasExistingIncident ? this.$t('popup.issue_alert.text_redirect') : this.$t('popup.issue_alert.text_save'),
                callSave: (popup) => this.saveIncidentAlert(popup, action),
                callSaveStart: (popup) => this.openCreatedIncident(popup),
                callCancel: (popup) => this.cancelIncidentAlert(popup, hasExistingIncident)
            })
        },
        async saveIncidentAlert(popup, action) {
            this.$overlay.loading()
            this._createdIncidentId = null

            try {
                if (action.hasExistingIncident) {
                    this.goToReference()
                    return popup
                }

                if (typeof popup.selectedEl === 'undefined') {
                    return popup
                }

                const isOffline = !fnCheckConnection()
                const templateIds = isOffline ? [popup.selectedEl] : action.templateIds
                const responses = await Promise.all(templateIds.map((templateId) => this.dispatchAddIncident(templateId, isOffline)))
                this._createdIncidentId = readCreatedIncidentId(responses && responses[0])
                return popup
            } catch (error) {
                this._createdIncidentId = null
                console.error('Error creating incident from alert:', error)
                return popup
            } finally {
                this.$overlay.hide()
            }
        },
        dispatchAddIncident(templateId, isOffline) {
            const payload = {
                tpl_id: templateId,
                cType: TYPE.ISSUE,
                checklist_ref: this.list.id,
                item_ref: this.item.item_id
            }

            if (isOffline) {
                payload.isOfflineCreated = true
                payload.toolQueue = this.typename
            }

            return this.$store.dispatch(this.typename + '/addIssue', payload)
        },
        async openCreatedIncident(popup) {
            const incidentId = this._createdIncidentId
            await this.$popup.close()

            if (!incidentId) {
                this.$overlay.hide()
                return popup
            }

            this.$overlay.loading()
            this.$router.push({ name: 'IssuesDetail', params: { id: incidentId } })
            return popup
        },
        async cancelIncidentAlert(popup, hasExistingIncident) {
            if (!hasExistingIncident) {
                await this.resetAnswer({ skipPreventDeletePopup: true })
            }

            this.$overlay.hide()
            this.$popup.close()
            return popup
        },
        goToReference() {
            if (!this.hasIssuesTool) {
                return
            }
            if (this.item.reference) {
                this.$router.push({
                    name: 'IssuesDetail',
                    params: { id: this.item.reference.checklist, checkType: this.item.reference.type }
                })
            }
        },
        goToActionPlan(item, event) {
            if (event) {
                event.preventDefault()
                event.stopPropagation()
                event.stopImmediatePropagation()
            }

            const self = this

            let actionPlanId = null

            if (item.reference && item.reference.type === 5) {
                actionPlanId = item.reference.checklist
            }

            const auditTemplateId = this.$route && this.$route.params && this.$route.params.id ? this.$route.params.id : null
            const auditChecklistId = this.$route && this.$route.params && this.$route.params.edit ? this.$route.params.edit : null
            const nonConformityId = this.item && this.item.item_id ? this.item.item_id : null

            const routerParams = {
                auditTemplateId: auditTemplateId,
                auditChecklistId: auditChecklistId,
                nonConformityId: nonConformityId
            }

            if (actionPlanId) {
                setTimeout(() => {
                    this.$router.push({
                        name: 'ActionPlan',
                        params: {
                            id: actionPlanId,
                            ...routerParams
                        },
                        query: {
                            ...routerParams
                        }
                    })
                }, 10)
            } else {
                this.$popup && this.$popup.alert
                    ? this.$popup.alert({
                          mood: 'warning',
                          message: self.getString('answer.no_action_plan')
                      })
                    : self.getString('answer.no_action_plan')
            }
        },
        /**
         @param {Number} actionType = Apply value (0 or 1 when 0 is not apply and 1 is apply)
         @returns {Object} Store dispatch data object for apply/not apply dispatch actions: this.typename + '/apply, this.typename + '/applyrecurrent
         */
        applyAndNotApplyDispatchData(actionType) {
            // actionType === 1 => apply
            // actionType === 0 => not apply
            return {
                cType: this.cType,
                check: this.cId,
                answer: this.aId,
                emp: this.loggedUser,
                date: moment().unix(),
                apply: actionType,
                checkRef: this.cType === 5 ? this.checkRef : null,
                itemRef: this.cType === 5 ? this.itemRef : null,
                userRol: this.user.rol
            }
        },
        showNotAllowedRolePopupAlert() {
            const self = this

            self.$popup.alert({
                message: self.$t('answer.timing.not_has_role', {
                    name: self.user.name,
                    roles: self.getStringLimitRoles(self.item.config.roles)
                })
            })
        },
        /**
         * Handles apply/not apply actions for audit items based on user role level.
         * For higher role levels (>1), shows confirmation popups before action.
         * For lower role levels (≤1), executes the action directly.
         * @param {Number} actionType - Action type where 0 means not apply and 1 means apply
         * @returns {Boolean|void} Returns false if user doesn't have valid role, otherwise executes the action
         */
        handleApplicability(actionType) {
            const self = this

            // valida si el usuario tiene permisos de escritura para el item según su rol
            if (!this.hasValidRole() || !this.isUserRoleLevelHigherThanOne) {
                self.showNotAllowedRolePopupAlert()
                return false
            }

            if (self.isUserRoleLevelHigherThanOne) {
                // Popup para NO APLICA (actionType == 0)
                if (actionType == ACTION_TYPE.NOT_APPLY) {
                    self.$snackbar.hide()
                    this.showNotApplyConfirmPopup()
                } else {
                    // Popup para APLICA (actionType == 1)
                    self.showApplyConfirmPopup()
                }
            }
        },
        // Shows the apply confirm popup that shows 3 options: 1) not apply only for now OR, 2) not apply recurrently OR, 3) cancel (close popup)
        showApplyConfirmPopup() {
            const self = this

            const isOfflineActive = !fnCheckConnection() ? { customClass: 'offline' } : {}

            const popupMessage =
                this.item.type == FORMAT.TITLE
                    ? self.$t('answer.apply.remember_apply_section_text_', {
                          username: self.user.name,
                          task: self.itemTitle
                      })
                    : self.$t('answer.apply.remember_apply_text', {
                          username: self.user.name,
                          task: self.itemTitle
                      })

            self.$popup.confirm({
                ...isOfflineActive,
                message: popupMessage,
                textSave: self.$t('popup.confirm.not_apply_text_save'),
                textCancel: self.$t('popup.confirm.not_apply_text_cancel'),
                textCancel2: self.$t('popup.confirm.text_cancel'),
                callSave: self.handleApplyRecurrent,
                callCancel: self.handleApply,
                callCancel2: self.cancelApply
            })
        },
        // sends dispatch to set an item or a section as "applies" (actionType == 1)
        handleApply(ref, store, item) {
            const self = this

            if (item == 'button') {
                self.$overlay.loading()

                self.$store
                    .dispatch(self.typename + '/apply', self.applyAndNotApplyDispatchData(ACTION_TYPE.APPLY))
                    .then((response) => {
                        self.$popup.close()
                        self.$overlay.hide()

                        self.showApplyMessage = false

                        const snackbarData = {
                            message: self.item.type == FORMAT.TITLE ? self.$t('answer.apply.revert_section') : self.$t('answer.apply.revert'),
                            duration: 5000,
                            closeable: true,
                            type: 'info'
                        }

                        self.$snackbar.main(snackbarData)
                        self.toggleMeta(false)
                    })
                    .catch((error) => {
                        logError(error)

                        self.$popup.close()
                        self.$overlay.hide()
                        self.showApplyMessage = false

                        const snackbarData = {
                            message: self.item.type == FORMAT.TITLE ? self.$t('answer.apply.revert_section') : self.$t('answer.apply.revert'),
                            duration: 5000,
                            closeable: true,
                            type: 'info'
                        }

                        self.$snackbar.main(snackbarData)
                        self.toggleMeta(false)
                    })
                // clicked outside
            } else {
                self.$popup.close()
            }
        },
        handleApplyRecurrent() {
            const self = this

            self.$overlay.loading()

            self.$store
                .dispatch(self.typename + '/applyrecurrent', self.applyAndNotApplyDispatchData(ACTION_TYPE.APPLY))
                .then(function (response) {
                    self.$popup.close()
                    self.$overlay.hide()
                    self.showApplyMessage = false
                    self.toggleMeta(false)
                })
                .catch((error) => {
                    logError(error)
                    self.$overlay.hide()
                })
        },
        cancelApply() {
            const self = this

            self.$popup.close()
            self.$overlay.hide()
            self.toggleMeta(false)
        },
        // Shows the not apply confirm popup that shows 3 options: 1) not apply only for now OR, 2) not apply recurrently OR, 3) cancel (close popup)
        showNotApplyConfirmPopup() {
            const notApplyConfirmPopupMsg =
                this.item.type == FORMAT.TITLE
                    ? this.$t('answer.apply.remember_no_apply_section_text', {
                          username: this.user.name,
                          task: this.itemTitle
                      })
                    : this.$t('answer.apply.remember_no_apply_text', {
                          username: this.user.name,
                          task: this.itemTitle
                      })

            let confirmPopupData = {
                message: notApplyConfirmPopupMsg,
                textSave: this.$t('popup.confirm.not_apply_text_save'),
                textCancel: this.$t('popup.confirm.not_apply_text_cancel'),
                textCancel2: this.$t('popup.confirm.text_cancel'),
                classSave: 'act save',
                callSave: this.showReconfirmNotApplyRecurrentPopup,
                callCancel: this.handleNotApply,
                callCancel2: this.cancelNotApply
            }

            if (!fnCheckConnection()) {
                confirmPopupData = {
                    message: notApplyConfirmPopupMsg,
                    textSave: this.$t('popup.confirm.not_apply_text_cancel'),
                    callSave: this.handleNotApply
                }
            }

            this.$popup.confirm(confirmPopupData)
        },
        // Shows the reconfirmation popup for not apply recurrentaction
        async showReconfirmNotApplyRecurrentPopup() {
            // close "confirm" modal in order to open "reconfirm" modal:
            await this.$popup.close()

            if (fnCheckConnection()) {
                const reconfirmPopupData = {
                    message: this.$t('answer.apply.confirm_not_apply'),
                    callSave: this.handleNotApplyRecurrent,
                    // cancel button has to close confirm recurrent modal and open again not apply confirm modal
                    callCancel: async () => {
                        // close this confirm recurrent modal and open again not apply confirm modal
                        await this.$popup.close()
                        this.showNotApplyConfirmPopup()
                    }
                }
                this.$popup.reconfirm(reconfirmPopupData)
            } else {
                this.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: this.$t('empty_pages.connection_description'),
                    textSave: this.$t('audit.error.alert_save'),
                    callSave: () => {
                        this.$popup.close()
                    }
                })
            }
        },
        /**
         * Applies "not apply" only for now (temporary not apply)
         * @param {*} ref - Reference parameter
         * @param {*} store - Store parameter
         * @param {*} item - Item parameter
         */
        handleNotApply(ref, store, item) {
            if (fnCheckConnection() || this.$store.getters.getOffline) {
                if (item == 'button' || typeof item === 'undefined') {
                    this.$overlay.loading()

                    this.$store
                        .dispatch(this.typename + '/apply', this.applyAndNotApplyDispatchData(ACTION_TYPE.NOT_APPLY))
                        .then((response) => {
                            this.$popup.close()
                            this.$overlay.hide()
                            this.showApplyMessage = true
                            this.toggleMeta(false)
                        })
                        .catch((error) => {
                            logError(error)
                            this.$overlay.hide()
                        })
                    // clicked outside
                } else {
                    this.$popup.close()
                }
            } else {
                this.$popup.close()
                this.$overlay.hide()
                this.$snackbar.error({
                    duration: 10000,
                    closeable: true,
                    message: this.$t('empty_pages.connection_description')
                })
            }
        },
        // Handles the remember not apply action (permanent not apply)
        handleNotApplyRecurrent() {
            if (fnCheckConnection()) {
                this.$overlay.loading()
                this.$store
                    .dispatch(this.typename + '/applyrecurrent', this.applyAndNotApplyDispatchData(ACTION_TYPE.NOT_APPLY))
                    .then((response) => {
                        this.$popup.close()
                        this.$overlay.hide()
                        this.showApplyMessage = true
                        this.toggleMeta(false)
                    })
                    .catch((error) => {
                        logError(error)
                        this.$overlay.hide()
                    })
            } else {
                this.$popup.close()
                this.$overlay.hide()
                this.$snackbar.error({
                    duration: 10000,
                    closeable: true,
                    message: this.$t('empty_pages.connection_description')
                })
            }
        },
        // Cancels the not apply action
        cancelNotApply(ref, store, item) {
            this.$popup.close()
            this.$overlay.hide()
            this.toggleMeta(false)
        },
        isBase64(string) {
            const regex = /^data:image\/(jpeg|png|jpg|webp);base64,/i
            return regex.test(string)
        },
        getOfflineImg() {
            return css_image_url + 'offline/no_icon_light.svg'
        },
        checkIfDescriptionWasShortened() {
            const description = this.$refs.description

            if (description) {
                const descriptionWasShortened = description.scrollHeight > description.clientHeight

                // this.showSeeMore = descriptionWasShortened

                return descriptionWasShortened
            }
        },
        updateSelectorPopupStatus(status) {
            setTimeout(() => {
                this.isSelectorPopupOpen = status
            }, 200)
        },
        reopenSelectorPopup() {
            const selector = this.itemIsMultiselect ? this.$refs.multiSelector : this.$refs.simpleSelector

            if (selector && typeof selector.reopenPopup === 'function') {
                selector.reopenPopup()
            }
        },
        loadLastValueForItem() {
            if (this.isActionPlanItem) {
                return
            }

            this.loading = true
            const employee = this.$store.getters['loginUser/getUserInformation']
            this.$store.dispatch('tasks/loadLastValueForItem', { item: this.item }).then((response) => {
                if (response && response.value) {
                    const loadedValue = JSON.parse(response.value)

                    const timezone = this.$store.getters['getTimeZoneName']
                    let currentTime = false

                    try {
                        const options = {
                            timeZone: timezone,
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: false
                        }
                        const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                        const objectDate = {}
                        for (const item of dateTimeFormat) {
                            objectDate[item.type] = item.value
                        }
                        const dateString = `${objectDate['year']}-${objectDate['month'].padStart(2, '0')}-${objectDate['day'].padStart(2, '0')} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}:${objectDate['second'].padStart(2, '0')}`
                        currentTime = moment(dateString).unix()
                    } catch (error) {
                        currentTime = moment().unix()
                        console.error('Error calculating timezone-aware timestamp:', error)
                    }
                    this.dispatchAnswer(loadedValue, employee.id, currentTime, currentTime)
                } else {
                    this.$popup.alert({
                        message: 'No se ha encontrado el valor anterior para este item'
                    })
                }
                this.loading = false
            })
        }
    },
    watch: {
        auditIsLoading(newVal) {
            if (Number(this.cType) === TYPE.AUDIT) {
                if (newVal) {
                    this.$overlay.loading()
                } else {
                    this.$overlay.hide()
                }
            }
        },
        'item.value'(newVal) {
            if (this.valueSavePending) {
                return
            }
            if (this.valueDraft !== null && String(newVal != null ? newVal : '') === String(this.valueDraft)) {
                this.valueDraft = null
                this.valueDraftCommitted = null
            }
        },
        'item.message'(newVal) {
            if (this.commentSavePending) {
                return
            }
            if (this.commentDraft !== null && String(newVal != null ? newVal : '') === String(this.commentDraft)) {
                this.commentDraft = null
                this.commentDraftCommitted = null
            }
        }
    },
    created() {
        this.isOnline = this.$store.getters.getConnState

        if (this.$store.getters.getIsApp) {
            setTimeout(function () {
                document.getElementsByTagName('a').forEach((e) => {
                    var link = e.innerHTML
                    if (link) {
                        e.onclick = function () {
                            cordova.InAppBrowser.open(link, '_blank')
                            return false
                        }
                        e.href = ''
                    }
                }),
                    500
            })
        }
    },
    mounted() {
        this.isOnline = this.$store.getters.getConnState
        this.unsubscribeScreenLayout = subscribeScreenLayoutChange((version) => {
            this.screenLayoutVersion = version
            this.onScreenLayoutChange()
        })
        setTimeout(() => {
            this.showSeeMore = this.checkIfDescriptionWasShortened()
            this.descriptionIsExpandable = this.checkIfDescriptionWasShortened()
        }, 200)
    },
    beforeDestroy() {
        if (this.unsubscribeScreenLayout) {
            this.unsubscribeScreenLayout()
            this.unsubscribeScreenLayout = null
        }

        this.cleanupInlineTextGuards()

        // Limpiar el timer cuando se destruye el componente
        if (this.typingTimer) {
            clearTimeout(this.typingTimer)
            this.typingTimer = null
        }
        this.valueDraft = null
        this.commentDraft = null
        this.valueDraftCommitted = null
        this.commentDraftCommitted = null
        this.valueSavePending = false
        this.commentSavePending = false
        // Asegurar que el estado se resetea
        this.$store.commit('tasks/setIsUserTyping', false)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// En el plan de acción los items se renderizan fuera de #content, por eso se añade #detail-content.action-plan
#content.issues.detail,
#content.register.detail,
#content.audit.detail,
#content.tasks.detail,
#detail-content.action-plan {
    $ans-border: #ccc;
    $ans-bg: #fff;
    $ans-value-bg: #f3f3f3;
    $ans-value-bg-hover: #b3b3b3;
    $ans-text-color: #222;
    $ans-desc-color: #666;
    $meta-bg: #fbfbfb;

    $answer-size: rem(40px);

    .question {
        &:first-child {
            margin-top: 15px;
        }

        width: 100%;
        padding: 0px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;

        @media (max-width: 767px) {
            margin: 0;
            padding: 8px 6px 8px 12px;
        }

        &.hidden {
            display: none;
        }

        &[data-type='8'] {
            display: flex;
            align-items: start;
            justify-content: space-between;
            flex-direction: row;
            gap: 8px;

            .section-button-container {
                height: 56px; // height fijo con el mínimo height del item para que el botón no se mueva cuando se abre y cierra la caja del botón de tres puntos
                display: flex;
                align-items: center;
                justify-content: center;

                .section-button {
                    @include background($color: $main-t80, $image: img('less_primary.svg'), $size: 10px);
                    @include border-radius(2px);
                    width: 18px;
                    height: 18px;
                    padding: 4px;
                    cursor: pointer;
                    padding-top: 8px;

                    &.closed {
                        @include background($color: $main-t80, $image: img('more_primary.svg'), $size: 10px);
                    }
                }
            }
        }

        .action-plan-section {
            width: 100%;
            padding-top: 24px;
            // padding-bottom: 24px;

            .title-and-button {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 4px;
            }

            .action-plan-title {
                font-size: 18px;
            }

            .show-hide {
                display: flex;
                gap: 4px;
                align-items: center;
                background-color: none;

                .label {
                    color: #374673;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .show-hide:hover {
                background-color: transparent;
            }

            .action-plan-items-container {
                padding-left: 16px;
            }
        }

        .unknown {
            @include border-radius(3px);
            @include font-size(sm);
            font-family: $text;
            color: $error;
            font-style: italic;
            text-align: center;
            padding: 10px 0;
            width: rem(100px);
            margin-left: rem(10px);
            display: inline-block;
            width: 100%;
            max-width: 100%;
            // float: right;
        }

        .answer,
        .answer > .line {
            // @include display-inline-flex();
            // @include align-items();
            // @include flex-wrap(wrap);
            width: 100%;
            min-height: $answer-size;
            // padding-right: 10px;

            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .statement {
                @include font-size(m);
                width: 100%;
                color: $ans-text-color;
                font-family: $text-light;
                max-width: 100%;

                .multiSelect-title-container {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .load-last-value {
                        cursor: pointer;
                        display: flex;
                        padding: 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        border-radius: 4px;
                        border: 1px solid $neutro-dark;
                        background: $neutro;

                        span {
                            white-space: nowrap;
                            font-size: 16px;
                        }
                    }

                    .load-last-value.margin {
                        margin-right: 10px;
                    }
                }

                p {
                    padding: 0px !important;
                }

                .section-progress-indicator {
                    position: absolute;
                    background-color: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 4px;
                    display: grid;
                    place-items: center;
                    top: 8px;
                    left: 8px;

                    .icon-container {
                        width: 24px;
                        height: 24px;
                        display: grid;
                        place-items: center;
                        border-radius: 50%;

                        .i-andy-menu-checklist {
                            color: $done;
                        }

                        .i-andy-circle-exclamation {
                            color: #ffcd1a;
                        }
                    }
                }

                .answer-title {
                    @include font-size(m);
                    width: 100%;
                    color: $ans-text-color;
                    font-family: $text-light;
                    // padding-top: 8px;
                    // font-weight: bold;
                    padding-right: 8px;

                    b {
                        @include font-size(inherit);
                        color: inherit;
                    }

                    ul {
                        list-style: disc;
                        padding: 5px 0;
                        padding-left: 30px;
                        color: inherit;
                    }

                    li {
                        @include font-size(inherit);
                        color: inherit;
                    }

                    &.mandatory {
                        // color: $error-dark;
                        // text-decoration: underline;
                        font-family: $text;

                        &:after {
                            content: ' *';
                            // color: $error;
                        }
                    }

                    &.optional {
                        font-family: $text-light;

                        &:after {
                            @include font-size(s);
                            color: #888;
                            content: attr(data-after);
                        }
                    }
                }

                .text-container {
                    max-height: 2.4em;
                    /* Dos líneas con una altura de línea de 1.2em */
                    overflow: hidden;
                    position: relative;
                }

                .text-container .expanded {
                    max-height: none;
                }

                .text-container::after {
                    content: '\2026';
                    /* Puntos suspensivos */
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    background: white;
                    /* Ajusta el fondo según tus necesidades */
                }

                .description {
                    @include font-size(s);
                    display: block;
                    color: $ans-desc-color;
                }

                .description-short {
                    p {
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: normal;
                    }
                }

                .see-more {
                    font-weight: 800;
                    position: relative;
                    display: flex;
                    padding-top: 4px;
                }

                .see-more:hover {
                    background-color: transparent;
                }

                .see-less {
                    font-weight: 800;
                    position: relative;
                    display: flex;
                    padding-top: 4px;
                }

                .see-less:hover {
                    background-color: transparent;
                }
            }

            .stat-description:after {
                @include font-size(s);
                content: attr(data-desc);
                display: block;
                color: $ans-desc-color;
            }

            .response {
                text-align: right;
                display: flex;
                align-items: center;
                gap: 4px;
                flex-direction: row;
                justify-content: flex-end;

                @media only screen and (max-width: 650px) {
                    flex-wrap: wrap;
                    // justify-content: flex-end;
                    gap: 6px;
                    flex-direction: column;
                    align-items: flex-end;

                    // .question[data-type='14'] {
                    //     flex-direction: column;
                    // }
                }

                > div {
                    // width: 100%;
                    @include display-inline-flex();
                    @include flex-wrap(wrap);
                    @include align-items(center);
                    @include justify-content(flex-end);
                    @include flex-direction(row);
                }

                .yes-no {
                    display: flex;
                    flex-direction: row;
                    gap: 4px;
                    flex-wrap: nowrap;
                }

                .responseNoApply {
                    @include display-inline-flex();
                    @include flex-wrap(wrap);
                    @include align-items(flex-end);
                    @include justify-content(flex-end);
                    height: 100%;
                    width: 150px;
                    cursor: pointer;

                    .text {
                        @include display-inline-flex();
                        @include flex-wrap(wrap);
                        @include align-items(center);
                        @include justify-content(center);
                        @include background($color: $main-t80, $image: img('offline/noApply.svg'), $size: 50px, $position: center 5px);
                        @include font-size(m);
                        @include border-radius(4px);
                        font-family: $conden-bold;
                        color: $main-s40;
                        padding: 9px 15px 30px 30px;
                        height: auto;
                        width: max-content;
                    }
                }

                .value {
                    @include interaction();

                    @include font-size(s);
                    @include border-radius(3px);
                    // line-height: 1;
                    font-family: $text;
                    text-transform: none;
                    text-align: center;
                    width: $answer-size;
                    height: $answer-size;
                    display: inline-block;
                    border: none;

                    @include bgHover($ans-value-bg);

                    &.disabled {
                        pointer-events: none;
                    }

                    &.bluetooth {
                        position: relative;
                        border: 2px solid $main-light;
                        width: calc(#{$answer-size} + 4rem);

                        .task-icon-bluetooth {
                            position: absolute;
                            top: -2px;
                            right: -1px;
                            background-color: $main-light;
                            padding: 1px 2px;
                            border-radius: 4px;
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -webkit-box-align: center;
                            -ms-flex-align: center;
                            align-items: center;
                            -webkit-box-pack: center;
                            -ms-flex-pack: center;
                            justify-content: center;
                            z-index: 10;
                            margin: 0;
                            border-top-left-radius: 0;
                            border-bottom-right-radius: 0;

                            i {
                                color: $color-white;
                            }
                        }
                    }
                }

                /* Evita que el texto se muestre invertido en WebViews nativos con idioma RTL */
                .input-text-ltr {
                    direction: ltr;
                    unicode-bidi: isolate;
                }

                .postposed {
                    @include border-radius(3px);
                    @include background($size: 16px, $position: left 3px center, $color: $main);
                    @include font-size(s);
                    line-height: $answer-size;
                    font-family: $text-bold;
                    color: #fff;
                    text-align: center;
                    padding: 0;
                    width: 80px;
                    height: $answer-size;
                    display: inline-block;
                    float: right;
                }
            }
        }

        .answer {
            width: calc(100% - 40px);
            padding: 6px;

            background-color: $ans-bg;
        }

        .answer-state {
            @include border-radius(5px);
            height: 5px;
            width: 100%;
            margin: 0;
            background-color: $accent-dark;
        }

        // ITEM REVIEW (DOUBLE CHECK)

        .toReview {
            gap: 6px;

            .line {
                // width: calc(100% - 55px);
                padding-right: 0;
            }

            .checkaccess {
                width: 171px;
            }

            .review-check {
                height: 2.5rem !important;
                width: 2.5rem !important;
                border-radius: 100%;
                background-size: initial;
                background-clip: padding-box;
            }

            .review-check-disabled {
                @extend .review-check;
                background: img('icons/double_check_grey.svg');
                background-repeat: no-repeat;
                background-color: #eeeeee;
                background-position: center;
            }

            .review-check-pending {
                @extend .review-check;
                background: img('icons/double_check_white.svg');
                background-repeat: no-repeat;
                background-color: #eeeeee;
                background-position: center;
                padding: 20px;
            }

            .review-check-done {
                @extend .review-check;
                background: img('icons/double_check_white.svg');
                background-repeat: no-repeat;
                background-color: #348567;
                background-position: center;

                &.portrait {
                    height: 2.5rem;
                    padding: 20px;
                }
            }
        }

        .meta {
            min-height: 60px;
            height: auto;
            width: 100%;
            padding: 10px 0;
            background-color: $meta-bg;
            border-radius: 0 0 4px 4px;
            position: relative;

            .hidden {
                display: none !important;
            }

            div.task-label {
                display: grid;
                place-content: center;
                margin-left: 12px;
                width: fit-content;
                height: 17px;
                flex-shrink: 0;
                border-radius: 2px;
                padding: 4px;

                &.daily {
                    background-color: $color-daily;
                }

                &.weekly {
                    background-color: $color-weekly;
                }

                &.biweekly {
                    background-color: $color-biweekly;
                }

                &.monthly {
                    background-color: $color-monthly;
                }

                &.quarterly {
                    background-color: $color-quarterly;
                }

                &.biannually {
                    background-color: $color-biannually;
                }

                &.annually {
                    background-color: $color-annually;
                }

                span {
                    display: flex;
                    height: 15px;
                    flex-direction: column;
                    justify-content: center;
                    flex-shrink: 0;
                    text-align: justify;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 16px;
                }
            }

            .actions,
            .info {
                font-family: $text !important;
                // float: left;
                display: inline-block;
                min-height: $answer-size;
                height: auto;

                .sign {
                    font-family: $text !important;

                    .name {
                        font-family: $text !important;

                        .bold {
                            font-family: $text !important;
                        }
                    }
                }

                .datetime {
                    font-family: $text !important;
                    font-size: 14px !important;
                }
            }
            .meta > .actions:not(.actions--with-qr) {
                width: 235px;
                float: right;
                padding: 0 10px;
            }

            .actions--with-qr {
                float: right;
                width: auto;
                max-width: 55%;
                padding: 0 10px;
                display: flex;
                flex-direction: row-reverse;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-start;
                gap: 5px;

                .actions__secondary {
                    display: contents;
                }

                .actions__secondary.hidden {
                    display: none !important;
                }
            }
            .info {
                width: auto;
                overflow: hidden;

                .offline-message-box,
                .sign,
                .review,
                .unreview,
                .period,
                .role,
                .timing {
                    display: block;
                    width: 100%;
                    padding-left: 12px;
                    padding-bottom: 6px;
                    min-height: 20px;
                    height: auto;

                    .bold,
                    .datetime,
                    .name,
                    .date-info,
                    .reason {
                        @include font-size(s);
                        color: $ans-desc-color;
                        margin-right: 3px;
                    }

                    .reason {
                    }

                    .date-info {
                        color: $main;
                        font-family: $text;
                    }

                    .bold {
                        font-family: $text;
                    }

                    .datetime,
                    span.offline-message {
                        @include font-size(15);
                        font-family: Avenir-Regular;
                        color: $ans-desc-color;
                    }

                    .bold,
                    .datetime {
                        .avatar {
                            @include border-radius(100%);
                            width: 15px;
                            height: 15px;
                        }
                    }

                    .ico {
                        @include border-radius(50%);
                        background-size: 20px;
                        width: 20px;
                        height: 20px;
                        position: relative;
                        bottom: -4px;
                        background-color: $main;
                        margin-right: 5px;
                    }

                    .task-icon-done {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('checked_ok.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-notdone {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('check-not-done.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-reviewed {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('icons/double_check_white.svg');
                        background-color: #348567;
                        border-radius: 100%;
                        background-position: center;
                        background-size: 10px;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-toreview {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('icons/double_check_white.svg');
                        background-size: 10px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-color: #b1b1b1;
                        border-radius: 100%;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-date {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('input_datetime_neutro_s50.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-postpone {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('postpone.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-postpone_done {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('postpone_done.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-reason {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('message.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-sync {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-image: img('offline/sync_icon.svg');
                        background-size: contain;
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        vertical-align: middle;
                    }

                    .task-icon-delete {
                        margin-top: -2px;
                        margin-right: 4px;

                        i {
                            color: $color-warning-500;
                        }
                    }

                    .task-icon-bluetooth {
                        margin-top: -2px;
                        margin-right: 4px;
                        background-color: $main-light;
                        padding: 3px 1px 0;
                        border-radius: 2px;

                        i {
                            color: $neutro-light;
                        }
                    }
                }
            }

            .roles {
                @include border-radius(3px);
                background-color: $neutro-t10;
                font-family: $text-light;
                padding: 2px 7px;
                width: fit-content;
                margin-right: 3px;
            }
        }

        .item-alert {
            width: 100%;
            padding-left: 40px;
            display: flex;
            align-items: center;

            .alex {
                @include background($image: img('alexhead_08.svg'), $size: contain, $position: left bottom);
                width: rem(40px);
                height: rem(40px);
                display: inline-block;
                margin-right: 6px;
            }

            .message {
                @include border-radius(3px);
                @include font-size(s);
                line-height: 25px;
                font-family: $text;
                color: $main-s40;
                padding: 4px 8px;
                display: flex;
                align-items: center;
                align-self: stretch;
                background-color: $main-t70;
                overflow: hidden;
                width: 100%;
                height: 32px;

                b {
                    @include font-size(s);
                    color: $main-text;
                }

                ul {
                    list-style: disc;
                    padding-left: 30px;
                }

                li {
                    color: $main-text;
                    @include font-size(s);
                }

                .preview,
                .read-more {
                    display: inline-block;
                    font-family: $text;
                    float: left;
                }

                .preview {
                    @include text-ellipsis();
                    width: 95%;
                }

                .read-more {
                    @include interaction();
                    font-family: $text;
                    color: $main-text;
                    text-align: center;
                }

                &.email {
                    width: 100%;
                    max-width: fit-content;

                    .preview {
                        width: auto;
                    }
                }
            }

            &.has-issue {
                // same as parent
            }

            &.info {
                .alex {
                    background-image: img('alexhead_03.svg');
                }

                .message {
                    background-color: #d5dcf3 !important;
                }
            }

            &.warning {
                .alex {
                    background-image: img('alexhead_04.svg');
                }

                .message {
                    background-color: #fff4cc !important;
                }
            }

            &.error {
                .alex {
                    background-image: img('alexhead_03.svg');
                }

                .message {
                    background-color: #fadfde !important;
                }
            }
        }

        .action-plan-link-container {
            padding-left: 40px !important;
            width: 100%;
            pointer-events: auto;

            &:hover {
                cursor: default;
            }
        }

        .action-plan-generated-message {
            display: flex;
            padding: 8px;
            align-items: center;
            gap: 4px;
            align-self: stretch;
            border-radius: 8px;
            background: var(--color-error-100, #fff3f4);

            i {
                display: flex;
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                aspect-ratio: 1/1;
                color: var(--color-error-500, #bd1f1e);
            }

            .message-text {
                color: var(--color-black, #222);
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin-left: 4px;
            }

            .ver-link {
                margin-left: auto;
                background: none;
                border: none;
                padding: 0;
                color: var(--color-error-500, #bd1f1e);
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                text-decoration-line: underline;
                text-decoration-style: solid;
                text-decoration-skip-ink: auto;
                text-decoration-thickness: auto;
                text-underline-offset: 2px;
                text-underline-position: from-font;
                cursor: pointer;
            }

            .ver-link:hover {
                color: var(--color-error-600, #9b1a1a);
            }

            &.is-closed {
                background: $color-info-100;

                i {
                    color: $color-info-500;
                }

                .ver-link {
                    color: $color-info-500;
                }

                .ver-link:hover {
                    color: $color-info-500;
                    opacity: 0.8;
                }
            }
        }

        & > .reference-link {
            padding-left: 40px !important;
            width: 100%;

            .message {
                //@include background($image: img('alert_alert.svg'), $size: 18px, $position: left center, $color: transparent);
                @include border-radius(3px);
                @include font-size(s);
                line-height: 25px;
                font-family: $text;
                color: $main-s40;
                overflow: hidden;
                max-width: 100%;
                height: auto;
                width: 100%;
                display: flex;
                gap: 4px;
                padding-left: 14px;

                .read-more {
                    color: #475b96;
                    text-align: center;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;

                    .i-andy-right-arrow {
                        padding: 0 8px;
                    }
                }
            }

            &.has-issue.warning {
                .i-andy-task-warning {
                    color: #cc9f00;
                }
            }

            &.has-issue.error {
                .i-andy-task-warning {
                    color: #bd1f1e;
                }
            }

            &.has-issue.info {
                .i-andy-task-warning {
                    color: #2c52c4;
                }
            }
        }

        .state {
            .planned {
                width: calc(100% - 100px);
                display: inline-block;
                padding: 0 12px;

                .name,
                .date,
                .hour {
                    @include font-size(14);
                    font-family: $text;
                    color: #666;
                    text-transform: uppercase;
                    text-align: center;
                    margin-left: 3px;
                }

                .name {
                    @include font-size(xs);
                    font-family: $text;
                }

                // .date,
                // .hour {
                //     // color: $main-dark;
                // }
            }

            .reviewed {
                @include background($color: transparent);
                @include font-size(s);
                display: inline-block;
                float: right;
                padding: 0;
                padding-right: 6px;
                margin: 0;
                color: $ans-desc-color;
                font-style: italic;
                font-family: $text-light;
                text-align: right;
                width: 100px;
            }
        }

        .btn.action {
            color: $ans-text-color;

            &.review {
                margin: 0;
                margin-left: 10px;
                padding: 0;
                height: $answer-size;
                width: 90px;
                text-transform: none;
                box-shadow: none;
                background-color: $accent-t70;
                @include display-flex();
                @include justify-content();
                @include align-items(center);

                .text {
                    @include font-size(s);
                    color: $accent-s60;
                }

                .text {
                    font-family: $text-bold;
                }

                &.disabled {
                    @include opacity(0.5);
                    @include filter(grayscale(100%));
                }
            }

            &.unreview {
                @include background($color: transparent);
                margin: 0;
                margin-left: 10px;
                padding: 0;
                height: $answer-size;
                width: 90px;
                text-transform: none;
                box-shadow: none;
                @include display-flex();
                @include justify-content();
                @include align-items(center);

                .text {
                    @include font-size(s);
                    color: #888;
                    text-align: right;
                }

                .text {
                    font-style: italic;
                    font-family: $text;
                }
            }

            &.toggleMeta {
                @include background($color: transparent, $size: 18px);
                background-image: img('more_vert_aaaaaa.svg');
                width: 40px;
                display: inline-block;
                padding: 0;

                &.open {
                    background-image: img('more_vert_primary.svg');
                }

                &.section-see-more {
                    width: 40px;
                }
            }

            &.hasFile,
            &.share,
            &.comment,
            &.postpone,
            &.noApply,
            &.apply,
            &.qr-icon-btn {
                @include background($color: transparent, $size: 20px, $position: top 3px center);
                @include font-size(s);
                text-align: center;
                font-family: $conden;
                color: $ans-text-color;
                width: fit-content;
                max-width: rem(100px);
                min-width: rem(40px);
                height: rem(40px);
                float: right;
                padding: 25px 10px 10px;
                margin-left: 5px;

                @include bgHover($meta-bg);
            }

            /* Misma caja que .comment / .postpone (padding + height del grupo); icono como background top 3px center */
            &.qr-icon-btn {
                background-image: none !important;
                position: relative;
                line-height: 1.1;

                .qr-icon-btn__icon {
                    position: absolute;
                    top: 3px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    pointer-events: none;
                }

                .qr-icon-btn__icon i {
                    font-size: 20px;
                    width: 20px;
                    height: 20px;
                    color: #aaa;
                }

                .qr-icon-btn__label {
                    display: block;
                    width: 100%;
                    text-align: center;
                    font-family: $conden;
                    @include font-size(s);
                    color: $ans-text-color;
                }

                &:hover .qr-icon-btn__label,
                &:focus-visible .qr-icon-btn__label {
                    color: $main;
                }

                &:hover .qr-icon-btn__icon i,
                &:focus-visible .qr-icon-btn__icon i {
                    color: $main;
                }
            }

            &.postpone {
                background-image: img('offline/postpone_aaaaaa.svg');

                &.cannot {
                    @include opacity(0.25);
                }
            }

            &.hasFile {
                background-image: img('offline/attach_aaaaaa.svg');
            }

            &.noApply {
                background-image: img('offline/noApply.svg');
                background-size: 40px;
            }

            &.apply {
                background-image: img('offline/arrows-retweet.svg');
            }

            &.share {
                background-image: img('share_aaaaaa.svg');
                background-size: 18px;
            }

            &.comment {
                background-image: img('offline/notes_create_aaaaaa.svg');
            }
        }

        .item {
            @include display-inline-flex();
            @include flex-wrap(wrap);
            @include align-items();
            @include justify-content(flex-end);
            @include border-radius(3px $default-border-radius $default-border-radius 3px);
            @include height-fit-content();
            background-color: $ans-bg;
            width: 100%;
            padding: 0;
            overflow: hidden;
            margin: 0;
            transition-duration: 0.2s;
            border-left: 5px solid #ccc;
            height: auto;
            min-height: $answer-size + rem(10px);
            // border-left: 5px solid $accent;

            &.excluded {
                border-color: #ccc;
            }

            &.done {
                border-color: $done;
            }

            &.showErrors {
                border-color: #bd1f1e;
            }

            &.error {
                border-color: $error;

                .roles {
                    background-color: $error !important;
                    color: #fff;
                }
            }

            &.alert {
                border-color: $warning;
            }

            &.issue {
                border-color: $error;
            }

            &.sync {
                border-color: $sync-main !important;
            }
        }

        .disabled {
            background-color: $color-neutral-200;
            border: 1px solid $color-neutral-500;
            border-color: $color-neutral-300 !important;
            border-left: 5px solid $color-neutral-500;
            cursor: not-allowed !important;

            .answer {
                background-color: $color-neutral-200;

                .answer-title,
                .description {
                    color: $color-neutral-600 !important;
                }

                .response {
                    .value {
                        cursor: not-allowed !important;
                    }
                }
            }
        }

        .has-comment {
            @include flex-wrap(wrap);
            display: flex;
            justify-content: space-between;
            width: 100%;
            max-height: 80px;
            //height: 60px;
            position: relative;

            .editIcon {
                @include background($image: img('offline/notes_create_aaaaaa.svg'), $size: 24px);
                background-color: #eae8e4;
                width: 24px;
                height: 24px;
                padding: 30px 10px 30px 30px;
                border-radius: 5px 0 0 5px;
            }

            &.editing {
                height: 80px;
            }

            &.hide {
                display: none;
            }

            .has-note {
                $image-size: rem(60px);
                width: calc(100% - 70px);
                min-height: $image-size;
                height: 100%;
                max-height: inherit;
                margin: 0px;
                padding: 12px 0px 0px 0px;
                display: flex;
                justify-content: flex-start;

                .note,
                .note:focus {
                    display: inline-block;
                    width: 100%;
                    height: $image-size;
                    margin: 0;
                    background-color: $ans-bg;
                    color: #666666;
                    -webkit-text-fill-color: #666;
                }

                .note[disabled],
                .note:focus[disabled] {
                    background-color: #eae8e4;
                    padding-left: 0px;
                    border-radius: 0px 5px 5px 0px;
                }

                /* Evita que el texto se muestre invertido en WebViews nativos con idioma RTL */
                .input-text-ltr {
                    direction: ltr;
                    unicode-bidi: isolate;
                }

                &.hide {
                    display: none;
                }
            }

            &.editing .has-note {
                .note,
                .note:focus {
                    height: 60px;
                    background-color: $ans-bg;
                }
            }

            .has-image {
                @include display-inline-flex();
                @include flex-wrap(wrap);
                @include flex-direction(column);
                width: 60px;
                height: 71px;
                text-align: center;
                margin-left: 10px;

                .preview {
                    @include border-radius(3px);
                    width: 60px;
                    height: 60px;
                    overflow: hidden;
                    // border: 1px solid #eee;
                    display: block;
                    margin-top: 13px;

                    .image {
                        // width: auto;
                        // max-width: unset;
                        // height: rem(40px);
                        height: 100% !important;
                        width: 100% !important;
                        object-fit: cover !important;
                    }
                }

                .add-file,
                .change-image,
                .btn.delete,
                .btn.view {
                    @include border-radius(3px);
                    visibility: hidden;
                    background-color: transparent;
                    width: rem(40px);
                    height: rem(40px);
                    display: inline-block;
                }

                .input-file {
                    left: -60px !important;
                    top: 12px;
                    width: rem(40px) !important;
                    height: rem(40px) !important;
                    max-width: unset;
                }

                .btn.delete,
                .btn.view {
                    @include opacity(0);
                }

                &.hide {
                    display: none;
                }
            }

            .has-image.editing {
                .btn.delete {
                    @include opacity(0.3);
                    background-position: left 6px top 13px;
                    background-size: 18px;
                }

                .btn.view {
                    @include opacity(0.3);
                    background-position: left 6px top 13px;
                    background-size: 18px;
                }
            }

            &.editing .has-image {
                height: 71px;

                .preview {
                    @include background($image: img('offline/camera_cccccc.svg'), $color: #fff, $size: 30px);
                    width: 60px;
                    height: 60px;

                    .image {
                        // height: 60px;
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                    }
                }

                .add-file,
                .change-image,
                .btn.delete,
                .btn.view {
                    visibility: visible;
                }

                .input-file {
                    width: 60px !important;
                    height: 60px !important;
                    border-radius: 5px;
                }
            }
        }

        .suggest {
            -webkit-animation-duration: 1500ms;
            animation-duration: 1500ms;
            -webkit-animation-name: attention;
            animation-name: attention;
            -webkit-animation-timing-function: linear;
            animation-timing-function: linear;
            -webkit-animation-iteration-count: 2;
            animation-iteration-count: 2;
            -webkit-animation-direction: normal;
            animation-direction: normal;
            // transition-duration: 0.2s;
        }

        &.loading {
            $loading-color: #fff;
            animation-duration: 0.2s;

            .item {
                position: relative;
                border-color: $loading-color;

                &:after {
                    @include background($color: $loading-color, $image: img('loader_primary.svg'), $size: 50px);
                    @include opacity(0.8);
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: $loading-color;
                    width: 100%;
                    height: 100%;
                    z-index: 5;
                }
            }
        }

        &[data-type='1'] {
            // CHECK
            .answer {
                .statement {
                    max-width: calc(100% - #{rem(40px)});
                }

                .line {
                    flex-wrap: nowrap;
                    width: calc(100%);
                }

                .response {
                    // height: rem(40px);
                    display: flex;
                    // gap: 0.625rem;

                    .value {
                        @include border-radius(100%);
                        // @include background($size: 16px, $color: $ans-value-bg);
                        // @include background($size: 16px, $color: $ans-value-bg, $image: img('check_to_do.svg'));
                        background-color: #eeeeee;
                        background: img('check_to_do.svg');
                        background-size: cover;

                        &:hover {
                            background-color: $ans-value-bg-hover;
                        }
                    }

                    .value.checked {
                        @include background($size: cover, $image: img('checked_ok.svg'));
                        border: none;
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;
                    border-color: $error-t60 !important;

                    &:focus {
                        background-color: tint($error-t90, 95%) !important;
                    }
                }
            }
        }

        &[data-type='2'] {
            // YES/NO

            .answer {
                .statement {
                    max-width: calc(100% - 15%);
                }

                .response {
                    // width: 15%;
                    @include justify-content(flex-end);
                    // gap: 0.625rem;

                    @media only screen and (max-width: 400px) {
                        flex-direction: column;
                        align-items: flex-end;
                    }

                    .value {
                        @include background($color: $ans-bg);

                        &[data-value='0'] {
                            background-image: img('error_dddddd.svg');
                            margin: 0px;
                        }

                        &[data-value='1'] {
                            background-image: img('checked_dddddd.svg');
                            margin: 0px;
                        }

                        &.selected {
                            &[data-value='0'] {
                                background-image: img('error_alert.svg');
                            }

                            &[data-value='1'] {
                                background-image: img('checked_ok.svg');
                            }
                        }

                        &:hover {
                            background-color: $ans-value-bg-hover;
                        }
                    }
                }
            }

            .error {
                .response {
                    [data-value='0'] {
                        background-image: img('error_error.svg') !important;
                        background-color: #bd1f1e !important;
                        border: 1px solid #bd1f1e;
                    }

                    [data-value='1'] {
                        background-image: img('checked_error.svg') !important;
                        background-color: #bd1f1e !important;
                        border: 1px solid #bd1f1e;
                    }
                }
            }
        }

        &[data-type='3'] {
            // YES/NO/NC
            .answer {
                .statement {
                    max-width: calc(100% - 20%);
                }

                .response {
                    width: 20%;
                    // gap: 0.625rem;
                    @include justify-content(flex-end);
                }

                .value {
                    background-color: $ans-value-bg;
                }

                .value.selected {
                    color: $color-white;
                }

                .value[data-value='0'].selected {
                    background-color: $error;
                }

                .value[data-value='1'].selected {
                    background-color: $done;
                }

                .value[data-value='2'] {
                    width: 70px;
                }

                .value[data-value='2'].selected {
                    background-color: #aaa;
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;
                    color: #bd1f1e !important;
                }
            }
        }

        &[data-type='2'] .answer,
        &[data-type='3'] .answer {
            // YES/NO /NC

            .response {
                @include display-flex();

                .value {
                    @include border-radius(rem(40px));
                    line-height: $answer-size;
                    color: $ans-text-color;

                    &.selected {
                        color: #fff;
                    }
                }
            }
        }

        &[data-type='4'] {
            // TEXT
            .answer {
                @include flex-wrap(wrap);

                .statement {
                    max-width: calc(100%);
                    display: inline-block;
                }

                .line {
                    flex-direction: column;

                    .response {
                        width: 100%;
                        margin-top: 6px;
                        padding-top: 4px !important;
                        border-top: 1px solid #eee;

                        border-top: none;
                        padding-top: 0;
                        margin-top: 0;

                        color: $ans-text-color;

                        .value {
                            @include background($image: img('input_text_cccccc.svg'), $size: 28px, $position: left 8px center);
                            @include border-radius(0);
                            background-color: $ans-value-bg;
                            width: calc(100%);
                            text-transform: none;
                            text-align: left;
                            padding: 0 0 0 44px;

                            .checkaccess {
                                width: 100%;
                            }
                        }

                        .text-temp {
                            display: none;
                            margin: 0;
                            padding: 0;
                            width: 0;
                            height: 0;
                        }
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;
                    background-image: img('input_text_error.svg') !important;
                }
            }
        }

        &[data-type='5'] {
            // IMAGE
            .answer {
                $qImage: rem(60px);
                $qActions: rem(40px);
                $qTotal: $qImage + $qActions;
                padding-right: 6px;

                .statement {
                    max-width: calc(100% - #{$qTotal});
                }

                .response {
                    @include display-flex();
                    // width: $qTotal;

                    .preview-image {
                        @include interaction();
                        @include background($image: img('offline/camera_cccccc.svg'), $color: $ans-value-bg);
                        @include border-radius(3px);
                        background-size: calc(#{$qImage} - #{rem(20px)});
                        float: left;
                        width: $qImage;
                        height: $qImage;
                        margin-top: 3px;
                        overflow: hidden;

                        .image-offline {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            @include background($image: img('offline/no_icon_light.svg'), $color: #fff, $size: 30px);
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            visibility: hidden;
                        }

                        .galery-img {
                            visibility: unset;
                        }

                        &.has-image:not(:empty) {
                            background-image: none;

                            img {
                                visibility: inherit;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                    }

                    .actions-image {
                        width: $qActions;
                        height: $qImage + rem(5px);
                        float: left;

                        .btn {
                            padding: 0;
                            min-height: unset;
                        }

                        .add-file {
                            width: 0;
                            height: 0;

                            // height: $qImage / 2;
                            .input-file {
                                opacity: 0;

                                &.disabled {
                                    pointer-events: none;
                                }
                            }
                        }

                        .btn.delete {
                            @include border-radius(3px);
                            width: $qActions;
                            height: $qActions;
                            min-height: $qActions - rem(10px);
                        }

                        .btn.view {
                            @include border-radius(3px);
                            width: $qActions;
                            height: $qActions - rem(10px);
                        }

                        .btn.view + .btn.delete {
                            height: $qActions - rem(10px);
                        }

                        .input-file {
                            width: $qImage !important;
                            height: $qImage !important;
                            max-width: unset;
                            // left: $qActions;
                            background-color: $ans-value-bg;
                            top: -40px;
                            padding: unset;
                        }
                    }
                }

                .actions-image:not(.editing) {
                    .btn.delete,
                    .btn.view {
                        display: none;
                    }
                }

                .actions-image.editing {
                    .btn.delete {
                        @include background($image: img('delete_cccccc.svg'), $color: transparent, $size: 20px);
                    }

                    .btn.view {
                        @include background($image: img('eye_cccccc.svg'), $color: transparent, $size: 20px);
                        z-index: 5;
                    }
                }

                &.galery {
                    // IMAGE GALERY
                    $qImgGalery: rem(40px);

                    .statement {
                        position: relative;
                        z-index: 2;
                    }

                    .title-no-description {
                        position: relative;
                        // top: 13px;
                    }

                    .response {
                        // display: block;
                        width: 100%;
                        @include display-flex();
                        @include flex-direction(column);
                        @include align-items(flex-end);

                        // margin-top: -$qImgGalery;
                        &.empty-gallery {
                            @include flex-direction(row);
                        }

                        .add-image {
                            .input-file {
                                $qActions: rem(40px);
                                $qImage: rem(40px);
                                width: $qImage !important;
                                height: $qImage !important;
                                max-width: unset;
                                left: $qActions;
                                background-color: $ans-value-bg;
                                top: 0;
                                left: 40px;

                                &.disabled {
                                    pointer-events: none;
                                }

                                &.empty {
                                    top: 0;
                                    left: 40px;
                                }
                            }

                            .preview-image {
                                // margin-top: rem(20px);
                                background-image: img('more_cccccc.svg');
                                background-size: 20px;
                                width: $qImgGalery;
                                height: $qImgGalery;
                            }

                            .actions-image {
                                height: $qImgGalery;
                            }
                        }

                        .galery-list {
                            width: 100%;
                            text-align: right;
                            padding-top: 6px;

                            .galery-item {
                                display: inline-block;
                                margin-left: rem(12px);

                                .preview-image {
                                    background: none;

                                    .image-offline {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        @include background($image: img('offline/no_icon_light.svg'), $color: #fff, $size: 30px);
                                    }
                                }
                            }
                        }

                        // &.no-description {
                        //     // margin-top: 0px;
                        //     // .add-image {
                        //     //     margin-top: 21px;
                        //     // }
                        // }
                    }
                }
            }

            .error {
                .preview-image {
                    background-image: img('camera_error.svg') !important;
                    background-color: $error-t90 !important;
                }
            }
        }

        &[data-type='6'] {
            // NUMERIC

            .answer {
                padding-right: 6px;

                .statement {
                    max-width: calc(100% - #{rem(100px)});
                }

                .response {
                    @include display-flex();

                    .value {
                        @include background($color: $ans-value-bg, $size: 25px);
                        @include font-size(ml);
                        line-height: $answer-size;
                        width: rem(100px);
                        min-height: $answer-size;
                        height: auto;
                        display: block;

                        &:focus {
                            background-color: tint($main, 95%);
                        }

                        &.showTap {
                            background-image: img('input_number_cccccc.svg');
                        }

                        &.no-value {
                            @include font-size(xs);
                            line-height: rem(16px);
                            font-family: $text;
                            background-image: none;
                            padding-top: 5px;
                        }
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;

                    &:focus {
                        background-color: tint($error-t90, 95%);
                    }

                    &.showTap {
                        background-image: img('input_number_error.svg') !important;
                    }
                }
            }
        }

        &[data-type='7'],
        &[data-type='13'] {
            .item,
            .answer,
            .response,
            .value {
                overflow: visible;
            }
        }

        // DATE AND TIME TYPES
        &[data-type='7'],
        &[data-type='12'],
        &[data-type='13'] {
            .answer {
                .response {
                    .value {
                        @include background($size: 28px, $position: left 8px center);
                        width: 100%;
                        text-transform: none;
                        padding: 0 0 0 rem(44px);
                        text-align: left;
                        background-color: $ans-value-bg;
                    }
                }
            }

            .error {
                .response {
                    .value {
                        background-color: $error-t90 !important;
                    }
                }
            }
        }

        &[data-type='7'] .item {
            // DATE
            .statement {
                width: calc(100% - #{rem(206px)});
            }

            .response {
                width: rem(200px);

                .value {
                    background-image: img('input_date_cccccc.svg');
                }
            }

            &.error {
                .answer {
                    .response {
                        width: 180px;

                        > .value {
                            background-image: img('input_datetime_error.svg') !important;

                            &::-webkit-input-placeholder {
                                color: #bd1f1e;
                                font-weight: lighter;
                            }

                            &::-moz-placeholder {
                                color: #bd1f1e;
                                font-weight: lighter;
                            }

                            &:-ms-input-placeholder {
                                color: #bd1f1e;
                                font-weight: lighter;
                            }

                            &::-ms-input-placeholder {
                                color: #bd1f1e;
                                font-weight: lighter;
                            }

                            &::placeholder {
                                color: #bd1f1e;
                                font-weight: lighter;
                            }
                        }
                    }
                }
            }
        }

        // SECTION TITLE
        &[data-type='8'] {
            // margin: rem(60px) auto 0px auto;
            margin-top: 16px;

            .answer-title {
                @include font-size($size: l);
                font-family: $title !important;
                color: $main-s30 !important;
                text-transform: uppercase;
                // background-color: $default-sec-color;

                padding-left: 56px;
                padding-right: 16px !important;
            }

            .statement {
                width: 100% !important;
            }
        }

        &[data-type='9'] {
            // SUBTITLE
            margin: rem(45px) auto 0px auto;

            .answer-title {
                @include font-size($size: ml);
                font-family: $title !important;
                color: $main-dark !important;
            }
        }

        &[data-type='8'],
        // TITLE &
        &[data-type='9'] {
            // SUBTITLE
            .answer {
                position: relative;
                background-color: transparent;
                padding: unset;
                width: 100%;
                cursor: pointer;
            }

            .answer-title {
                @include display-flex();
                @include justify-content(center);
                @include align-items(center);
                @include font-size(ml);
                @include border-radius(4px);
                background-color: $default-sec-color;
                height: 40px;
                color: $neutro-s90 !important;
                font-family: $text-bold !important;
            }

            .description {
                text-align: center;
            }

            .item,
            .item.done {
                border: none;
            }

            .sign,
            .alert,
            .state {
                display: none;
            }

            .item {
                @include border-radius(0);
                width: 100%;
                margin: 0 auto;
                background-color: transparent;
            }

            .btn.action {
                bottom: unset;
                position: absolute;
                // display: none;

                // &.open {
                //     top: 8px !important;
                // }
            }

            .actions {
                .action {
                    top: unset !important;
                    bottom: 10px !important;
                    right: 10px;

                    button {
                        margin: 0px !important;
                    }
                }
            }

            .statement {
                max-width: unset !important;
            }

            .response,
            .line {
                padding: 0;
                width: 100% !important;
            }
        }

        // SECTION TITLE
        &[data-type='8'] {
            .answer {
                .answer-title {
                    min-height: 56px;
                }
            }

            .line {
                flex-direction: column;

                .statement {
                    min-height: 56px;
                }
            }
        }

        &[data-type='10'] {
            // TEXTAREA
            .answer {
                @include flex-wrap(wrap);

                .line {
                    flex-direction: column;

                    .statement {
                        max-width: calc(100%);
                        display: inline-block;
                    }

                    .response {
                        width: 100%;
                        padding-top: 6px;

                        .checkaccess {
                            width: 100%;
                        }

                        .value {
                            @include background($image: img('input_text_cccccc.svg'), $size: 28px, $position: left 8px center);
                            @include border-radius(0);
                            background-color: $ans-value-bg;
                            width: calc(100%);
                            text-transform: none;
                            text-align: left;
                            padding: 10px 5px 10px 44px;
                            border: none;
                            color: $ans-text-color;
                        }

                        .text-temp {
                            display: none;
                            margin: 0;
                            padding: 0;
                            width: 0;
                            height: 0;
                        }
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;
                    background-image: img('input_text_error.svg') !important;
                }
            }
        }

        &[data-type='11'] {
            .item.done.flex-column {
                align-items: flex-start;
            }

            .answer {
                .line.flex-column {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 2px;

                    .response {
                        // background-color: $color-selector;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        gap: 2px;
                        width: 100%;

                        .multiSelector {
                            width: 100%;

                            &.portrait {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }

        // &[data-type='11'] {
        //     // MULTIPLE SELECT
        //     .answer {
        //         > .line {
        //             @include display-flex();
        //             @include justify-content(space-between);
        //             .statement {
        //                 width: calc(100% - #{rem(200px)});
        //             }
        //         }

        //         .response {
        //             //width: rem(200px);
        //             // display: flex;
        //             //width: 31%;
        //             // gap: 12px;

        //             > div {
        //                 display: unset;
        //                 // width: 140px;
        //             }

        //             .value {
        //                 // @include text-ellipsis();
        //                 @include background($color: $ans-value-bg, $size: 10px, $position: right 9px center, $image: img('down_caret_aaaaaa.svg'));
        //                 -webkit-appearance: none;
        //                 -moz-appearance: none;
        //                 width: 100%;
        //                 padding: 8px;
        //                 padding-right: 26px;

        //                 &:focus {
        //                     background-color: tint($main, 95%);
        //                 }
        //                 &.showTap {
        //                     background-image: img('down_caret_aaaaaa.svg');
        //                     -webkit-appearance: none;
        //                     -moz-appearance: none;
        //                 }
        //             }

        //             option[disabled] {
        //                 display: none;
        //             }
        //         }
        //         .review-check-disabled {
        //             padding: 20px;
        //         }
        //     }
        //     .error {
        //         .value {
        //             &.showTap {
        //                 background-image: img('down_caret_error.svg') !important;
        //                 border: 1px solid $error-t90 !important;
        //                 background-color: $error-t90 !important;
        //             }
        //         }
        //     }
        // }

        &[data-type='12'] .item {
            // HOUR
            .statement {
                width: calc(100% - #{rem(150px)});
            }

            .response {
                width: rem(150px);

                .value {
                    width: 100%;
                    text-align: center;
                    padding-left: 43px;
                    background-image: img('input_time_cccccc.svg');
                }
            }
        }

        &[data-type='13'] {
            // DATETIME
            .answer {
                .statement {
                    max-width: calc(100% - #{rem(250px)});
                }

                .response {
                    width: rem(250px);

                    .value {
                        @include background($image: img('input_datetime_cccccc.svg'), $size: 28px, $position: left 8px center);
                        width: 100%;
                        padding: 0 0 0 44px;
                        text-align: left;
                        display: flex;

                        &::-webkit-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::-moz-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &:-ms-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::-ms-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }
                    }

                    input[type='date']::-webkit-calendar-picker-indicator,
                    input[type='datetime-local']::-webkit-calendar-picker-indicator {
                        background: none;
                    }
                }
            }

            .error {
                .value {
                    background-image: img('input_datetime_error.svg') !important;
                }
            }
        }

        &[data-type='14'] {
            // SIGNATURE
            .answer {
                padding-right: rem(6px);

                .statement {
                    // max-width: calc(100% - #{rem(140px)} - #{rem(6px)});+
                    max-width: 60%;
                }

                .response {
                    // @include display-flex();
                    // // width: rem(146px);
                    // align-items: flex-end;

                    .value {
                        @include background($color: $ans-value-bg, $size: 28px);
                        @include font-size(sm);
                        width: rem(40px);
                        display: block;

                        &:focus {
                            background-color: tint($main, 95%);
                        }

                        &.unsigned {
                            // margin-left: auto;
                            background-image: img('input_sign_cccccc.svg');
                        }
                    }

                    .sign-block {
                        display: flex;
                        gap: 4px;
                        align-items: center;
                    }

                    .signed {
                        // width: rem(100px);
                        width: 60px;
                        height: 40px;
                        // margin-right: rem(6px);

                        .text {
                            @include text-ellipsis();
                            width: 100%;
                            height: calc(100% - #{rem(50px)});
                        }

                        .ico {
                            @include background($size: cover);
                            width: 100%;
                            // height: rem(50px);
                            height: 40px;
                        }
                    }

                    .value,
                    .signed {
                        display: block;
                        float: right;
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;

                    &.unsigned {
                        background-image: img('input_sign_error.svg') !important;
                    }
                }
            }
        }

        &[data-type='15'] {
            // TEMPERATURE
            .answer {
                padding-right: 6px;

                .statement {
                    max-width: calc(100% - #{rem(90px)});
                }

                .response {
                    @include display-flex();

                    .value {
                        @include background($color: $ans-value-bg, $size: 25px);
                        @include font-size(ml);
                        line-height: $answer-size;
                        width: rem(90px);
                        display: block;

                        &:focus {
                            background-color: tint($main, 95%);
                        }

                        &.showTap {
                            background-image: img('input_temperature_cccccc.svg');
                        }

                        &.no-value {
                            @include font-size(xs);
                            line-height: rem(16px);
                            font-family: $text;
                            background-image: none;
                            padding-top: 5px;
                        }

                        // &:not(.showTap):not(.no-value):after {
                        //     content: '\00b0';
                        // }
                    }
                }
            }

            .error {
                .value {
                    background-color: $error-t90 !important;
                    @include font-size(ml);
                    line-height: $answer-size;
                    width: rem(90px);
                    display: block;

                    &:focus {
                        background-color: tint($error-t90, 95%) !important;
                    }

                    &.showTap {
                        background-image: img('input_temperature_error.svg') !important;
                    }

                    &.no-value {
                        @include font-size(xs);
                        line-height: rem(16px);
                        font-family: $text;
                        background-image: none;
                        padding-top: 5px;
                    }

                    // &:not(.showTap):not(.no-value):after {
                    //     content: '\00b0';
                    // }
                }
            }
        }

        &[data-type='16'] {
            // SEND MAIL
            .answer {
                .statement {
                    max-width: calc(100% - #{rem(120px)});
                }

                .response {
                    @include display-flex();

                    .value {
                        @include background($color: $ans-value-bg, $size: 25px, $image: img('send_cccccc.svg'), $position: right 6px center);
                        @include font-size(xs);
                        width: rem(120px);
                        padding-right: 30px;
                        display: block;
                        text-transform: none;
                        font-family: $text;
                        color: $ans-text-color;

                        &:focus {
                            background-color: tint($main, 95%);
                        }

                        &.sended {
                            @include background($color: transparent, $image: none);
                            padding-right: 0;
                        }
                    }
                }
            }

            .error {
                .value {
                    color: #bd1f1e !important;
                    background-color: $error-t90 !important;
                    background-image: img('send_error.svg') !important;
                }
            }
        }

        &[data-type="17"] .answer,
        // DOCUMENT
        &[data-type="18"] .answer {
            // MESSAGE

            .statement {
                @include interaction();
                @include background($image: img('up_dark.svg'), $size: 14px, $position: right 6px center);
                max-width: calc(100%);
                display: inline-block;
                padding-right: $answer-size;
            }

            .response {
                @include flex-direction(column);
                min-height: unset;
                width: 100%;

                .value-content {
                    @include background($color: $ans-value-bg);
                    @include border-radius(0);
                    width: calc(100%);
                    text-transform: none;
                    text-align: left;
                    padding: 10px 5px 10px 44px;
                    height: auto;
                    color: $ans-text-color;
                }
            }
        }

        &[data-type="17"].value-collapsed .answer,
        // DOCUMENT
        &[data-type="18"].value-collapsed .answer {
            // MESSAGE

            .statement {
                @include background($image: img('down_dark.svg'), $size: 14px, $position: right 6px center);
            }

            .response {
                .value-content {
                    height: 0;
                    display: none;
                    overflow: hidden;
                }
            }
        }

        &[data-type='17'] .answer {
            // DOCUMENT

            .response {
                @include flex-direction(column);
                padding-top: 12px;

                .conditions {
                    @include display-flex();
                    @include justify-content();
                    width: 100%;
                    height: rem(40px);
                    text-align: center;
                    margin: 12px 0 6px 0;

                    .text-check,
                    .value {
                        display: inline-block;
                        color: $ans-text-color;
                    }

                    .text-check {
                        @include font-size(sm);
                        font-family: $text;
                        line-height: rem(40px);
                        height: rem(40px);
                        max-width: calc(100% - #{rem(40px)});
                        width: auto;
                        padding-right: 12px;
                    }

                    .value {
                        @include border-radius(100%);
                        @include background($size: 16px, $color: $ans-value-bg);
                        width: rem(40px);
                        border: 2px solid $ans-border;

                        &.checked {
                            @include background($size: cover, $image: img('checked_ok.svg'));
                            border: none;
                        }
                    }
                }
            }
        }

        &[data-type='18'] .answer {
            // MESSAGE
            @include flex-wrap(wrap);

            .response {
                padding-top: 6px;
            }
        }

        &[data-type='19'] {
            // LINK

            .answer {
                padding-right: 6px;

                .statement {
                    max-width: calc(100% - #{$answer-size});
                }

                .response {
                    @include display-flex();

                    .value {
                        @include background($image: img('link_primary.svg'), $color: $ans-value-bg, $size: 25px);
                        @include font-size(ml);
                        line-height: $answer-size;
                        width: $answer-size;
                        display: block;

                        &:focus {
                            background-color: tint($main, 95%);
                        }
                    }
                }
            }

            .error {
                .value {
                    background-image: img('link_error.svg') !important;
                    background-color: $error-t90 !important;
                }
            }
        }

        &[data-type='20'] {
            .item {
                border-color: $default-sec-color;

                .answer {
                    // LINK
                    padding-right: 6px;

                    .statement {
                        max-width: calc(100% - #{$answer-size});
                    }

                    .response {
                        @include display-flex();

                        .value {
                            @include background($image: img('eye_preview_dark.svg'), $color: $ans-value-bg, $size: 25px);
                            @include font-size(ml);
                            line-height: $answer-size;
                            width: $answer-size;
                            display: block;

                            &:focus {
                                background-color: tint($main, 95%);
                            }
                        }
                    }
                }

                &.error {
                    border-color: $error;

                    .answer {
                    }

                    .value {
                        background-color: $error-t90 !important;
                        background-image: img('eye_preview_error.svg') !important;
                    }
                }
            }
        }

        &.uncompleted {
            .done {
                border-color: #ccc;
            }

            .answer {
                .statement {
                    width: calc(100% - #{rem(120px)});
                    max-width: calc(100% - #{rem(120px)});
                }

                .response {
                    // width: rem(120px)
                    width: fit-content;
                    display: block;
                    text-align: center;
                    margin: 0;
                    display: grid;
                    align-items: center;
                }
            }
        }

        &[data-type='17'].uncompleted .answer,
        &[data-type='18'].uncompleted .answer {
            // MESSAGE

            .statement {
                width: 100%;
                max-width: 100%;
            }

            .response {
                width: 100%;
            }
        }

        &.complete-all {
            margin-bottom: rem(60px);

            .item {
                border: none;
            }

            .answer {
                width: 100%;
                background-color: $main-t80;

                .line {
                    padding: 0 10px;
                }

                .statement {
                    max-width: calc(100% - #{$answer-size});

                    .answer-title {
                        color: $main-dark;
                    }
                }

                .response {
                    height: $answer-size;

                    .value {
                        @include border-radius(100%);
                        @include background($size: 16px, $color: $main-t80);
                        border: 2px solid $main-t10;

                        @include bgHover($main-t80);
                    }

                    .value.semichecked {
                        @include background($size: cover, $image: img('checked_aaaaaa.svg'));
                        border: none;
                    }

                    .value.checked {
                        @include background($size: cover, $image: img('checked_primary.svg'));
                        border: none;
                    }
                }
            }
        }

        &[noApply='1'] .answer {
            .statement {
                width: calc(100% - #{rem(150px)});
                max-width: calc(100% - #{rem(150px)});
            }

            .response {
                width: rem(150px);
                display: block;
            }
        }
    }

    .question.past,
    .question.future {
        @include filter(grayscale(25%));
        position: relative;

        .ico.lock {
            @include background($image: img('lock_aaaaaa.svg'), $size: 25px, $position: top 6px center);
            position: absolute;
            width: rem(50px);
        }

        .item {
            //border-width: 50px;
            border-color: #eee;
        }

        .response {
            @include opacity(0.8);
        }
    }

    .question.future .ico.lock {
        background-image: img('unlock_primary.svg');
    }

    .question.postposed-to {
        .statement {
            max-width: calc(100% - #{rem(80px)}) !important;
        }

        .response {
            width: rem(80px) !important;
        }

        .item {
            border-color: $info;
            // border-color: $ans-bg;

            .line {
                padding-right: 0px;

                .response {
                    .postposed {
                        width: 100%;
                    }
                }
            }
        }
    }

    .question.child {
        width: 100% !important;
        // margin-left: 48px !important;
        padding-left: 40px !important;

        &.subitem-action-plan {
            margin-left: 0% !important;
            width: 100% !important;
        }
    }

    .question.subsubitem {
        padding-left: 80px !important;
    }

    .question.hidden {
        display: none;
    }

    .answer > .flex-row {
        display: flex;
        flex-direction: row !important;

        .response {
            width: 100%;
            max-width: 100%;
            display: flex !important;
            align-content: flex-end;
        }
    }

    @-webkit-keyframes attention {
        0% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }

        25% {
            -webkit-transform: rotate(-10deg) scale(1.2);
            transform: rotate(-10deg) scale(1.2);
            @include opacity(0.9);
        }

        50% {
            -webkit-transform: rotate(0) scale(1);
            transform: rotate(0) scale(1);
        }

        75% {
            -webkit-transform: rotate(10deg) scale(1.2);
            transform: rotate(10deg) scale(1.2);
            @include opacity(0.9);
        }

        100% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }
    }

    @keyframes attention {
        0% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }

        25% {
            -webkit-transform: rotate(-10deg) scale(1.2);
            transform: rotate(-10deg) scale(1.2);
            @include opacity(0.9);
        }

        50% {
            -webkit-transform: rotate(0) scale(1);
            transform: rotate(0) scale(1);
        }

        75% {
            -webkit-transform: rotate(10deg) scale(1.2);
            transform: rotate(10deg) scale(1.2);
            @include opacity(0.9);
        }

        100% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }
    }
}

/* Solo checklist/tareas: el max-height 80px del bloque compartido recorta la fila nota (icono + padding + textarea). */
#content.tasks.detail {
    .question .has-comment {
        max-height: none;
        align-items: flex-start;

        &.editing {
            height: auto;
            min-height: 80px;
        }

        .has-note {
            .note,
            .note:focus {
                overflow-y: auto;
            }
        }
    }
}
</style>

<!-- // PORTRAIT STYLES -->
<style lang="scss">
#content.detail,
#detail-content.action-plan {
    .question.portrait {
        padding: 0px !important;
        max-width: 100%;

        .action-plan-link-container {
            padding-left: 16px !important;
        }

        .has-comment {
            overflow: hidden;
            flex-wrap: nowrap;

            .has-note {
                margin-left: 0px !important;
                width: 100%;

                .note {
                    font-size: 0.7rem;
                    height: 60px;
                }

                // .note[disabled],
                // .note:focus[disabled] {
                // }
            }

            .has-image {
                position: relative;

                .add-file {
                    position: absolute;

                    input {
                        left: 0 !important;
                    }
                }

                // width: 60px;

                .image {
                    height: 100% !important;
                    width: 100% !important;
                    object-fit: cover !important;
                }
            }

            &:not(.editing) {
                .has-note {
                    width: calc(100% - 68px);
                }

                .has-image {
                    width: auto;
                }
            }
        }

        &[data-type='1'] {
            // CHECK
            .answer {
                .statement {
                    max-width: calc(100% - #{rem(40px)});
                }

                .line {
                    flex-wrap: nowrap;
                    width: 100%;
                }

                .response {
                    // display: table;
                    // gap: 0.625rem;
                }
            }
        }

        &[data-type='2'] {
            // S/N/NS
            .answer {
                .statement {
                    max-width: calc(100% - 35%);
                }

                .response {
                    // width: 35%;
                    // flex-wrap: wrap;
                    @include justify-content(flex-end);
                }
            }
        }

        &[data-type='3'] {
            // YES/NO/NC
            .answer {
                .statement {
                    max-width: calc(100% - 60%);
                }

                .response {
                    width: 60%;
                    flex-wrap: wrap;
                    // @include justify-content(flex-end);
                    justify-content: flex-end !important;
                    gap: 8px;
                }

                .value {
                    margin-left: 2px;
                }
            }
        }

        &[data-type='5'] .item {
            $qImage: rem(40px);
            $qActions: rem(40px);
            $qTotal: $qImage + $qActions;

            // IMAGE
            .statement {
                max-width: calc(100% - #{$qImage} - 25px);

                &.has-image {
                    max-width: calc(100% - #{$qTotal} - 25px);
                }
            }

            .response {
                position: relative;
                width: min-content;

                &.empty-gallery {
                    justify-content: flex-end !important;
                }

                .actions-image {
                    position: absolute;
                    left: right;
                    width: 50px;

                    .add-file {
                        width: 50px;
                        height: 50px;
                        position: absolute;

                        input {
                            left: 0;
                            opacity: 0;
                        }
                    }
                }

                .editing {
                    position: relative;
                    display: initial;
                    width: $qActions;

                    .input-file {
                        top: 0;
                        left: 50px !important;
                    }
                }

                .value {
                }
            }

            .galery {
                .add-image {
                    // margin-top: 30px !important;
                    cursor: pointer;

                    .add-file {
                        width: 50px;
                        height: 50px;

                        .input-file {
                            left: 0 !important;
                            top: 0;

                            &.disabled {
                                pointer-events: none;
                            }
                        }
                    }
                }
            }
        }

        &[data-type='12'] .item {
            // HOUR
            .statement {
                width: calc(100% - #{rem(100px)});
            }

            .response {
                width: rem(100px);

                .value {
                    width: 100%;
                    text-align: center;
                    padding-left: 25px;
                    background-image: img('input_time_cccccc.svg');
                    background-size: 20px;
                    padding-top: 15px;
                }
            }
        }

        &[data-type='15'] .item {
            // TEMPERATURE
            .statement {
                width: calc(100% - #{rem(100px)});
            }

            .response {
                width: rem(100px);

                .value {
                    font-family: $text-light;
                    width: 100%;
                }
            }
        }

        // Datetime
        &[data-type='13'] .answer {
            .line {
                @include display-flex();
                @include flex-direction(row);
                width: 100% !important;
                justify-content: space-between;

                .statement {
                    width: 100%;
                    max-width: calc(100% - 220px);
                }

                .response {
                    width: 220px;

                    .value {
                        @include background($image: img('input_datetime_cccccc.svg'), $size: 28px, $position: left 8px center);
                        // width: 100%;
                        padding: 0 0 0 44px;
                        text-align: left;
                        max-width: 223px;

                        &::-webkit-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::-moz-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &:-ms-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::-ms-input-placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }

                        &::placeholder {
                            color: #ccc;
                            font-weight: lighter;
                        }
                    }
                }
            }
        }

        // DATE
        &[data-type='7'] {
            .answer {
                .line {
                    @include display-flex();
                    @include flex-direction(row);
                    width: 100% !important;
                    justify-content: space-between;

                    .statement {
                        width: 100%;
                        max-width: calc(100% - 180px);
                    }

                    .response {
                        width: 180px;

                        .value {
                            @include background($image: img('input_datetime_cccccc.svg'), $size: 28px, $position: left 8px center);
                            width: 100%;
                            padding: 0 0 0 44px;
                            text-align: left;

                            width: 171px;

                            &::-webkit-input-placeholder {
                                color: #ccc;
                                font-weight: lighter;
                            }

                            &::-moz-placeholder {
                                color: #ccc;
                                font-weight: lighter;
                            }

                            &:-ms-input-placeholder {
                                color: #ccc;
                                font-weight: lighter;
                            }

                            &::-ms-input-placeholder {
                                color: #ccc;
                                font-weight: lighter;
                            }

                            &::placeholder {
                                color: #ccc;
                                font-weight: lighter;
                            }
                        }
                    }
                }
            }
        }

        // SELECT
        &[data-type='11'] .item {
            .flex-column {
                align-items: flex-start;
                gap: 2px;
            }

            .answer {
                .line {
                    @include display-flex();
                    @include flex-direction(column);
                    justify-content: space-between;
                    width: 100%;

                    .flex-column {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 2px;
                    }

                    .statement {
                        // width: calc(100% - #{rem(100px)}) !important;
                        /* .answer-title {
                        width: 130px;
                    } */
                        .description {
                            overflow-wrap: break-word;
                        }
                    }

                    .response {
                        // display: initial;
                        .review-check-container {
                            width: 100%;
                            gap: 4px;

                            .itemIsMultiselect,
                            .simpleSelector {
                                margin-top: 8px;
                            }
                        }

                        .value {
                            @include text-ellipsis();
                            // width: 160px !important;
                        }
                    }

                    .review-check-disabled {
                        margin-top: 6px;
                    }
                }
            }

            &.portrait {
                .answer {
                    .line {
                        .response {
                            width: 100%;

                            .multiSelector {
                                width: 100%;

                                &.portrait {
                                    width: 100%;
                                }
                            }

                            .simpleSelector {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }

        // Email
        &[data-type='16'] .answer {
            .line {
                @include display-flex();
                @include flex-direction(row);
                justify-content: space-between;
                width: 100%;

                // .statement {
                // }

                .response {
                    width: auto;

                    .value {
                        padding: 10px 10px;
                        padding-right: 30px;
                        background-size: 25px;
                    }
                }
            }
        }

        .item.portrait {
            display: flex;
            flex-direction: row;
            align-items: flex-start;

            .answer {
                @include justify-content(flex-end);

                // width: calc(100%) !important;
                .line {
                    padding-right: 0 !important;

                    .statement {
                        .answer-title {
                            @include font-size(s);
                            line-height: 0.875rem !important;
                            padding-right: 5px;
                            font-family: $text-bold;
                            word-break: break-word;

                            &:after {
                                font-family: $text-light;
                                @include font-size(xs);
                            }
                        }

                        .description {
                            @include font-size(xs);
                            font-family: $text-light;
                            line-height: 0.9rem !important;
                            color: #666 !important;
                            margin-top: 5px;

                            li {
                                color: #666 !important;
                                font-family: $text-light !important;
                            }
                        }

                        @include portrait-tablet {
                            .answer-title {
                                // @include font-size(m);
                                font-size: 18px;
                                line-height: 23px !important;
                            }

                            .description {
                                @include font-size(s);
                                line-height: 23px !important;
                            }
                        }
                    }

                    .response {
                        justify-content: flex-end;

                        .unknown {
                            @include font-size(xs);
                            width: max-content;
                        }

                        // .value {
                        // }

                        .responseNoApply {
                            .text {
                                @include font-size(s);
                                // padding: 6px 10px 3px 30px;
                            }
                        }
                    }
                }

                .review,
                .unreview {
                    @include font-size(xs);
                    margin-top: 5px;
                    height: 40px;
                    padding: 0px 5px;
                    min-height: unset;
                    width: auto;
                }

                &.toReview {
                    .line {
                        width: calc(100%);
                    }
                }
            }

            .btn.action.noApply {
                background-image: img('noApply-portrait.svg');
                background-size: 30px;
            }

            .btn.action.toggleMeta {
                width: 24px;
            }

            .meta {
                // min-height: auto !important;

                .info {
                    width: 100% !important;
                    min-height: unset;

                    .sign,
                    .review {
                        @include font-size(xs);
                        widows: 100% !important;

                        .name,
                        .bold,
                        .datetime {
                            @include font-size(xs);
                        }
                    }

                    .timing,
                    .role {
                        .line {
                            .name {
                                @include font-size(xs);
                            }

                            .roles {
                                @include font-size(xs);
                            }
                        }
                    }
                }
                .actions--with-qr {
                    width: unset;
                    max-width: 100%;
                    justify-content: flex-end;
                    flex-direction: row-reverse;
                    flex-wrap: wrap;
                    gap: 8px;

                    .actions__secondary {
                        display: contents;
                    }

                    button.btn.action:not(.qr-icon-btn) {
                        @include font-size(0px);
                        background-color: $default-bg-color;
                        line-height: 16px;
                        background-size: 25px;
                        background-position: center center;
                        height: 45px;
                        width: 45px;
                        margin-left: 15px;
                        // margin-top: 5px;

                        &:last-child {
                            margin-left: 0;
                        }
                    }

                    button.btn.action.qr-icon-btn {
                        background-color: transparent !important;
                        background-image: none !important;
                        box-shadow: none !important;
                        position: relative;
                        width: auto !important;
                        min-width: rem(48px);
                        height: 45px !important;
                        margin-left: 15px;
                        padding: 25px 10px 8px !important;
                        line-height: 1.1;
                        text-align: center;
                        float: none;

                        .qr-icon-btn__icon {
                            position: absolute;
                            top: 6px;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 22px;
                            height: 22px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            pointer-events: none;
                        }

                        .qr-icon-btn__icon i {
                            font-size: 22px;
                            width: 22px;
                            height: 22px;
                            color: #aaa;
                        }

                        .qr-icon-btn__label {
                            @include font-size(s);
                            font-family: $conden;
                            color: #222;
                            line-height: 1.1;
                            display: block;
                            width: 100%;
                        }

                        &:hover .qr-icon-btn__label,
                        &:focus-visible .qr-icon-btn__label {
                            color: $main;
                        }

                        &:hover .qr-icon-btn__icon i,
                        &:focus-visible .qr-icon-btn__icon i {
                            color: $main;
                        }
                    }
                }

                .meta > .actions:not(.actions--with-qr) {
                    width: unset;

                    button.btn.action {
                        @include font-size(0px);
                        background-color: $default-bg-color;
                        line-height: 16px;
                        background-size: 25px;
                        background-position: center center;
                        height: 45px;
                        width: 45px;
                        margin-left: 15px;

                        &:last-child {
                            margin-left: 0;
                        }
                    }
                }

                .sync {
                    @include font-size(xs);
                }
            }

            .load-last-value {
                margin: 10px;
                width: 100%;
                cursor: pointer;
                display: flex;
                padding: 8px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                border-radius: 4px;
                border: 1px solid $neutro-dark;
                background: $neutro;

                span {
                    white-space: nowrap;
                    font-size: 16px;
                }
            }

            .load-last-value.margin {
                margin-right: 10px;
            }
        }

        .custom-alert-task {
            padding-left: 6px;

            .andy {
                left: 0px;
            }
        }

        &[noApply='1'] .answer {
            .line {
                width: 100%;
            }

            .statement {
                width: calc(100% - 150px);
                max-width: calc(100% - 150px);
            }

            .response {
                height: 100%;
                width: 150px;
            }
        }

        & > .item-alert {
            width: 100%;
            padding-left: 16px !important;

            .preview,
            .read-more {
                font-size: 16px;
            }
        }

        & > .reference-link {
            width: 100%;
            padding-left: 16px !important;

            .message {
                display: flex;
                align-items: center;
                padding: 0 0 0 16px !important;

                .preview {
                    width: auto;
                    font-size: 16px;
                }

                .read-more {
                    color: #475b96;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    margin-left: auto;

                    .i-andy-right-arrow {
                        padding: 0 8px;
                    }

                    text-align: left;
                }
            }
        }

        &.child {
            padding-left: 16px !important;
        }

        &.subsubitem {
            padding-left: 32px !important;
        }

        &.child {
            padding-left: 16px !important;
        }

        &.subsubitem {
            padding-left: 32px !important;
        }
    }
}
</style>
